import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Button,
  Card,
  Modal,
  OverlayTrigger,
  ProgressBar,
  Spinner,
  Table,
  Tooltip as BootTooltip,
} from "react-bootstrap";
import DOMPurify from "dompurify";

import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL, Assets_URL } from "../../Apicongfig";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import {
  MdKeyboardArrowDown,
  MdOutlineSummarize,
  MdStars,
} from "react-icons/md";
import ReportStepCard from "./ReportStepCard";
import DecisionCard from "./DecisionCard";
import ParticipantCard from "./CurrentMeeting/components/ParticipantCard";
import HostCard from "./CurrentMeeting/components/HostCard";
import { useHeaderTitle } from "../../../context/HeaderTitleContext";
import moment from "moment";
import { IoArrowBackSharp } from "react-icons/io5";
import {
  FaArrowRight,
  FaCheckCircle,
  FaList,
  FaQuestionCircle,
  FaTimesCircle,
} from "react-icons/fa";
import ParticipantCardProfile from "../Profile/ParticipantCardProfile";
import SignUp from "../AuthModal/SignUp";
import ForgotPassword from "../AuthModal/ForgotPassword";
import { useSidebarContext } from "../../../context/SidebarContext";
import { Accordion } from "react-bootstrap";
import { FaFlag } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { FaPhoneAlt } from "react-icons/fa";
import { BsPersonWorkspace } from "react-icons/bs";
import {
  formatMissionDate,
  markTodoMeeting,
  typeIcons,
} from "../../Utils/MeetingFunctions";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Tooltip as AntdTooltip, Avatar } from "antd";
import { FaChartGantt, FaRegCalendarDays } from "react-icons/fa6";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import Select from "react-select";
import {
  calculateTimeDifference,
  calculateTimeDifferenceDestination,
  calculateTimeDifferencePrepareData,
  convertCount2ToSeconds,
  convertTimeTakenToSeconds,
  openGoogleMeet,
} from "../../Utils/MeetingFunctions";
import { useFormContext } from "../../../context/CreateMeetingContext";
import { useSteps } from "../../../context/Step";
import { useDraftMeetings } from "../../../context/DraftMeetingContext";

import ReportStepFile from "./ReportStepFile";

import StepperModal from "../AuthModal/StepperModal";
import CompletedReportStepFile from "./CompletedReportStepFile";
import StepperSignUpModal from "../AuthModal/StepperSignUpModal";
import { CgTranscript } from "react-icons/cg";
import {
  convertDateToUserTimezone,
  convertTo12HourFormat,
  formatDate,
  formatTime,
  localizeVisibilityMessage,
  parseAndFormatDateTime,
  specialMeetingEndTime,
  timezoneSymbols,
  userTimeZone,
} from "./GetMeeting/Helpers/functionHelper";
import ActiveReportStepCard from "./Report/ActiveReportStepCard";
import SubscriberCard from "./CurrentMeeting/components/SubscriberCard";
import InProgress from "./InProgress";
import { runStepTranscription } from "../../../Helpers/useStepTranscription";
import ReportFileMenu from "./ReportFileMenu";
import ViewFilePreview from "./ViewFilePreview";
import { useMeetings } from "../../../context/MeetingsContext";
import Roadmap from "../Invities/DestinationToMeeting/Roadmap";
import ReactCalendar from "../Invities/DestinationToMeeting/ReactCalendar";
import MeetingDiscussion from "./CurrentMeeting/components/MeetingDiscussion";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
const localizer = momentLocalizer(moment);
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
const Report = () => {
  const location = useLocation();
  const navigate = useNavigate();
  let fromMeeting = false;
  if (location?.state?.from === "meeting") {
    fromMeeting = true;
  }
  const {
    destinationId,
    setDestinationId,
    destinationUniqueId,
    setDestinationUniqueId,
  } = useFormContext();
  const getTimezoneSymbol = (timezone) => timezoneSymbols[timezone] || timezone;
  const { setCallApi, setFromTektime, fromTektime } = useMeetings();
  const [showProgressBar1, setShowProgressBar1] = useState(false);
  const [progress1, setProgress1] = useState(false);
  const { id } = useParams();
  const [t, i18n] = useTranslation("global");
  const { unqiue_id, meeting_id: meetId } = useParams();
  const [meeting, setMeeting] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [startTime1, setStartTime1] = useState(null);
  const [time, setTime] = useState(null);

  const [objective, setObjective] = useState(null);
  const [userId, setUserID] = useState(null);
  const [checkStatus, setCheckStatus] = useState(null);
  const { setHeaderTitle } = useHeaderTitle();
  const pageId = `${userId}/${meetId}/${objective}`;
  const [pageViews, setPageViews] = useState(0);
  const [meetingData, setMeetingData] = useState();
  const [meetingFile, setMeetingFile] = useState(null);
  const [isModalOpen1, setIsModalOpen1] = useState(false);

  //For Destination Home Page START-------------------------------------------------------------------------------
  const [uniqueId, setUniqueId] = useState(false);
  const [destinationDate, setdestinationData] = useState({});
  const [isCalling, setIsCalling] = useState(false);

  const [isUploading,setIsUploading] = useState(false)
  const [fileClicked, setFileClicked] = useState(false); // state for file button

  const [roadmapData, setRoadmapData] = useState(null);
  const [milestones, setMilestones] = useState(null);
  const [roadmapMeetings, setRoadmapMeetings] = useState(null);
  const [timeWindowOffset, setTimeWindowOffset] = useState(0);

  // Memoize the date calculation
  // Memoize the date calculation

  const {
    meetingStartDate,
    meetingEndDate,
    formattedStartDate,
    formattedMeetingEndDate,
  } = useMemo(() => {
    const baseDate = new Date();
    baseDate.setMonth(baseDate.getMonth() + timeWindowOffset);
    baseDate.setDate(1); // Always start from first of month
    baseDate.setHours(0, 0, 0, 0);

    const start = new Date(baseDate);
    start.setDate(start.getDate() - start.getDay()); // Align to previous Sunday

    // Get the end of the 4th week (Saturday)
    const end = new Date(start);
    end.setDate(start.getDate() + 27); // 4 weeks (28 days) - 1 day = 27 days

    const format = (date) =>
      `${String(date.getDate()).padStart(2, "0")}-${String(
        date.getMonth() + 1
      ).padStart(2, "0")}-${date.getFullYear()}`;

    return {
      meetingStartDate: start,
      meetingEndDate: end,
      formattedStartDate: format(start),
      formattedMeetingEndDate: format(end),
    };
  }, [timeWindowOffset]);
  const updateCallApi = (value) => {
    setCallApi(value);
    sessionStorage.setItem("callApi", value);
  };
  const convertTo12HourFormatPrepareData = (time, steps) => {
    if (!time || !steps) {
      return;
    }
    // Check if any step has time unit in seconds
    const hasSeconds = steps?.some((step) => step.time_unit === "seconds");
    // Extract hours and minutes from the time string
    // let [hour, minute] = time?.split(":").map(Number);

    return time;
  };

  const [meetingMessages, setMeetingMessages] = useState([]);
  useEffect(() => {
    const getMeetingMessages = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/meeting-messages?meeting_id=${meetId}`,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        );
        if (response?.status === 200) {
          const data = response?.data?.data;
          const sortedMessages = [...(data || [])].sort(
            (a, b) => new Date(a.created_at) - new Date(b.created_at)
          );
          setMeetingMessages(sortedMessages);
        }
      } catch (error) {
        console.log("error", error);
      }
    };
    getMeetingMessages();
  }, [meetId]);

  // This is the GET API function you want to call after upload succeeds
  const fetchNotesData = async () => {
    try {
      const token =
        sessionStorage.getItem("token") || localStorage.getItem("token");
      const response = await axios.get(
        `${API_BASE_URL}/get-upmeet-report/${meetId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return response.data; // Return full response (check for response.data.data later)
    } catch (error) {
      console.error("Error fetching notes:", error);
      throw error;
    }
  };



// 3. Use this useEffect
useEffect(() => {
  const handleBeforeUnload = (e) => {
    if (isUploading) {
      // Modern browsers require both of these
      e.preventDefault();
      e.returnValue = ''; // Chrome requires this to be set (even if blank)
      return '';
    }
  };

  window.addEventListener('beforeunload', handleBeforeUnload);
  return () => window.removeEventListener('beforeunload', handleBeforeUnload);
}, [isUploading]); // Add dependency here
  const [progress2, setProgress2] = useState(0);
  const [meetingSummaryLoading, setMeetingSummaryLoading] = useState(false);


  const handleAudioUploadSuccess = async () => {
    // if (shouldGenerateSummary()) {
      // Your condition check
      setMeetingSummaryLoading(true);
      setProgress2(10); // Initial progress

      // Smooth progress animation
      const progressInterval = setInterval(() => {
        setProgress2((prev) => Math.min(prev + (100 - prev) * 0.05, 90)); // Slow down near completion
      }, 500);

      // Start polling
      const poll = async () => {
        try {
          const response = await fetchNotesData();

          if (response?.data?.upmeet_summary) {
            clearInterval(progressInterval);
            setProgress2(100);
            setTimeout(() => {
              setMeetingSummary(response.data?.upmeet_summary?.text);
              setMeetingSummaryLoading(false);
            }, 500); // Let progress complete
            return true;
          }
          return false;
        } catch (error) {
          console.error("Polling error:", error);
          return false;
        }
      };

      // Recursive polling with exponential backoff
      const startPolling = async (attempt = 0) => {
        const success = await poll();
        if (!success && attempt < 60) {
          // Max ~5 minutes
          setTimeout(
            () => startPolling(attempt + 1),
            Math.min(1000 * Math.pow(1.5, attempt), 10000)
          );
        } else if (!success) {
          clearInterval(progressInterval);
          setMeetingSummaryLoading(false);
          // toast.error("Summary generation is taking longer than usual");
        }
      };

      await startPolling();
    // }
  };

  const sanitize = (dirty) => {
    return DOMPurify.sanitize(dirty, {
      ALLOWED_TAGS: [
        "p",
        "strong",
        "em",
        "u",
        "ol",
        "ul",
        "li",
        "br",
        "h1",
        "h2",
        "h3",
        "h4",
      ],
      ALLOWED_ATTR: ["style", "class", "id"],
    });
  };

  const getParticipantsByDestinationId = async () => {
    const currentTime = new Date();
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const options = { timeZone: userTimeZone };
    const timeInUserZone = new Date(
      currentTime.toLocaleString("en-US", options)
    );

    const formattedTime = formatTime(timeInUserZone);
    const formattedDate = formatDate(timeInUserZone);
    setIsLoading(true);
    try {
      const response = await axios.get(
        `${API_BASE_URL}/destination-participants/${meetId}?current_time=${formattedTime}&current_date=${formattedDate}`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      if (response.status) {
        const data = response?.data?.data;
        setRoadmapData(data);
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setIsLoading(false);
    }
  };
  const getMilestones = async () => {
    const currentTime = new Date();
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const options = { timeZone: userTimeZone };
    const timeInUserZone = new Date(
      currentTime.toLocaleString("en-US", options)
    );

    const formattedTime = formatTime(timeInUserZone);
    const formattedDate = formatDate(timeInUserZone);
    setIsLoading(true);
    try {
      const response = await axios.get(
        `${API_BASE_URL}/get-destination-meeting-step-decisions/${meetId}?current_time=${formattedTime}&current_date=${formattedDate}`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      if (response.status) {
        const data = response?.data?.data;
        setMilestones(data);
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setIsLoading(false);
    }
  };
  const getSpecialMeeting = async () => {
    setIsModalOpen(false);
    setIsModalOpen1(false);
    const currentTime = new Date();
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const options = { timeZone: userTimeZone };
    const timeInUserZone = new Date(
      currentTime.toLocaleString("en-US", options)
    );

    const formattedTime = formatTime(timeInUserZone);
    const formattedDate = formatDate(timeInUserZone);
    setIsLoading(true);
    try {
      const response = await axios.get(
        // `${API_BASE_URL}/get-destination-with-meeting/${meetId}?current_time=${formattedTime}&current_date=${formattedDate}`,
        `${API_BASE_URL}/get-destination-meetings/${meetId}?current_time=${formattedTime}&current_date=${formattedDate}&timezone=${userTimeZone}`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      const data = response?.data?.data;
      // `${API_BASE_URL}/get-destination-meetings/${meetId}?current_time=${formattedTime}&current_date=${formattedDate}`,

      setIsLoading(false);
      setdestinationData(response?.data?.data);
      setDestinationId(response?.data?.data?.id);
      setIsModalOpen(false);

      // Create the proper data structure for Roadmap
      const roadmapData = [
        {
          ...data.clients, // Spread all client properties
          meetings: data.meetings, // Add meetings array
          client_logo: data.clients.client_logo,
          client_need: data.clients.client_need,
        },
      ];
      setRoadmapMeetings(data?.meetings);
      // setRoadmapData(roadmapData);

      const uuid = response?.data?.data?.uuid
        ? `${response.data.data.uuid}--es`
        : null;
      if (uuid) {
        setDestinationUniqueId(uuid);
      } else {
        console.warn("UUID is missing in the response:", response);
      }
    } catch (error) {
      setIsModalOpen(false);
    } finally {
      setIsLoading(false);
    }
  };

  const [loading, setLoading] = useState(false);

  function getAllDecisionsFromMeetings(meetings) {
    const allDecisions = [];

    // Assuming you have userTimeZone and currentTime defined as before
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const currentDateTime = new Date().toLocaleString("en-US", {
      timeZone: userTimeZone,
    });
    const currentTime = currentDateTime.split(", ")[1]; // Extract the time part
    const currentDate = currentDateTime.split(", ")[0]; // Extract the time part
    meetings?.forEach((meeting) => {
      meeting?.steps?.forEach((step) => {
        if (step?.decision) {
          allDecisions.push({
            meeting_id: meeting.id,
            step_id: step.id,
            decision_type: step.decision.decision_type,
            decision: step.decision.decision,
            decision_apply: step.decision.decision_apply,
            milestone_date:
              step.decision.decision_type === "Milestone"
                ? step.decision?.milestone_date
                : step.decision?.creation_date,
            creation_time: step?.decision?.creation_time || currentTime,
          });
        }
      });
    });

    return allDecisions;
  }

  const decisions = getAllDecisionsFromMeetings(destinationDate?.meetings);
  const sortedMilestones = decisions.sort(
    (a, b) => new Date(a.milestone_date) - new Date(b.milestone_date)
  );
  function calculateTotalTime(steps) {
    let totalSeconds = 0;
    steps?.forEach((step) => {
      switch (step.time_unit) {
        case "days":
          totalSeconds += step.count2 * 86400;
          break;
        case "hours":
          totalSeconds += step.count2 * 3600;
          break;
        case "minutes":
          totalSeconds += step.count2 * 60;
          break;
        case "seconds":
          totalSeconds += step.count2;
          break;
      }
    });

    const days = Math.floor(totalSeconds / 86400);
    const hrs = Math.floor(totalSeconds / 3600);
    const mins = Math.floor((totalSeconds % 3600) / 60);
    const secs = totalSeconds % 60;

    let result = "";
    // Display logic based on the available time units
    if (days > 0) {
      result += `${days} ${t("time_unit.days")}`;
    } else if (hrs > 0) {
      result += `${hrs} ${t("time_unit.hours")}`;
    } else if (mins > 0) {
      result += `${mins} ${t("time_unit.minutes")}`;
    } else if (secs > 0) {
      result += `${secs} ${t("time_unit.seconds")}`;
    }

    return result.trim();
  }
  const calculateTotalTimeTaken = (steps) => {
    if (!steps) return;
    // Helper function to convert time string to seconds
    const convertToSeconds = (timeString) => {
      if (!timeString) return 0;
      let totalSeconds = 0;

      // Split by '-' and iterate through parts
      const timeParts = timeString?.split(" - ").map((part) => part.trim());
      timeParts?.forEach((part) => {
        const [value, unit] = part?.split(" ");

        if (unit?.startsWith("sec")) {
          totalSeconds += parseInt(value, 10);
        } else if (unit?.startsWith("min")) {
          totalSeconds += parseInt(value, 10) * 60;
        } else if (unit?.startsWith("hour") || unit?.startsWith("hr")) {
          totalSeconds += parseInt(value, 10) * 3600;
        } else if (unit?.startsWith("day")) {
          totalSeconds += parseInt(value, 10) * 86400;
        }
      });

      return totalSeconds;
    };

    // Calculate total time in seconds
    let totalSeconds = steps?.reduce((acc, step) => {
      return acc + convertToSeconds(step?.time_taken);
    }, 0);

    // Convert total seconds to days, hours, minutes, and seconds
    const days = Math.floor(totalSeconds / 86400);
    totalSeconds %= 86400;
    const hours = Math.floor(totalSeconds / 3600);
    totalSeconds %= 3600;
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    // Determine the most significant units to display
    let timeDisplay = "";
    if (days > 0) {
      timeDisplay =
        hours > 0
          ? // ? `${days} ${t("time_unit.days")} - ${hours} ${t("time_unit.hours")} `
            `${days} ${t("time_unit.days")} `
          : `${days} ${t("time_unit.days")} `;
    } else if (hours > 0) {
      timeDisplay =
        minutes > 0
          ? `${hours} ${t("time_unit.hours")} `
          : `${hours} ${t("time_unit.hours")}`;
    } else if (minutes > 0) {
      timeDisplay =
        seconds > 0
          ? `${minutes} ${t("time_unit.minutes")}`
          : `${minutes} ${t("time_unit.minutes")}`;
    } else {
      timeDisplay = `${seconds} ${t("time_unit.seconds")}`;
    }

    return timeDisplay;
  };

  const startDate1 = new Date(
    formatMissionDate(destinationDate?.meeting_start_date)
      ?.split("/")
      ?.reverse()
      ?.join("/")
  ); // Convert to MM/DD/YYYY
  const endDate1 = new Date(
    formatMissionDate(destinationDate?.meeting_end_date)
      ?.split("/")
      ?.reverse()
      ?.join("/")
  ); // Convert to MM/DD/YYYY

  // Calculate the difference in milliseconds
  const differenceInMillis = endDate1 - startDate1;

  // Convert milliseconds to days
  const totalDays2 = Math.floor(differenceInMillis / (1000 * 60 * 60 * 24));
  // Format the result
  let result;
  if (totalDays2 > 0) {
    result = `${totalDays2} ${
      totalDays2 > 1 ? t("time_unit.days") : t("time_unit.day")
    }`;
  } else {
    // result = t("time_unit.no_days"); // Handle cases where the end date is before the start date
    result = `1 ${t("time_unit.day")}`;
  }

  // Output the result
  const events = (destinationDate?.meetings || [])
    ?.filter((meeting) => meeting?.status !== "abort")
    ?.map((meeting) => {
      const userTimezoneOffset = new Date().getTimezoneOffset() * 60000;
      const meetingDateTime = new Date(
        new Date(meeting.date).getTime() - userTimezoneOffset
      );
      const currentDateTime = new Date();

      const color = meetingDateTime < currentDateTime ? "#ff4d4d" : "#4C49E3";

      let totalCompletedTime = 0;
      let totalAllTime = 0;
      let totalCount2 = 0;
      let timeUnit = "";

      const convertToSeconds = (timeString) => {
        if (!timeString) return 0;
        let totalSeconds = 0;

        const timeParts = timeString.split(" - ").map((part) => part.trim());
        timeParts.forEach((part) => {
          const [value, unit] = part.split(" ");

          if (unit?.includes("sec")) {
            totalSeconds += parseInt(value, 10);
          } else if (unit?.includes("min")) {
            totalSeconds += parseInt(value, 10) * 60;
          } else if (unit?.includes("hour") || unit?.includes("hr")) {
            totalSeconds += parseInt(value, 10) * 3600;
          } else if (unit?.includes("day")) {
            totalSeconds += parseInt(value, 10) * 86400;
          }
        });

        return totalSeconds;
      };

      const getStepColor = (step) => {
        const stepTimeInSeconds = convertToSeconds(step?.time_taken);
        const count2InSeconds = convertToSeconds(
          `${step?.count2} ${step?.time_unit || ""}`
        );
        return stepTimeInSeconds > count2InSeconds ? "#F12D2B" : "#FFDB01";
      };

      meeting?.steps?.forEach((step) => {
        const stepTimeInSeconds = convertToSeconds(step?.time_taken);
        totalAllTime += stepTimeInSeconds;

        if (meeting?.status === "in_progress") {
          totalCount2 += step?.count2 ?? 0;
        }

        if (step?.step_status === "completed") {
          totalCompletedTime += stepTimeInSeconds;
        }

        if (step?.time_unit === "seconds") {
          totalCount2 += step?.count2 || 0;
        } else if (step?.time_unit === "minutes") {
          totalCount2 += step?.count2 || 0;
        } else if (step?.time_unit === "hours") {
          totalCount2 += step?.count2 || 0;
        }

        timeUnit = step?.time_unit || timeUnit;
      });

      let percentage = 0;
      if (meeting?.status === "closed") {
        percentage =
          totalAllTime > 0 ? (totalCompletedTime / totalAllTime) * 100 : 0;
      }

      if (meeting?.status === "in_progress") {
        const totalSteps = meeting?.steps?.length || 1;
        const completedSteps = meeting?.steps?.filter(
          (step) => step?.step_status === "completed"
        ).length;
        percentage =
          totalSteps > 0
            ? ((completedSteps + totalCompletedTime / totalAllTime) /
                totalSteps) *
              100
            : 0;
      }

      let start;
      // Ensure valid start time for meetings
      if (meeting?.status === "in_progress" && meeting?.starts_at) {
        const formattedStartTime = convertTo12HourFormatPrepareData(
          meeting?.starts_at,
          meeting?.steps
        );
        const startDateStringInProgress = `${meeting?.date}T${formattedStartTime}`;
        start = new Date(startDateStringInProgress);
      } else {
        const startDateString = `${meeting?.date}T${
          meeting?.start_time || "00:00:00"
        }`; // Add a fallback for undefined start_time
        start = new Date(startDateString);
      }

      const estimateTime = meeting?.estimate_time || new Date().toISOString();
      const end = new Date(estimateTime.split(".")[0]);
      return {
        title: meeting?.title,
        start: start,
        end: end,
        color:
          meeting?.status === "closed"
            ? "#0A8634"
            : meeting?.status === "in_progress"
            ? meeting?.steps?.some((step) => getStepColor(step) === "#F12D2B")
              ? "#F12D2B"
              : "#FFDB01"
            : meeting?.status === "active"
            ? color
            : "#4C49E3",
        // progress: percentage.toFixed(2),
        progress: Math.floor(percentage),
        status: meeting?.status,
        url: `/destination/${meeting?.unique_id}/${meeting?.id}`,
        allDay: true,
        totalCount2,
        timeUnit,
      };
    });

  const decisionEvents = sortedMilestones?.map((decision, index) => ({
    start: new Date(decision.milestone_date),
    end: new Date(decision.milestone_date),
    title: `Milestone ${index + 1}: ${decision.decision}`,
    color: "#000000",
    status: "decision",
  }));

  const allEvents = [...events, ...decisionEvents];

  const minDate = new Date(Math.min(...allEvents.map((event) => event.start)));
  const maxDate = new Date(Math.max(...allEvents.map((event) => event.end)));
  const dateDiff = maxDate - minDate; // Difference in milliseconds
  const oneDay = 24 * 60 * 60 * 1000; // One day in milliseconds
  const oneWeek = 7 * oneDay; // One week in milliseconds
  const oneYear = 365 * oneDay; // Approximate year in milliseconds

  // Determine the appropriate view based on date difference
  let defaultView;
  let views;

  if (dateDiff < oneDay) {
    defaultView = "day"; // Show day view if less than a day (hour view)
    views = {
      day: true, // Only show the agenda view
    };
  } else if (dateDiff < oneWeek) {
    defaultView = "week"; // Show week view if less than a week
    views = {
      day: false, // Only show the day view
      week: true, // Show the week view
      month: false, // Show the week view
    };
  } else if (dateDiff < oneYear) {
    defaultView = "month"; // Default to month view for less than a year
    views = {
      day: false,
      week: false,
      month: true,
    };
  } else {
    defaultView = "agenda"; // Show agenda view if a year or more
    views = {
      day: false,
      week: false,
      month: false,
      agenda: true, // Only show agenda view
    };
  }

  //For Destination Home Page END-------------------------------------------------------------------------------

  useEffect(() => {
    const incrementPageView = async () => {
      // setIsLoading(true)
      try {
        const response = await axios.get(
          `${API_BASE_URL}/page-views/${pageId}`
        );
        if (response.status === 200) {
          setPageViews(response?.data?.data?.views);
          // setIsLoading(false);
        }
      } catch (error) {
        console.error("Error incrementing page view:", error);
      }
    };
    incrementPageView();
  }, [pageId]);
  const [estimateTime, setEstimateTime] = useState(null);
  const [estimateDate, setEstimateDate] = useState(null);
  const [selectedMeeting, setSelectedMeeting] = useState(null); // State for the selected meeting
  const [selectedFile, setSelectedFile] = useState(null); // State for the selected meeting
  const [visibilityMessage, setVisibilityMessage] = useState(null);

  const sessionUser = JSON.parse(sessionStorage.getItem("user"));
  useEffect(() => {
    if (!meetingData) return;

    const { estimate_time, type, steps, start_time, timezone } = meetingData;
    if (estimate_time) {
      const { formattedDate: estimateDate, formattedTime: estimateTime } =
        parseAndFormatDateTime(estimate_time, type, timezone);
      setEstimateTime(estimateTime);
      setEstimateDate(estimateDate);
    }

    // Ensure start_time exists before manipulating
    if (start_time) {
      const totalCount2 = steps?.reduce((acc, step) => acc + step.count2, 0);
      const [hours, minutes, seconds] = start_time.split(":").map(Number);

      if (!isNaN(hours) && !isNaN(minutes)) {
        const startDate = new Date();
        startDate.setHours(hours);
        startDate.setMinutes(minutes);
        startDate.setSeconds(seconds || 0); // Handle case where seconds might be missing
        startDate.setMinutes(startDate.getMinutes() + totalCount2);

        const formattedStartTime = startDate.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });

        setStartTime1(formattedStartTime);
      }
    }
  }, [meetingData, id, meetId]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  useEffect(() => {
    if (visibilityMessage) {
      setIsModalOpen(true);
    }
  }, [visibilityMessage, unqiue_id]);

  const dateActive = new Date(meeting?.date);

  const startTimeActive = meeting?.start_time;
  const formattedTimeActive = new Date(
    `1970-01-01T${startTimeActive}`
  ).toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  const desId = destinationId || null;

  const [progress, setProgress] = useState(0);
  const [showProgressBar, setShowProgressBar] = useState(false);
  const [reportData, setReportData] = useState(null);

  const [meetingAudio, setMeetingAudio] = useState(null);
  const [audioLoading, setAudioLoading] = useState(false);
  const [transcriptLoading, setTranscriptLoading] = useState(false);
  const [summaryLoading, setSummaryLoading] = useState(false);
  const [meetingTranscript, setMeetingTranscript] = useState(null);
  const [meetingSummary, setMeetingSummary] = useState(null);
  const [viewNote, setViewNote] = useState("note");

  const getMeetingReport = async () => {
    if (uniqueId) return false;

    const currentTime = new Date();
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const options = { timeZone: userTimeZone };
    const timeInUserZone = new Date(
      currentTime.toLocaleString("en-US", options)
    );

    const formattedTime = formatTime(timeInUserZone);
    const formattedDate = formatDate(timeInUserZone);

    setIsLoading(true);
    setIsModalOpen(false);
    try {
      const response = await axios.get(
        `${API_BASE_URL}/get-meeting-report/${meetId}?current_time=${formattedTime}&current_date=${formattedDate}&destination_id=${desId}&timezone=${userTimeZone}`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      if (response.status === 200) {
        const meeting = response.data.data;
        // if(meeting?.status === "in_progress"){
        //   navigate(`/destiination/${meeting?.unique_id}/${meeting?.id}`)
        //   return
        // }

        setMeetingAudio(meeting?.voice_notes);
        setMeetingFile(meeting);
        setMeetingTranscript(meeting?.meeting_notes_transcript?.transcript);
        setMeetingSummary(meeting?.meeting_notes_summary);
        if (response?.data?.data?.meeting_notes) {
          setReportData(response?.data?.data?.meeting_notes);
          setReportProgress(false);
          setIsCalling(true);
        }

        setObjective(meeting?.objective);
        setUserID(meeting?.user?.id);
        const steps = meeting?.steps || [];
        const startTime = meeting?.start_time;
        const { formattedDate: estimateDate, formattedTime: estimateTime } =
          parseAndFormatDateTime(
            meeting?.estimate_time,
            meeting?.type,
            meeting?.timezone
          );
        setEstimateTime(estimateTime);
        setEstimateDate(estimateDate);
        // const estimateTime = meeting?.estimate_time?.split("T")[1] || "";

        setMeeting(meeting);
        setHeaderTitle({ titleText: " " });
        setTime(startTime);
        // setEstimateDate(meeting?.estimate_time.split("T")[0]);
        // setEstimateTime(estimateTime);

        const totalMinutes = steps.reduce((acc, step) => acc + step.count2, 0);
        const [hours, minutes] = startTime.split(":").map(Number);

        const startDate = new Date();
        startDate.setHours(hours, minutes + totalMinutes);
        setStartTime1(
          startDate.toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          })
        );

        setSelectedMeeting({ value: meeting?.id, label: meeting?.title });
        setMeetingData(meeting);

        setIsLoading(false);

        // Check if all notes are summarized
        // const areNotesSummarized = steps.every(
        //   (step) => step.note?.trim() === step.original_note?.trim()
        // );
        const allEqual = steps.every(
          (step) => step.note?.trim() === step.original_note?.trim()
        );

        const someEqual = steps.some(
          (step) => step.note?.trim() === step.original_note?.trim()
        );

        const areNotesSummarized = allEqual || someEqual; // true if all or some equal, false if none

        const areStepNotesSummarized = steps
          ? steps.every((step) => step.note === null) || // All notes are null
            (steps.some((step) => step.note === null) &&
              steps.some((step) => step.note !== null)) // One note is null and one is not
          : undefined; // Handle the case when `steps` is null or undefined

        // if (
        //   (meeting?.status === "closed" &&
        //     meeting?.prise_de_notes === "Automatic" &&
        //     areNotesSummarized) ||
        //   (meeting?.type === "Special" && areStepNotesSummarized)
        // ) {
        //   setShowProgressBar(true);
        //   await handleSecondApiCall(meeting.id); // Pass any required data
        // }
        if (
          (meeting?.status === "closed" &&
            meeting?.prise_de_notes === "Automatic" &&
            meeting?.summary_status === 0) ||
          (meeting?.type === "Special" && areStepNotesSummarized)
        ) {
          // setShowProgressBar(true);
          // await handleSecondApiCall(meeting.id); // Pass any required data
        }
        return { status: response.status, meeting };
      }
    } catch (error) {
      const status = error?.response?.status || 500;
      const message = error?.response?.data?.message || "An error occurred.";
      setVisibilityMessage(status === 403 ? message : message);
      setIsModalOpen(true);

      // return { status, message };
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const reportResponse = await getMeetingReport();

        if (reportResponse?.status === 200 && reportResponse?.meeting) {
          const { meeting } = reportResponse;

          if (meeting.status === "closed") {
            getMeetingByID(meeting.objective, meeting.user.id);
          } else if (
            ["active", "in_progress", "to_finish", "todo"].includes(
              meeting.status
            )
          ) {
            getActiveMeetingByID(meeting.objective, meeting.user.id);
          }
        } else if (reportResponse?.message || reportResponse?.status === 403) {
          console.error(
            "Visibility message or Forbidden status found:",
            reportResponse?.message
          );
          // setVisibilityMessage(reportResponse?.message || "Access Denied");
          // setIsModalOpen(true);
        }
      } catch (error) {
        console.error("Error in useEffect:", error);
      }
    };

    if (unqiue_id?.endsWith("--es")) {
      setUniqueId(true);
      getSpecialMeeting();
      getMilestones();
      getParticipantsByDestinationId();
    } else {
      fetchData();
    }
  }, [unqiue_id]);

  const [allMeetings, setAllMeetings] = useState([]);

  const [allFiles, setAllFiles] = useState([]);
  const [allMedia, setAllMedia] = useState([]);
  const [isFileModalOpen, setIsFileModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const openModal = (file) => {
    setModalContent(file);
    setIsFileModalOpen(true);
  };
  const closeModal = () => {
    setIsFileModalOpen(false);
    setModalContent(null);
  };
 const getAllFiles = async () => {
  // Validate required data
  const destinationId = uniqueId ? meetId : meetingData?.destination_id;
  if (!destinationId) {
    console.warn("No destination ID available");
    return;
  }

  try {
    const response = await axios.get(
      `${API_BASE_URL}/get-public-destination-files/${destinationId}`
    );

    if (response?.status === 200) {
      const files = response?.data?.data || []; // Fallback to empty array

      // Files that are NOT media (i.e., treat as documents)
      const documentFiles = files.filter((file) => {
        const type = file?.file_type?.toLowerCase() || "";
        return !(
          type.startsWith("audio/") ||
          type.startsWith("video/") ||
          type.startsWith("image/")
        );
      });

      // Files that ARE media
      const mediaFiles = files.filter((file) => {
        const type = file?.file_type?.toLowerCase() || "";
        return (
          type.startsWith("audio/") ||
          type.startsWith("video/") ||
          type.startsWith("image/")
        );
      });

      setAllFiles(documentFiles);
      setAllMedia(mediaFiles);
    }
  } catch (error) {
    console.error("Error fetching files:", error);
    // Consider setting error state here for UI feedback
  }
};

useEffect(() => {
  // Only run if we have either meetId or destination_id
  if (meetId || meetingData?.destination_id) {
    getAllFiles();
  }
}, [uniqueId, meetingData, destinationDate, meetId]); // Added meetId to dependencies
  const getMeetingByID = async (objective, userId) => {
    if (uniqueId) {
      return false;
    }

    try {
      const currentTime = new Date();
      const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      const options = { timeZone: userTimeZone };
      const timeInUserZone = new Date(
        currentTime.toLocaleString("en-US", options)
      );

      const formattedTime = formatTime(timeInUserZone);
      const formattedDate = formatDate(timeInUserZone);
      const token = sessionStorage.getItem("token");
      const REQUEST_URL = `${API_BASE_URL}/get-public-meetings/${userId}/${objective}?destination_id=${desId}&current_time=${formattedTime}&current_date=${formattedDate}&timezone=${userTimeZone}`;

      const response = await axios.get(REQUEST_URL, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status) {
        const meetings = response.data?.data;
        //    // Filter out duplicate meetings by ID
        // const uniqueMeetings = meetings.reduce((acc, current) => {
        //   const x = acc.find(item => item.id === current.id);
        //   if (!x) {
        //     return acc.concat([current]);
        //   } else {
        //     return acc;
        //   }
        // }, []);

        setAllMeetings(meetings);
      } else {
        toast.error("Échec de la récupération du rapport");
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const getActiveMeetingByID = async (objective, userId) => {
    if (uniqueId) {
      return false;
    }

    try {
      const currentTime = new Date();
      const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      const options = { timeZone: userTimeZone };
      const timeInUserZone = new Date(
        currentTime.toLocaleString("en-US", options)
      );

      const formattedTime = formatTime(timeInUserZone);
      const formattedDate = formatDate(timeInUserZone);
      const token = sessionStorage.getItem("token");
      const REQUEST_URL = `${API_BASE_URL}/get-public-active-meetings/${userId}/${objective}?destination_id=${desId}&current_time=${formattedTime}&current_date=${formattedDate}&timezone=${userTimeZone}`;

      const response = await axios.get(REQUEST_URL, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status) {
        const meetings = response.data?.data;

        //  // Filter out duplicate meetings by ID
        //     const uniqueMeetings = meetings.reduce((acc, current) => {
        //       const x = acc.find(item => item.id === current.id);
        //       if (!x) {
        //         return acc.concat([current]);
        //       } else {
        //         return acc;
        //       }
        //     }, []);

        setAllMeetings(meetings);
      } else {
        toast.error("Échec de la récupération du rapport");
      }
    } catch (error) {
    } finally {
    }
  };

  const handleViewToggle = (view) => {
    setViewNote(view);
  };

  // useEffect(() => {
  //   let pollingInterval;

  //   const getMeeting = async () => {
  //     setAudioLoading(true);
  //     try {
  //       const response = await axios.get(
  //         `${API_BASE_URL}/get-meeting/${meetId}`
  //       );
  //       if (response.status) {
  //         const data = response.data?.data;
  //         // Check if voice_notes is available
  //         if (data?.voice_notes) {
  //           const cleanUrl = data?.voice_notes;
  //           setMeetingAudio(cleanUrl);
  //           setMeetingSummary(data?.meeting_notes_summary);
  //           setMeetingTranscript(data?.meeting_notes_transcript?.transcript);
  //           clearInterval(pollingInterval); // Stop polling if voice_notes is available
  //           setAudioLoading(false);
  //         }
  //       }
  //     } catch (error) {
  //       console.log("error while fetching meeting data", error);
  //     }
  //   };

  //   // Only start polling if prise_de_notes is "Automatic" AND meeting is in progress
  //   if (
  //     meetingData?.prise_de_notes === "Automatic" &&
  //     meetingData?.status === "closed"
  //   ) {
  //     pollingInterval = setInterval(getMeeting, 5000); // Poll every 5 seconds

  //     if (!meetingAudio) {
  //       getMeeting(); // Initial fetch
  //     }
  //   }

  //   // Cleanup interval on component unmount or dependency change
  //   return () => clearInterval(pollingInterval);
  // }, [meetId, meetingData?.prise_de_notes, meetingData?.status, meetingAudio]);
  const [callNow, setCallNow] = useState(false);

  useEffect(() => {
    if (callNow && !meetingTranscript) {
      const fetchTranscript = async () => {
        setTranscriptLoading(true);
        try {
          const response = await axios.get(
            `${API_BASE_URL}/transcripte-meeting-notes/${meetId}`
          );

          const transcript =
            response.data?.data?.meeting_notes_transcript?.transcript;

          if (response.status && transcript) {
            setMeetingTranscript(transcript);
            setViewNote("note");
          }
        } catch (error) {
          console.log("error while fetching meeting transcript", error);
          toast.error("Transcription Failed, Please Refresh the Page");
        } finally {
          setTranscriptLoading(false);
        }
      };

      fetchTranscript();
    }
  }, [callNow, meetingTranscript, meetId]);

  const hasTranscribedRef = useRef(false);

  const [transcriptionProgress, setTranscriptionProgress] = useState(0);
  const [isTranscribing, setIsTranscribing] = useState(false);

  const handleTranscriptionAndNext = async () => {
    setIsTranscribing(true);
    setTranscriptionProgress(0);

    const simulateProgress = () => {
      setTranscriptionProgress((prev) => {
        if (prev >= 75) return prev;
        return prev + 1;
      });
    };

    const interval = setInterval(simulateProgress, 100);

    try {
      const currentTime = new Date();
      const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const options = { timeZone: userTimeZone };
      const timeInUserZone = new Date(
        currentTime.toLocaleString("en-US", options)
      );

      const formattedTime = formatTime(timeInUserZone);
      const formattedDate = formatDate(timeInUserZone);

      // STEP 1: Fetch current meeting before transcription (optional but can help)
      const initialResponse = await axios.get(
        `${API_BASE_URL}/get-meeting/${meetId}?current_time=${formattedTime}&current_date=${formattedDate}&timezone=${userTimeZone}`
      );

      const meeting = initialResponse?.data?.data;
      console.log("🧠 Meeting before transcription:", meeting);

      // STEP 2: Run transcription on freshly fetched meeting
      await runStepTranscription(meeting);
      console.log("✅ Transcription finished");

      // STEP 3: Now fetch latest version after transcription is saved
      const refreshedResponse = await axios.get(
        `${API_BASE_URL}/get-meeting/${meetId}?current_time=${formattedTime}&current_date=${formattedDate}&timezone=${userTimeZone}`
      );

      clearInterval(interval); // Stop progress simulation

      if (refreshedResponse?.status === 200) {
        const updatedMeeting = refreshedResponse.data.data;
        setMeetingData(updatedMeeting);
        setTranscriptionProgress(100);
        hasTranscribedRef.current = true;

        setTimeout(() => {
          setIsTranscribing(false);
        }, 500);

        console.log(
          "🎉 Refreshed meeting with updated step notes:",
          updatedMeeting
        );
      }
    } catch (err) {
      console.error("❌ Error during transcription flow:", err);
      clearInterval(interval);
      setIsTranscribing(false);
    }
  };

  useEffect(() => {
    if (meetingTranscript && !meetingData?.meeting_notes_summary) {
      const fetchSummary = async () => {
        console.log("Fetching summary...");
        setSummaryLoading(true);
        try {
          const response = await axios.get(
            `${API_BASE_URL}/summarize-meeting-notes/${meetId}`
          );
          console.log("Summary response:", response);

          if (response.status === 200) {
            setMeetingSummary(response.data?.data?.meeting_notes_summary);
            console.log("Calling handleTranscriptionAndNext");
            await handleTranscriptionAndNext();
          }
        } catch (error) {
          console.log("error while fetching meeting summary", error);
          toast.error("Summarization Failed, Please Refresh the Page");
        } finally {
          setSummaryLoading(false);
        }
      };

      fetchSummary();
    }
  }, [meetingTranscript]);

  const formattedDate = convertDateToUserTimezone(
    meetingData?.date,
    meetingData?.start_time,
    meetingData?.timezone
  );

  const startTime = meetingData?.starts_at || meetingData?.start_time;
  const formattedTime = new Date(`1970-01-01T${startTime}`).toLocaleTimeString(
    "en-US",
    { hour: "2-digit", minute: "2-digit", hour12: true }
  );

  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [selectedTitleOrder, setSelectedTitleOrder] = useState(
    meetingData?.title_order
  );
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setDropdownVisible(!dropdownVisible);
  };

  const applyFilter = async (item) => {
    try {
      setIsLoading(true);
      setFileClicked(false);

      // await getMeeting(item.id); // Fetch meeting data
      setSelectedTitleOrder(item.title_order);
      setDropdownVisible(!dropdownVisible);
      if (item?.status === "in_progress") {
        updateCallApi(true);
        navigate(`/destination/${item?.unique_id}/${item?.id}`);
      } else {
        updateCallApi(false);

        navigate(`/destination/${item.unique_id}/${item.id}`);
      }
      setSelectedMeeting({
        value: item?.id,
        label: item?.title,
      });
    } catch (error) {
      // Handle error
    } finally {
      setIsLoading(false); // Hide loader whether successful or not
    }
  };
  const applyHeaderFilter = async (item) => {
    try {
      setIsLoading(true);
      setFileClicked(false);

      // await getMeeting(item.id); // Fetch meeting data
      setSelectedTitleOrder(item.title_order);
      // setDropdownVisible(!dropdownVisible);
      if (item?.status === "in_progress") {
        updateCallApi(true);

        navigate(`/destination/${item?.unique_id}/${item?.id}`);
      } else {
        updateCallApi(false);

        navigate(`/destination/${item.unique_id}/${item.id}`);
      }
      setSelectedMeeting({
        value: item?.id,
        label: item?.title,
      });
    } catch (error) {
      // Handle error
    } finally {
      setIsLoading(false); // Hide loader whether successful or not
    }
  };
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setDropdownVisible(false);
    }
  };
  useEffect(() => {
    if (dropdownVisible) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownVisible]);

  // const data = meetingData?.plan_d_actions;
  // // Sort data by order
  // const sortedData = data?.sort((a, b) => a.order - b.order);

  // useEffect(() => {
  //   if (!sortedData) {
  //     return;
  //   }

  //   const svgWidth = 1000;
  //   const svgHeight = 500;
  //   const margin = { top: 70, right: 20, bottom: 0, left: 50 };
  //   const width = svgWidth - margin.left - margin.right;
  //   const height = svgHeight - margin.top - margin.bottom;

  //   const topBarMargin = 30; // Add margin for the top of the bars

  //   // Calculate total action days
  //   const totalActionDays = sortedData?.reduce(
  //     (acc, item) => acc + item.action_days,
  //     0
  //   );

  //   // Add an extra day to the totalActionDays
  //   const extendedTotalActionDays = totalActionDays + 1;

  //   // Define a color scale for the orders
  //   const colorScale = d3.scaleOrdinal(d3.schemeCategory10);

  //   // Clear any existing svg
  //   d3.select("#gantt-chart").selectAll("*").remove();

  //   const svg = d3
  //     .select("#gantt-chart")
  //     .append("svg")
  //     .attr("width", svgWidth)
  //     .attr("height", svgHeight);

  //   const chart = svg
  //     .append("g")
  //     .attr("transform", `translate(${margin.left},${margin.top})`);

  //   const xScale = d3
  //     .scaleLinear()
  //     .domain([1, extendedTotalActionDays])
  //     .range([0, width]);

  //   const yScale = d3
  //     .scaleBand()
  //     .domain(sortedData?.map((d) => d.action + d.startDate))
  //     .range([height, 0]);

  //   const oddTickValues = Array.from(
  //     { length: extendedTotalActionDays },
  //     (_, i) => i + 1
  //   ).filter((d) => d % 2 !== 0);

  //   const xAxis = d3
  //     .axisTop(xScale)
  //     .tickSize(-height)
  //     .tickFormat((d) => `D${d}`)
  //     .ticks(sortedData.length <= 3 ? extendedTotalActionDays : undefined)
  //     .tickValues(oddTickValues);

  //   const calculateDx = (d) => {
  //     if (d >= 11) {
  //       return "-3em";
  //     } else {
  //       return "-1.7em";
  //     }
  //   };

  //   chart
  //     .append("g")
  //     .call(xAxis)
  //     .selectAll("text")
  //     .style("font-size", "12px")
  //     .style("color", "#B9B9C7")
  //     .style("text-anchor", "middle")
  //     .attr("dx", (d) => calculateDx(d))
  //     .attr("dy", "-2.5em");

  //   chart.selectAll(".domain").remove();

  //   const tooltip = d3
  //     .select("body")
  //     .append("div")
  //     .attr("class", "tooltip")
  //     .style("position", "absolute")
  //     .style("background", "#fff")
  //     .style("border", "1px solid #ccc")
  //     .style("padding", "10px")
  //     .style("display", "none");

  //   let cumulativeDays = {};
  //   let nextAvailableDay = 1;
  //   const ordersWithOverlap = new Set();

  //   sortedData?.forEach((d) => {
  //     if (!cumulativeDays[d.order]) {
  //       cumulativeDays[d.order] = nextAvailableDay;
  //     } else {
  //       ordersWithOverlap.add(d.order);
  //     }
  //     nextAvailableDay = Math.max(
  //       nextAvailableDay,
  //       cumulativeDays[d.order] + d.action_days
  //     );
  //   });

  //   chart
  //     .selectAll(".bar")
  //     .data(sortedData)
  //     .enter()
  //     .append("rect")
  //     .attr("x", (d) => xScale(cumulativeDays[d.order]))
  //     .attr(
  //       "y",
  //       (d, i) =>
  //         yScale(d.action + d.startDate) +
  //         (ordersWithOverlap.has(d.order) ? 10 * (i % 2) : 0) +
  //         topBarMargin
  //     )
  //     .attr("width", (d) => xScale(d.action_days) - xScale(0))
  //     .attr(
  //       "height",
  //       sortedData?.length > 3
  //         ? yScale.bandwidth() / 2
  //         : sortedData.length === 1
  //         ? yScale.bandwidth() / 13
  //         : sortedData.length === 3
  //         ? yScale.bandwidth() / 4
  //         : yScale.bandwidth() / 8
  //     )
  //     .attr("fill", (d) => colorScale(d.order))
  //     .attr(
  //       "rx",
  //       sortedData?.length >= 3
  //         ? yScale.bandwidth() / 5
  //         : yScale.bandwidth() / 20
  //     )
  //     .attr(
  //       "ry",
  //       sortedData?.length >= 3
  //         ? yScale.bandwidth() / 5
  //         : yScale.bandwidth() / 20
  //     );

  //   svg
  //     .append("defs")
  //     .append("clipPath")
  //     .attr("id", "clip-path-rounded")
  //     .append("rect")
  //     .attr("width", 25)
  //     .attr("height", 25)
  //     .attr("rx", 5)
  //     .attr("ry", 5);

  //   chart
  //     .selectAll(".bar")
  //     .data(sortedData)
  //     .enter()
  //     .append("text")
  //     .attr("x", (d) => xScale(cumulativeDays[d.order]) + 35)
  //     .attr(
  //       "y",
  //       (d, i) =>
  //         yScale(d.action + d.startDate) +
  //         (ordersWithOverlap.has(d.order) ? 10 * (i % 2) : 0) +
  //         yScale.bandwidth() / 4
  //     )
  //     .attr("dy", ".35em")
  //     .style("fill", "white")
  //     .style("font-size", "12px")
  //     .style("text-anchor", "start");

  //   chart.selectAll(".tick text").attr("x", function () {
  //     return (this.getBoundingClientRect().width / 2) * +6;
  //   });

  //   sortedData?.forEach((d) => {
  //     cumulativeDays[d.order] += d.action_days;
  //   });

  //   // Step 1: Filter out duplicate action names
  //   const uniqueActions = sortedData.filter(
  //     (action, index, self) =>
  //       index === self.findIndex((t) => t.action === action.action)
  //   );
  //   const textContainer = d3.select("#text-container").html(""); // Clear any existing content

  //   uniqueActions?.forEach((d, i) => {
  //     const textGroup = textContainer
  //       .append("div")
  //       .attr("class", "text-group")
  //       .style("display", "flex")
  //       .style("align-items", "center")
  //       .style("gap", `10px`)
  //       .style("color", colorScale(d.order))
  //       .style("justify-content", "space-between")
  //       .style("font-weight", "700")
  //       .style("font-size", "14px")
  //       .style(
  //         "height",
  //         `${
  //           sortedData?.length >= 3
  //             ? `${yScale.bandwidth()}px`
  //             : `${yScale.bandwidth()}px`
  //         }`
  //       );
  //     textGroup
  //       .append("img")
  //       .attr(
  //         "src",
  //         d.assigned_to_image?.startsWith("users")
  //           ? Assets_URL + "/" + d.assigned_to_image
  //           : d.assigned_to_image
  //       )
  //       .attr("alt", "Assigned to image")
  //       .style("height", "40px")
  //       .style("width", "40px")
  //       .style("border-radius", "50px");
  //     textGroup
  //       .append("p")
  //       .text(
  //         `${d.action_days} ${t("actions.day")}${d.action_days > 1 ? "s" : ""}`
  //       );
  //     textGroup.append("p").text(d.action);
  //   });
  // }, [sortedData]);

  const steps = meetingData?.steps || [];

  const lastStep = steps[steps.length - 1];
  const lastStepTime = lastStep?.end_time;
  const lastStepFormattedTime = new Date(
    `1970-01-01T${lastStepTime}`
  ).toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
  const calculateTotalDays = (steps) => {
    if (!steps) {
      return;
    }
    return steps?.reduce((total, step) => {
      return total + step.count2;
    }, 0);
  };
  const addDaysToDate = (date, days) => {
    if (!date || !days) {
      return;
    }
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  };
  const formatDateInFrench = (dateString) => {
    if (!dateString) {
      return;
    }
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  // const startDate = new Date(meetingData?.date);
  const startDate = new Date(`${meetingData?.date}T${meetingData?.start_time}`);

  const totalDays1 = calculateTotalDays(meetingData?.steps);

  let endDateForHour;
  if (meetingData?.type === "Action") {
    // If the meeting type is "Active", treat totalDays as total days
    endDateForHour = new Date(
      startDate.getTime() + totalDays1 * 24 * 60 * 60 * 1000
    );
  } else if (meetingData?.type === "Task") {
    // If the meeting type is "Task", treat totalDays as total hours
    endDateForHour = new Date(
      startDate.getTime() + totalDays1 * 60 * 60 * 1000
    );
  } else if (meetingData?.type === "Quiz") {
    // If the meeting type is "Quiz", treat totalDays as total seconds
    endDateForHour = new Date(startDate.getTime() + totalDays1 * 1000);
  } else {
    // Otherwise, treat totalDays as total minutes
    endDateForHour = new Date(startDate.getTime() + totalDays1 * 60 * 1000);
  }

  const formattedEndDateInHours = formatDateInFrench(endDateForHour);

  const endDate = addDaysToDate(startDate, totalDays1);
  const formattedEndDate = formatDateInFrench(endDate);

  const filteredActions = meetingData?.plan_d_actions?.reduce((acc, item) => {
    // Find if an entry with the same action, order, and action_days already exists
    const existing = acc.find(
      (obj) =>
        obj.action === item.action &&
        obj.order === item.order &&
        obj.action_days === item.action_days
    );

    // If it exists, we skip adding the current item to the accumulator
    if (!existing) {
      acc.push(item);
    }

    return acc;
  }, []);

  const guideEmails = new Set(meetingData?.guides?.map((guide) => guide.email));

  //Participant
  const [showProfile, setShowProfile] = useState(false);
  const handleShow = () => {
    setShowProfile(true);
  };
  const hideShow = () => {
    setShowProfile(false);
  };

  //Host
  const [showHostProfile, setShowHostProfile] = useState(false);
  const handleHostShow = () => {
    setShowHostProfile(true);
  };
  const hideHostShow = () => {
    setShowHostProfile(false);
  };

  //Closed Report Participant
  const [uuid, setUuid] = useState(null);
  const [show, setShow] = useState(false);
  const handleProfile = (userId) => {
    setShow(true);
    setUuid(userId);
  };
  const handleHide = () => {
    setShow(false);
  };

  //Closed Report Host
  const [isUser, setIsUser] = useState(false);

  const [showSignIn, setShowSignIn] = useState(false);
  const [showSignUp, setShowSignUp] = useState(false);
  const [showForgot, setShowForgot] = useState(false);

  const [showStepperModal, setShowStepperModal] = useState(false);

  const handleShowSignIn = () => {
    setShowSignUp(false);
    setShowSignIn(true);
  };

  const handleShowSignUp = () => {
    setShowSignIn(false);
    setShowSignUp(true);
  };

  const handleShowStepperModal = () => {
    setShowStepperModal(true);
    // setShowSignUp(true);
  };
  const handleCloseStepperModal = () => setShowStepperModal(false);

  const handleShowForgot = () => {
    setShowSignIn(false);
    setShowSignUp(false);
    setShowForgot(true);
  };

  const handleCloseSignUp = () => setShowSignUp(false);
  const handleCloseForgot = () => setShowForgot(false);

  const { toggle } = useSidebarContext();
  const handleClose = () => {
    toggle(true);
    setIsModalOpen(false);
    // onClose();
  };

 const handleLogin = () => {
    navigate("/login", {
      state: {
              redirect_rules:false,
      fromInvitePage: true,
      fromProfile: true,
      previousPath: window.location.pathname + window.location.search,
      },
    });
  };


  const [password, setPassword] = useState(null);
  const checkPassword = async () => {
    const payload = {
      password: password,
      meeting_id: meetId,
    };
    try {
      const response = await axios.post(
        `${API_BASE_URL}/check-meeting-password`,
        payload
      );
      if (response?.status) {
        const meeting = response?.data?.data;
        toggle(true);
        handleClose();
        setMeetingAudio(meeting?.voice_notes);
        setMeetingTranscript(meeting?.meeting_notes_transcript?.transcript);
        setMeetingSummary(meeting?.meeting_notes_summary);
        setMeetingData(meeting);
        if (meeting.status === "closed") {
          const allEqual = steps.every(
            (step) => step.note?.trim() === step.original_note?.trim()
          );

          const someEqual = steps.some(
            (step) => step.note?.trim() === step.original_note?.trim()
          );

          const areNotesSummarized = allEqual || someEqual; // true if all or some equal, false if none

          const areStepNotesSummarized = steps
            ? steps.every((step) => step.note === null) || // All notes are null
              (steps.some((step) => step.note === null) &&
                steps.some((step) => step.note !== null)) // One note is null and one is not
            : undefined; // Handle the case when `steps` is null or undefined

          if (
            (meeting?.status === "closed" &&
              meeting?.prise_de_notes === "Automatic" &&
              meeting?.summary_status === 0) ||
            (meeting?.type === "Special" && areStepNotesSummarized)
          ) {
            // setShowProgressBar(true);
            // await handleSecondApiCall(meeting.id); // Pass any required data
          }
          getMeetingByID(meeting.objective, meeting.user.id);
        } else if (["active", "in_progress"].includes(meeting.status)) {
          getActiveMeetingByID(meeting.objective, meeting.user.id);
        }
        setSelectedMeeting({
          value: meeting?.id,
          label: meeting?.title,
        });
        setIsModalOpen(false);
        // getRefreshMeeting()
      }
    } catch (error) {
      console.log("error", error);
      toast.error("Incorrect password");
    }
  };

  const [view, setView] = useState("graph");
  // const [open1, setOpen1] = useState(false);
  const handleToggle = () => {
    setView(view === "list" ? "graph" : "list");
    // setOpen1(!open1);
  };

  const [activeEventKey, setActiveEventKey] = useState(null);

  const copyToClipboard = (nick_name) => {
    if (!nick_name) return;
    const visitingCardUrl =
      window.location.origin + "/heroes" + "/" + nick_name;

    navigator.clipboard.writeText(visitingCardUrl).then(
      () => {},
      (err) => {
        console.error("Failed to copy: ", err);
      }
    );
    // navigate("/" + "heros" + "/" + user?.uuid);
    window.open("/" + "heroes" + "/" + nick_name, "_blank");
  };

  const viewPresentation = (data) => {
    setSelectedMeeting({
      value: data?.id,
      label: data?.title,
    });
    const url = `/destination/${data?.unique_id}/${data?.id}`;
    if (data?.status === "closed" || data?.status === "abort") {
      updateCallApi(false);

      navigate(url);
    } else if (data?.status === "in_progress") {
      updateCallApi(true);

      navigate(`/destination/${data?.unique_id}/${data?.id}`);
    } else {
      updateCallApi(false);

      navigate(url);
    }
  };

  const [openKeys, setOpenKeys] = useState([]);

  useEffect(() => {
    if (destinationDate?.meetings) {
      // Set all keys open initially once destinationDate is available
      setOpenKeys(destinationDate.meetings.map((_, index) => index.toString()));
    }
  }, [destinationDate]);

  const handleToggleAccoridon = (key) => {
    setOpenKeys(
      (prevKeys) =>
        prevKeys.includes(key)
          ? prevKeys.filter((k) => k !== key) // Close if open
          : [...prevKeys, key] // Open if closed
    );
  };

  const [activeLink, setActiveLink] = useState("");

  const { updateLanguage } = useDraftMeetings();

  const handleChangeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    updateLanguage(lang);
  };

  const handleClick = () => {
    setFileClicked(false);
    setSelectedMeeting(null);
    setIsModalOpen(false);
    setShowHostProfile(false);

    const url =
      meetingData?.status === "closed" || meetingData?.status === "in_progress"
        ? `/destination/${meetingData?.destination_unique_id}--es/${meetingData?.destination_id}`
        : meetingData?.status === "active" ||
          meetingData?.status === "in_progress" ||
          meetingData?.status === "to_finish" ||
          meetingData?.status === "todo"
        ? `/destination/${meetingData?.destination_unique_id}--es/${meetingData?.destination_id}`
        : `/destination/${destinationDate?.uuid}--es/${destinationDate?.id}`;

    navigate(url);
    setIsModalOpen1(false);
  };
  useEffect(() => {
    const path = location.pathname;

    const destinationPattern =
      /^\/destination\/([a-f0-9\-]+)--es\/([a-f0-9\-]+)$/;
    if (destinationPattern.test(path)) {
      setActiveLink("/destination");
    } else {
      setActiveLink(path);
    }
  }, [location]);

  const renderIcon = () => {
    const type = meetingData?.type;
    return typeIcons[type] || null;
  };

  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const navbarStyle = {
    position: isSticky ? "fixed" : "relative",
    top: isSticky ? "0" : "auto",
    zIndex: 10000000000,
    boxShadow: isSticky ? "0 4px 2px -2px white" : "none",
  };

  // Prepare options for react-select
  const options = destinationDate?.meetings
    ?.filter((moment) => moment.status !== "abort")
    ?.map((item, index) => ({
      value: item.id,
      label: `${index + 1}. ${item.title}`, // Format as '1. title'
    }));

  // Handle change event
  const handleChange = (selectedOption) => {
    setFileClicked(false);
    setSelectedMeeting(selectedOption);

    if (selectedOption) {
      const selectedItem = destinationDate?.meetings?.find(
        (item) => item.id === selectedOption.value
      );

      if (selectedItem) {
        setUniqueId((prev) => !prev); // Assuming setUniqueId is defined elsewhere
        viewPresentation(selectedItem);
      }
    }
  };

  // Map the meetings to options
  const optionsMeetings = allMeetings
    ?.filter((item) => item.id.toString() !== meetId.toString())
    ?.map((item, index) => ({
      value: item.id,
      label: `${index + 1}. ${item.title}`, // Format as '1. title'
    }));

  const handleChangeMeetings = (selectedOption) => {
    setFileClicked(false);
    setSelectedMeeting(selectedOption);

    const selectedItem = allMeetings?.find(
      (item) => item.id === selectedOption.value
    );

    if (selectedItem) {
      applyHeaderFilter(selectedItem);
    }
  };

  const [dropdownWidth, setDropdownWidth] = useState(250); // Initial width

  const calculateDropdownWidth = (options) => {
    // Calculate width based on the longest label in the options
    const maxLabelLength = options.reduce((maxLength, option) => {
      const optionLength = option.label.length;
      return optionLength > maxLength ? optionLength : maxLength;
    }, 0);
    // You can adjust the multiplier to add padding or margins if needed
    setDropdownWidth(maxLabelLength * 8); // Adjusting width dynamically based on text length
  };

  useEffect(() => {
    if (optionsMeetings && optionsMeetings.length > 0) {
      calculateDropdownWidth(optionsMeetings);
    }
  }, [optionsMeetings]);

  const [reportProgress, setReportProgress] = useState(0);
  const [showReportProgressBar, setShowReportProgressBar] = useState(false);

  // const handleMeetingReport = async () => {
  //   if (isCalling || reportData || meetingData?.location === null) {
  //     return;
  //   }
  //   if (!meetId) {
  //     console.error("Meeting ID is not set");
  //     return;
  //   }

  //   if (meetingData?.meeting_notes !== null) return;
  //   // Ensure progress bar only starts if not already shown
  //   if (!showReportProgressBar) {
  //     setShowReportProgressBar(true); // Show progress bar
  //     if (reportProgress === 0) {
  //       setReportProgress(65); // Initialize progress if starting for the first time
  //     }
  //   }

  //   const simulateProgress = () => {
  //     setReportProgress((prev) => {
  //       if (prev >= 65) return prev; // Cap progress at 65%
  //       return prev + 1; // Increment progress
  //     });
  //   };

  //   const interval = setInterval(simulateProgress, 100); // Increment every 100ms

  //   try {
  //     const response = await axios.get(
  //       `${API_BASE_URL}/get-email-imap/${meetId}`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${sessionStorage.getItem("token")}`,
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );
  //     if (response.status) {
  //       clearInterval(interval);
  //       const data = response.data;
  //       setIsCalling(true); // Prevent further calls
  //       setReportData(data?.data?.meeting_notes); // Save report data
  //       setReportProgress(100);
  //       // Hide progress bar after a short delay
  //       setTimeout(() => {
  //         setShowReportProgressBar(false);
  //       }, 500);
  //     }
  //   } catch (error) {
  //     console.log("Error while fetching meeting data:", error);
  //     // Do not reset or hide the progress bar here to maintain its state
  //   } finally {
  //     clearInterval(interval);
  //     // Keep progress at its current state on failure
  //     if (!reportData && reportProgress < 65) {
  //       setReportProgress(65); // Ensure progress reaches 65% if still waiting
  //     }
  //   }
  // };
  // useEffect(() => {
  //   // Skip setting up the interval if location is null
  //   if (meeting?.location === null) {
  //     console.log("Location is null, skipping useEffect setup.");
  //     return;
  //   }
  //   // Only set up the interval if no ongoing API call or existing report data
  //   if (!isCalling && !reportData) {
  //     const intervalId = setInterval(() => {
  //       handleMeetingReport();
  //     }, 5000);

  //     return () => clearInterval(intervalId); // Cleanup interval on unmount
  //   }
  // }, [isCalling, reportData, meeting?.location]);

  const [isLoggedIn, setIsLoggedIn] = useState(false); // Local state for login

  // Check if max_participant and price are not null
  const shouldBlurContent =
    meetingData?.max_participant !== null && meetingData?.price !== null;

  // Determine if content should be blurred
  const isContentBlurred =
    shouldBlurContent &&
    meetingData?.participants?.some(
      (item) => item?.email === sessionUser?.email
    );

  const [showFeedbackPopup, setShowFeedbackPopup] = useState(false);
  const [rating, setRating] = useState(null);
  const [feedback, setFeedback] = useState(null);
  const [anonymous, setAnonymous] = useState(false);
  const [userName, setUserName] = useState(null);
  const [alreadyAnswered, setAlreadyAnswered] = useState(false); // State for checkbox

  const userid = parseInt(sessionStorage.getItem("user_id"));
  const [submit, setSubmit] = useState(false);
  const onClose = () => {
    setShowFeedbackPopup(false);
    setRating(0);
    setFeedback(null);
    setAnonymous(false);
  };
  useEffect(() => {
    if (meetingData?.status === "closed" && meetingData?.feedback) {
      const hasGivenFeedback = checkUserFeedback(
        userid,
        meetingData.meeting_feedbacks
      );
      if (!hasGivenFeedback) {
        setShowFeedbackPopup(true);
      }
    }
  }, [meetingData]);

  // Check if the user has already provided feedback for the meeting
  const checkUserFeedback = (userId, feedbacks) => {
    return feedbacks?.some((feedback) => feedback?.user_id === userId);
  };
  const handleFeedbackSubmit = async () => {
    // Check if rating is not provided (but allow 0 as a valid rating)
    if (rating === null || rating === undefined) {
      // alert("Please provide a rating before submitting.");
      toast.error(t("Please provide a rating before submitting"));
      return;
    }

    if (!sessionUser && userName === null) {
      toast.error(t("Please enter your name before submitting"));
      return;
    }
    setLoading(true);
    setSubmit(true);

    try {
      await axios.post(
        `${API_BASE_URL}/moment-feedback`,
        {
          user_id: userid || null,
          meeting_id: meetingData.id,
          rating,
          user_name: userName,
          comment: feedback,
          anonymous,
        },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      // Hide feedback popup after submission
      onClose();
    } catch (error) {
      console.error("Error submitting feedback:", error);
      if (error.response && error.response.data) {
        const { message, errors } = error.response.data;

        // Show the main error message
        if (message) {
          toast.error(t(message));
        }

        // Show validation errors (if any)
        if (errors) {
          Object.entries(errors).forEach(([field, messages]) => {
            messages.forEach((msg) => toast.error(t(msg)));
          });
        }
      } else {
        // Fallback error message if no response data
        toast.error(t("Failed to submit feedback. Please try again."));
      }
    } finally {
      setUserName(null);
      setRating(null);
      setAnonymous(false);
      setFeedback(null);
      setLoading(false);
      setSubmit(false);
    }
  };

  const emojis = [
    {
      value: 5,
      emoji: "😎",
      label: t("5 Star"),
    }, // Cool
    { value: 4, emoji: "😀", label: t("4 Star") }, // Happy
    {
      value: 3,
      emoji: "🙂",
      label: t("3 Star"),
    }, // Neutral
    {
      value: 2,
      emoji: "😟",
      label: t("2 Star"),
    }, // Sad
    {
      value: 1,
      emoji: "😣",
      label: t("1 Star"),
    }, // Very Sad
    // { value: 0, emoji: "❌", label: t("0 Star") }, // No opinion
  ];

  const handleCheckboxChange = (event) => {
    setAlreadyAnswered(event.target.checked);
    if (event.target.checked) {
      onClose(); // Call the onClose function to close the popup
    }
  };
  const [previousTab, setPreviousTab] = useState(null);

  const handleClicked = () => {
    setPreviousTab(activeLink); // save current menu

    setFileClicked(true); // set state to true
    setShowHostProfile(false);
  };

  const updateFromTektime = (value) => {
    setFromTektime(value);
    sessionStorage.setItem("fromTektime", value);
  };

  const [play, setPlay] = useState(false);
  const handlePlay = async (item) => {
    updateCallApi(false);
    updateFromTektime(true);

    continueHandlePlay(item);
  };

  const continueHandlePlay = async (item) => {
    updateCallApi(false);
    updateFromTektime(true);

    setPlay(true);
    const scheduledDateTime = new Date(`${item.date}T${item.start_time}`);
    const currentDateTime = new Date();
    const currentTime = new Date();

    // Get the user's time zone
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const localCurrentTime = currentTime.toLocaleString("en-GB", {
      timeZone: userTimeZone,
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
    const formattedCurrentDate = currentDateTime.toISOString().split("T")[0];

    const minOrderNo = Math.min(...item.steps.map((step) => step.order_no));

    // Find the first step (order_no 1)
    const firstStep = item.steps.find((step) => step.order_no === minOrderNo);
    const firstParticipant = firstStep?.assigned_to;

    // Format date and time in user's timezone
    const stepTimeFormatted = moment().tz(userTimeZone).format("hh:mm:ss A"); // "05:27:40 PM"
    const startDateFormatted = moment().tz(userTimeZone).format("YYYY-MM-DD"); // "2025-04-30"

    const updatedSteps = item?.steps?.map((step) => {
      if (step.id === firstStep.id) {
        // The actual step that's being played
        return {
          ...step,
          status: "in_progress",
          step_status: "in_progress",
          current_time: localCurrentTime,
          current_date: formattedCurrentDate,
          step_time: stepTimeFormatted,
          start_date: startDateFormatted,
        };
      } else if (
        step.order_no === minOrderNo &&
        step.assigned_to === firstParticipant
      ) {
        // Same order_no and same participant as first step → Todo
        return {
          ...step,
          step_status: "todo",
          status: "todo",
        };
      } else if (
        step.order_no === minOrderNo &&
        step.assigned_to !== firstParticipant
      ) {
        // Same order_no but different participant → in_progress
        return {
          ...step,
          step_status: "in_progress",
          status: "in_progress",
          current_time: localCurrentTime,
          current_date: formattedCurrentDate,
          step_time: stepTimeFormatted,
          start_date: startDateFormatted,
        };
      }
      return step;
    });

    const payload = {
      ...item,
      steps: updatedSteps,
      starts_at: localCurrentTime,
      current_date: currentDateTime,
      status: "in_progress",
      _method: "put",
      moment_privacy_teams:
        item?.moment_privacy === "team" &&
        item?.moment_privacy_teams?.length &&
        typeof item?.moment_privacy_teams[0] === "object"
          ? item?.moment_privacy_teams.map((team) => team.id)
          : item?.moment_privacy_teams || [], // Send as-is if IDs are already present
    };

    try {
      const response = await axios.post(
        `${API_BASE_URL}/meetings/${item.id}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      if (response.status) {
        const firstInProgressStep = item?.steps[0];
        if (item?.type === "Task" || item?.type === "Strategy") {
          markTodoMeeting(item?.id);
          // getMeeting()
        }
        // navigate(`/play/${item.id}`);

        window.location.reload();
        // window.open(`/destination/${item?.unique_id}/${item?.id}`, '_blank');

        setLoading(false);

        // navigate(`/destínation/${item?.unique_id}/${item?.id}`);
      }
    } catch (error) {
      console.log("error", error);
      setPlay(false);
    }
  };

  return (
    <>
      {isLoading ? (
        <>
          <Spinner
            animation="border"
            role="status"
            className="center-spinner"
          ></Spinner>
        </>
      ) : (
        <>
          {!isModalOpen1 && (
            <div className="home-header">
              <nav
                id="navbar"
                className="container-fluid navbar bg-white navbar-expand-lg py-3"
                style={navbarStyle}
              >
                <div className="container">
                  <Link
                    to="/"
                    className="navbar-brand"
                    onClick={() => {
                      setFileClicked(false);
                      setIsModalOpen1(true);
                      setShowHostProfile(false);
                    }}
                  >
                    <img
                      src="/Assets/landing/logo.png"
                      alt=""
                      className="img-fluid"
                    />
                  </Link>
                  <button
                    className="navbar-toggler bg-white"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                  >
                    <span className="navbar-toggler-icon" />
                  </button>
                  <div
                    className="collapse navbar-collapse "
                    id="navbarSupportedContent"
                  >
                    <div className="navbar-nav ms-auto d-flex right-dropdown-profile w-100">
                      <ul className="navbar-nav mb-2 mb-lg-0 align-items-center justify-content-between w-100 ">
                        {
                          <div
                            className="d-flex align-items-center ms-5"
                            style={{
                              visibility: uniqueId
                                ? "visible"
                                : !uniqueId &&
                                  allMeetings?.filter(
                                    (item) =>
                                      Number(item?.id) !== Number(meetId)
                                  )?.length > 0
                                ? "visible"
                                : "hidden",
                            }}
                          >
                            <li
                              className={`nav-item ${
                                activeLink === "/destination" && !fileClicked
                                  ? "active"
                                  : ""
                              }`}
                            >
                              <span
                                className="nav-link pb-1"
                                onClick={handleClick}
                                style={{ cursor: "pointer" }}
                              >
                                {t("navbar.home")}
                              </span>
                            </li>
                            <li
                              className={`nav-item ${
                                fileClicked ? "active" : ""
                              }`}
                            >
                              <span
                                className="nav-link pb-1"
                                onClick={handleClicked}
                                style={{ cursor: "pointer" }}
                              >
                                {t("navbar.file")}
                              </span>
                            </li>

                            <li
                              className={`nav-item dropdown ${
                                selectedMeeting && !fileClicked ? "active" : ""
                              }`} // Add 'active' class if selectedMeeting exists
                            >
                              {!uniqueId ? (
                                <>
                                  <Select
                                    options={optionsMeetings}
                                    value={
                                      selectedMeeting
                                        ? {
                                            value: selectedMeeting.value,
                                            label: selectedMeeting.label,
                                          }
                                        : null
                                    } // Set selected value
                                    onChange={handleChangeMeetings} // Handle change
                                    placeholder="Moments"
                                    isSearchable={false}
                                    styles={{
                                      control: (provided, state) => ({
                                        ...provided,
                                        width: "290px",
                                        border: "none",
                                        outline: "none",
                                        cursor: "pointer",
                                        borderBottom:
                                          selectedMeeting && !fileClicked
                                            ? "3px solid rgba(255, 186, 0, 1)"
                                            : "none",
                                      }),
                                      menu: (base) => ({
                                        ...base,
                                        width: "290px",
                                      }),
                                      menuList: (base) => ({
                                        ...base,
                                        width: "290px",
                                      }),
                                    }}
                                  />
                                </>
                              ) : (
                                <>
                                  <Select
                                    options={options}
                                    onChange={handleChange}
                                    placeholder="Moments"
                                    value={
                                      selectedMeeting
                                        ? {
                                            value: selectedMeeting.value,
                                            label: selectedMeeting.label,
                                          }
                                        : null
                                    } // Set selected value
                                    // isSearchable
                                    // className="nav-link pb-1"
                                    styles={{
                                      control: (base, state) => ({
                                        ...base,
                                        width: "290px",
                                        border: "none",
                                        boxShadow: "none",
                                        cursor: "pointer",
                                        borderBottom:
                                          selectedMeeting && !fileClicked
                                            ? "3px solid rgba(255, 186, 0, 1)"
                                            : "none", // Add border-bottom if an option is selected
                                      }),
                                      menu: (base) => ({
                                        ...base,
                                        width: "290px",
                                      }),
                                      menuList: (base) => ({
                                        ...base,
                                        width: "290px",
                                      }),
                                    }}
                                  />
                                </>
                              )}
                            </li>
                          </div>
                        }

                        <div className="d-flex align-items-center gap-4">
                          <li className="nav-item">
                            <div className="mt-1 swtich">
                              <label
                                className="form-check-label mr-2"
                                htmlFor="languageSwitch"
                                style={{
                                  fontFamily: "Inter",
                                  fontSize: "13px",
                                  lineHeight: "15.73px",
                                  textAlign: "left",
                                  color: "#4C4C4C",
                                  fontWeight:
                                    i18n.language === "fr" ? 200 : "bold",
                                }}
                              >
                                {/* {i18n.language === "en" && "En"} */}
                                En
                              </label>

                              <div
                                className="form-check form-switch p-0"
                                style={{ minHeight: "0px" }}
                              >
                                <input
                                  className="form-check-input m-0"
                                  type="checkbox"
                                  id="languageSwitch"
                                  role="switch"
                                  checked={i18n.language === "fr"} // Set the checked state based on the current language
                                  onChange={() =>
                                    handleChangeLanguage(
                                      i18n.language === "fr" ? "en" : "fr"
                                    )
                                  }
                                />
                              </div>
                              <label
                                className="form-check-label"
                                htmlFor="languageSwitch"
                                style={{
                                  fontFamily: "Inter",
                                  fontSize: "13px",
                                  lineHeight: "15.73px",
                                  textAlign: "left",
                                  color: "#4C4C4C",
                                  fontWeight:
                                    i18n.language === "en" ? 200 : "bold",
                                }}
                              >
                                {/* {i18n.language === "fr" && "Fr"} */}
                                Fr
                              </label>
                            </div>
                          </li>

                          {sessionUser ? (
                            <div className="connected_users">
                              <div className=" d-flex align-items-center flex-wrap">
                                <Avatar.Group>
                                  <Avatar
                                    size="large"
                                    src={
                                      sessionUser?.image?.startsWith("users/")
                                        ? Assets_URL + "/" + sessionUser?.image
                                        : sessionUser?.image
                                    }
                                  />
                                </Avatar.Group>
                                <span
                                  style={{
                                    marginLeft: "8px",
                                  }}
                                >
                                  {sessionUser?.full_name}
                                </span>
                              </div>
                            </div>
                          ) : (
                            <div className="nav-item">
                              <button
                                onClick={handleLogin}
                                className="nav-link ps-0 pb-1"
                              >
                                <div className="container-door align-items-center">
                                  {t("navbar.login")}

                                  <div className="flipbox top-0">
                                    <div className="flipbox-active"></div>
                                  </div>
                                </div>
                              </button>
                            </div>
                          )}
                        </div>
                      </ul>
                    </div>
                  </div>
                </div>
              </nav>
            </div>
          )}
          {fileClicked ? (
            <>
              <div
                className="email-invite report w-100 "
                style={{ position: fileClicked ? "static" : "relative" }}
              >
                {destinationDate?.banner ? (
                  <img
                    src={destinationDate?.banner}
                    alt="Destination Banner"
                    style={{
                      width: "100%",
                      height: "338px",
                      objectFit: "cover",
                      filter: "opacity(0.5)",
                    }}
                  />
                ) : (
                  <div className="gradient-header">
                    <svg
                      width="100%"
                      height="338"
                      viewBox="0 0 1453 338"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g filter="url(#filter0_f_902_7997)">
                        <rect
                          width="100%"
                          height="271"
                          fill="url(#paint0_linear_902_7997)"
                        />
                      </g>
                      <defs>
                        <filter
                          id="filter0_f_902_7997"
                          x="-66.5"
                          y="-66.5"
                          width="1573"
                          height="404"
                          filterUnits="userSpaceOnUse"
                          colorInterpolationFilters="sRGB"
                        >
                          <feFloo
                            floodOpacity="0"
                            result="BackgroundImageFix"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="BackgroundImageFix"
                            result="shape"
                          />
                          <feGaussianBlur
                            stdDeviation="33.25"
                            result="effect1_foregroundBlur_902_7997"
                          />
                        </filter>
                        <linearGradient
                          id="paint0_linear_902_7997"
                          x1="856"
                          y1="281.934"
                          x2="863.131"
                          y2="-138.913"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="white" />
                          <stop offset="1" stopColor="#76C3EE" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>
                )}

                <div className="participant px-0">
                  <div className="content">
                    <div
                      className="row align-items-center report-row"
                      style={{ minHeight: "35vh" }}
                    >
                      <div className="col-md-10 d-flex flex-column ps-2 mt-5">
                        <h5 className="content-heading fw-bold text-start ps-2 mt-5 mt-md-0">
                          {destinationDate?.destination_name ||
                            meetingData?.objective}
                        </h5>

                        {/* <div className="ps-2 content-body mt-3">
                          <div className="d-flex align-items-center gap-2">
                            <>
                              <img src="/Assets/invite-date.svg" />
                              <span className="fw-bold formate-date">
                                {destinationDate?.meeting_start_date}
                                &nbsp; -
                              </span>
                              <span className="fw-bold formate-date">
                                {destinationDate?.meeting_end_date}
                              </span>
                            </>
                          </div>
                        </div> */}
                      </div>
                    </div>

                    {/* //TABS */}
                    <div className="row align-items-center justify-content-between tab-row tektimetabs">
                      <div className="col-md-12 mt-3 mt-md-2">
                        <ul
                          className="nav nav-pills border-bottom"
                          id="pills-tab"
                          role="tablist"
                        >
                          <li className="nav-item" role="presentation">
                            <button
                              className="nav-link  active p-0 rounded-0"
                              id="pills-active-tab"
                              data-bs-toggle="pill"
                              data-bs-target="#pills-active"
                              type="button"
                              role="tab"
                              aria-controls="pills-active"
                              aria-selected="true"
                            >
                              {t("navbar.documents")}{" "}
                              {/* <span class="count">{closedTeams?.length}</span> */}
                            </button>
                          </li>
                          <li className="nav-item" role="presentation">
                            <button
                              className="nav-link p-0 rounded-0"
                              id="pills-archive-tab"
                              data-bs-toggle="pill"
                              data-bs-target="#pills-archive"
                              type="button"
                              role="tab"
                              aria-controls="pills-archive"
                              aria-selected="true"
                            >
                              {t("navbar.media")}{" "}
                              {/* <span class="count">{team?.length}</span> */}
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                    {/* //TABS CONTENT */}
                    <div
                      className="tab-content mt-3 invite"
                      id="pills-tabContent"
                      style={{ background: "none" }}
                    >
                      <div
                        className="tab-pane fade show active"
                        id="pills-active"
                        role="tabpanel"
                        aria-labelledby="pills-active-tab"
                        tabIndex={0}
                      >
                        <button
                          className="btn p-0 ps-3 back-button"
                          style={{ fontSize: "16px" }}
                          onClick={() => {
                            setFileClicked(false);
                            if (previousTab) {
                              setActiveLink(previousTab);
                            }
                          }}
                        >
                          {t("Retour")}
                        </button>

                        <ReportFileMenu
                          meeting_files={allFiles}
                          openModal={openModal}
                        />
                        {isFileModalOpen && (
                          <ViewFilePreview
                            isModalOpen={isFileModalOpen}
                            setIsModalOpen={setIsFileModalOpen}
                            modalContent={modalContent}
                            closeModal={closeModal}
                            // isFileUploaded={isFileUploaded}
                            // setIsFileUploaded={setIsFileUploaded}
                            // refreshMeeting={getRefreshMeeting}
                          />
                        )}
                      </div>
                      <div
                        className="tab-pane fade"
                        id="pills-archive"
                        role="tabpanel"
                        aria-labelledby="pills-archive-tab"
                        tabIndex={1}
                      >
                        <button
                          className="btn p-0 ps-3 back-button"
                          style={{ fontSize: "16px" }}
                          onClick={() => {
                            setFileClicked(false);
                            if (previousTab) {
                              setActiveLink(previousTab);
                            }
                          }}
                        >
                          {t("Retour")}
                        </button>
                        <ReportFileMenu
                          meeting_files={allMedia}
                          openModal={openModal}
                        />
                        {isFileModalOpen && (
                          <ViewFilePreview
                            isModalOpen={isFileModalOpen}
                            setIsModalOpen={setIsFileModalOpen}
                            modalContent={modalContent}
                            closeModal={closeModal}
                            // isFileUploaded={isFileUploaded}
                            // setIsFileUploaded={setIsFileUploaded}
                            // refreshMeeting={getRefreshMeeting}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              {!uniqueId ? (
                                     <div className={showProgressBar1 ? "blur-container" : ""}>

                  {/* feedbact location */}
                  {meetingData?.status === "closed" ||
                  meetingData?.status === "abort" ? (
                          <div>

                      <div
                        className={
                          !(
                            meeting?.location === "Google Meet" &&
                            !["Task", "Quiz", "Media", "Law"].includes(
                              meeting?.type
                            )
                          )
                            ? showProgressBar
                              ? "blur-container"
                              : ""
                            : null
                        }
                      >
                        <div
                          className="email-invite report w-100"
                          style={{
                            position: fromMeeting ? "static" : "relative",
                          }}
                        >
                          {!fromMeeting && (
                            <>
                              {meetingData?.destination_banner ? (
                                <img
                                  src={meetingData?.destination_banner}
                                  alt="Destination Banner"
                                  style={{
                                    width: "100%",
                                    height: "338px",
                                    objectFit: "cover",
                                    filter: "opacity(0.5)",
                                  }}
                                />
                              ) : (
                                <div className="gradient-header">
                                  <svg
                                    width="100%"
                                    height="338"
                                    viewBox="0 0 1453 338"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g filter="url(#filter0_f_902_7997)">
                                      <rect
                                        width="100%"
                                        height="271"
                                        fill="url(#paint0_linear_902_7997)"
                                      />
                                    </g>
                                    <defs>
                                      <filter
                                        id="filter0_f_902_7997"
                                        x="-66.5"
                                        y="-66.5"
                                        width="1573"
                                        height="404"
                                        filterUnits="userSpaceOnUse"
                                        colorInterpolationFilters="sRGB"
                                      >
                                        <feFloo
                                          floodOpacity="0"
                                          result="BackgroundImageFix"
                                        />
                                        <feBlend
                                          mode="normal"
                                          in="SourceGraphic"
                                          in2="BackgroundImageFix"
                                          result="shape"
                                        />
                                        <feGaussianBlur
                                          stdDeviation="33.25"
                                          result="effect1_foregroundBlur_902_7997"
                                        />
                                      </filter>
                                      <linearGradient
                                        id="paint0_linear_902_7997"
                                        x1="856"
                                        y1="281.934"
                                        x2="863.131"
                                        y2="-138.913"
                                        gradientUnits="userSpaceOnUse"
                                      >
                                        <stop stopColor="white" />
                                        <stop offset="1" stopColor="#76C3EE" />
                                      </linearGradient>
                                    </defs>
                                  </svg>
                                </div>
                              )}
                            </>
                          )}
                          <div className="content">
                            {!fromMeeting && (
                              <div
                                className="row report-row"
                                style={{ height: "35vh" }}
                              >
                                <div className="col-md-10 d-flex flex-column">
                                  <h5 className="content-heading fw-bold">
                                    {meetingData?.objective}
                                  </h5>
                                </div>

                                <div className="col-md-2">
                                  <div className="position-relative">
                                    {/* <HostCard data={meeting?.user} /> */}
                                    <Card className="mt-3 host-card tektime-dev-team">
                                      <Card.Body>
                                        <div className="d-flex justify-content-center">
                                          <div className="profile-logo">
                                            <Card.Img
                                              className="avatar-img"
                                              style={{
                                                objectFit: "cover",
                                                objectPosition: "top",
                                              }}
                                              src={
                                                meetingData?.destination
                                                  ?.clients?.client_logo
                                                  ? meetingData?.destination?.clients?.client_logo?.startsWith(
                                                      "http"
                                                    )
                                                    ? meetingData?.destination
                                                        ?.clients.client_logo
                                                    : `${Assets_URL}/${meetingData?.destination?.clients?.client_logo}`
                                                  : "/Assets/logo2.png" ||
                                                    "/Assets/logo2.png"
                                              }
                                            />
                                          </div>
                                        </div>

                                        <Card.Title className="text-center mt-3 card-heading">
                                          {meetingData?.destination?.clients
                                            ?.name || ""}
                                        </Card.Title>
                                      </Card.Body>
                                    </Card>
                                  </div>
                                </div>

                                {/* ------------------------------------------------ HOST */}
                              </div>
                            )}
                            <div className="row mt-5 mt-lg-0 pt-5 pt-md-0 report-row">
                              <div
                                className={`col-md-7 ${
                                  fromMeeting ? "w-100" : ""
                                }`}
                              >
                                <div
                                  className="dropdown-container"
                                  ref={dropdownRef}
                                >
                                  <div className="content-heading-title d-flex">
                                    <div style={{ cursor: "pointer" }}>
                                      {renderIcon()}
                                    </div>
                                    &nbsp;
                                    {selectedTitleOrder && (
                                      <>{selectedTitleOrder}&nbsp;</>
                                    )}
                                    {meetingData?.title}&nbsp;&nbsp;
                                    {meetingData?.status === "active" && (
                                      <span
                                        className={`badge ms-2 h-100 ${
                                          moment().isAfter(
                                            moment(
                                              `${meetingData?.date} ${meetingData?.start_time}`,
                                              "YYYY-MM-DD HH:mm"
                                            )
                                          )
                                            ? "late"
                                            : "future"
                                        }`}
                                        // style={{ padding: "3px 8px 3px 8px" }}
                                      >
                                        {moment().isAfter(
                                          moment(
                                            `${meetingData?.date} ${meetingData?.start_time}`,
                                            "YYYY-MM-DD HH:mm"
                                          )
                                        )
                                          ? t("badge.late")
                                          : t("badge.future")}
                                      </span>
                                    )}
                                    {meetingData?.status === "in_progress" && (
                                      // <span className="mx-2 badge status-badge-inprogress1">
                                      <span
                                        className={`${
                                          meetingData?.steps?.some(
                                            (moment) =>
                                              moment?.step_status ===
                                                "in_progress" &&
                                              convertTimeTakenToSeconds(
                                                moment?.time_taken
                                              ) >
                                                convertCount2ToSeconds(
                                                  moment?.count2,
                                                  moment?.time_unit
                                                )
                                          )
                                            ? "status-badge-red1"
                                            : "status-badge-inprogress1"
                                        } mx-2 badge h-100`}
                                      >
                                        {t("badge.inprogress")}
                                      </span>
                                    )}
                                    {meetingData?.status === "closed" && (
                                      <span className="mx-2 badge inprogrss h-100">
                                        {t("badge.finished")}
                                      </span>
                                    )}
                                    {meetingData?.status === "abort" && (
                                      <span className="mx-2 badge late h-100">
                                        {t("badge.cancel")}
                                      </span>
                                    )}
                                    {allMeetings?.filter(
                                      (item) =>
                                        Number(item?.id) !== Number(meetId)
                                    )?.length > 0 ? (
                                      <span>
                                        <MdKeyboardArrowDown
                                          size={30}
                                          onClick={toggleDropdown}
                                          style={{
                                            cursor: "pointer",
                                            // marginLeft: ".6rem",
                                            marginBottom: "6px",
                                          }}
                                        />
                                      </span>
                                    ) : null}
                                  </div>
                                  {dropdownVisible && (
                                    <div className="dropdown-content-filter">
                                      <div className="dropdown-section">
                                        {allMeetings
                                          // ?.filter((item) => item.id !== meetId)
                                          ?.filter(
                                            (item) =>
                                              item.id.toString() !==
                                              meetId.toString()
                                          )
                                          ?.map((item, index) => {
                                            return (
                                              <>
                                                <div
                                                  key={index}
                                                  onClick={() =>
                                                    applyFilter(item)
                                                  }
                                                  style={{ cursor: "pointer" }}
                                                >
                                                  <b>{item.title_order}</b>
                                                  .&nbsp; {item.title}
                                                </div>
                                              </>
                                            );
                                          })}
                                      </div>
                                    </div>
                                  )}
                                </div>

                                <div className="d-flex align-items-center gap-4 items mt-0 mt-md-2 audio-items">
                                  <div className="type">
                                    <svg
                                      width="20"
                                      height="20"
                                      viewBox="0 0 16 16"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M8.33333 2.99984C8.33333 3.3665 8.20289 3.6805 7.942 3.94184C7.68111 4.20317 7.36711 4.33362 7 4.33317C6.85556 4.33317 6.72222 4.31362 6.6 4.2745C6.47778 4.23539 6.35556 4.17162 6.23333 4.08317C5.96667 4.17206 5.75289 4.33317 5.592 4.5665C5.43111 4.79984 5.35044 5.05539 5.35 5.33317H14L13.3333 9.99984H10.0667V8.6665H12.1833C12.2389 8.33317 12.2862 7.99984 12.3253 7.6665C12.3644 7.33317 12.4116 6.99984 12.4667 6.6665H3.53333C3.58889 6.99984 3.63622 7.33317 3.67533 7.6665C3.71444 7.99984 3.76156 8.33317 3.81667 8.6665H5.93333V9.99984H2.66667L2 5.33317H4C4 4.78873 4.15 4.29428 4.45 3.84984C4.75 3.40539 5.15556 3.07762 5.66667 2.8665C5.7 2.52206 5.84444 2.23606 6.1 2.0085C6.35556 1.78095 6.65556 1.66695 7 1.6665C7.36667 1.6665 7.68067 1.79717 7.942 2.0585C8.20333 2.31984 8.33378 2.63362 8.33333 2.99984ZM6.51667 12.6665H9.48333L9.86667 8.6665H6.13333L6.51667 12.6665ZM5.33333 13.9998L4.83333 8.79984C4.78889 8.41095 4.9 8.06939 5.16667 7.77517C5.43333 7.48095 5.76111 7.33362 6.15 7.33317H9.85C10.2389 7.33317 10.5667 7.4805 10.8333 7.77517C11.1 8.06984 11.2111 8.41139 11.1667 8.79984L10.6667 13.9998H5.33333Z"
                                        fill="#8590A3"
                                      />
                                    </svg>
                                    {/* <span className="time">{meeting?.type}</span> */}
                                    <span className="time">
                                      {meetingData?.solution
                                        ? meetingData?.solution?.title
                                        : meetingData?.type ===
                                          "Google Agenda Event"
                                        ? "Google Agenda Event"
                                        : meetingData?.type === "Special"
                                        ? "Media"
                                        : meetingData?.type ===
                                          "Prise de contact"
                                        ? "Prise de contact"
                                        : t(`types.${meetingData?.type}`)}
                                    </span>
                                  </div>
                                  {/* <div className="priority">
                                    <svg
                                      width="20"
                                      height="20"
                                      viewBox="0 0 16 16"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M12.346 6.79075C12.3618 6.77463 12.3808 6.76199 12.4018 6.75362C12.4228 6.74526 12.4453 6.74137 12.4679 6.74218C12.4905 6.743 12.5126 6.74851 12.533 6.75836C12.5533 6.76821 12.5714 6.78219 12.586 6.79941C13.4616 7.83748 13.9592 9.1419 13.9973 10.4994C13.9978 10.5213 13.9938 10.543 13.9857 10.5633C13.9776 10.5835 13.9656 10.602 13.9502 10.6175C13.9349 10.6331 13.9165 10.6454 13.8964 10.6537C13.8762 10.6621 13.8545 10.6663 13.8327 10.6661H10.8293C10.7849 10.6653 10.7424 10.6476 10.7104 10.6167C10.6785 10.5857 10.6595 10.5438 10.6573 10.4994C10.627 10.0165 10.4657 9.5509 10.1907 9.15275C10.167 9.11952 10.1557 9.07907 10.1588 9.0384C10.1618 8.99773 10.179 8.95941 10.2073 8.93008L12.346 6.79075ZM11.866 6.07941C11.9393 6.14075 11.9427 6.25141 11.8753 6.31941L9.73532 8.45875C9.70603 8.48691 9.66784 8.50399 9.62732 8.50703C9.5868 8.51007 9.54649 8.49889 9.51332 8.47541C9.20249 8.26075 8.84958 8.11463 8.47799 8.04675C8.43781 8.03991 8.4013 8.01924 8.37475 7.98831C8.34821 7.95739 8.33332 7.91816 8.33265 7.87741V4.85208C8.33265 4.75608 8.41265 4.68008 8.50865 4.68808C9.74476 4.79382 10.9177 5.27947 11.866 6.07941ZM7.66599 4.85275C7.66625 4.8301 7.66178 4.80765 7.65287 4.78684C7.64395 4.76602 7.63079 4.74729 7.61423 4.73186C7.59766 4.71642 7.57805 4.70461 7.55666 4.69719C7.53526 4.68976 7.51256 4.68689 7.48999 4.68875C6.25395 4.7943 5.08102 5.28038 4.13265 6.08008C4.11544 6.09471 4.10146 6.11276 4.0916 6.1331C4.08175 6.15343 4.07624 6.17559 4.07542 6.19817C4.07461 6.22075 4.0785 6.24325 4.08687 6.26424C4.09523 6.28523 4.10787 6.30424 4.12399 6.32008L6.26399 8.45941C6.29315 8.48781 6.33137 8.50505 6.37196 8.5081C6.41255 8.51114 6.45292 8.49981 6.48599 8.47608C6.7968 8.2614 7.14972 8.11528 7.52132 8.04741C7.56149 8.04057 7.59801 8.0199 7.62455 7.98898C7.65109 7.95806 7.66599 7.91883 7.66665 7.87808L7.66599 4.85275ZM5.80865 9.15275C5.83205 9.11951 5.84311 9.07915 5.83995 9.03862C5.83679 8.9981 5.81959 8.95995 5.79132 8.93075L3.65199 6.79075C3.63611 6.77467 3.61705 6.76207 3.59604 6.75377C3.57502 6.74546 3.55251 6.74163 3.52993 6.74251C3.50735 6.74338 3.4852 6.74896 3.46489 6.75887C3.44459 6.76878 3.42657 6.78282 3.41199 6.80008C2.53685 7.83833 2.03977 9.14273 2.00199 10.5001C2.00154 10.5219 2.00546 10.5435 2.01351 10.5638C2.02156 10.584 2.03358 10.6024 2.04886 10.618C2.06415 10.6335 2.08238 10.6458 2.1025 10.6542C2.12261 10.6626 2.1442 10.6668 2.16599 10.6667H5.16932C5.26132 10.6667 5.33599 10.5927 5.34132 10.5001C5.37132 10.0154 5.53465 9.54941 5.80799 9.15341"
                                        fill="#8590A3"
                                        fill-opacity="0.25"
                                      />
                                      <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M8.33203 7.87077C8.33203 7.95477 8.3947 8.02477 8.47737 8.0401C8.85073 8.10802 9.20529 8.25485 9.51737 8.47077C9.55067 8.49434 9.59116 8.50551 9.63183 8.50234C9.67251 8.49918 9.71079 8.48187 9.74004 8.45344L12.3467 5.84677C12.3628 5.83102 12.3756 5.8121 12.384 5.79119C12.3925 5.77029 12.3966 5.74786 12.3959 5.72531C12.3953 5.70276 12.39 5.68059 12.3804 5.66019C12.3708 5.63979 12.357 5.6216 12.34 5.60677C11.2636 4.6834 9.92079 4.12735 8.5067 4.01944C8.48426 4.01788 8.46174 4.02097 8.44055 4.02851C8.41936 4.03606 8.39996 4.04791 8.38356 4.0633C8.36717 4.0787 8.35412 4.09732 8.34526 4.11799C8.33639 4.13866 8.33189 4.16094 8.33203 4.18344V7.87077Z"
                                        fill="#8590A3"
                                      />
                                    </svg>
                                    <span className="time">
                                      {t(
                                        `meeting.newMeeting.options.priorities.${meetingData?.priority}`
                                      )}
                                    </span>
                                  </div> */}

                                  {/* {!["Task", "Newsletter", "Special"].includes(
                                                    meeting?.type
                                                  ) &&
                                                    (audioLoading ? (
                                                      <div style={{ width: "20%", margin: "20px 0" }}>
                                                        <ProgressBar animated now={45} />
                                                      </div>
                                                    ) : (
                                                      <audio controls src={meetingAudio}>
                                                      Your browser does not support the audio
                                                      element.
                                                    </audio>
                                                    ))} */}
                                </div>

                                <div className="mt-3 d-flex align-items-center gap-2 content-body">
                                  <div className="d-flex align-items-center gap-2 ps-1">
                                    <img
                                      src="/Assets/invite-date.svg"
                                      width="28px"
                                      height="28px"
                                    />

                                    {meetingData?.type === "Action" ||
                                    meetingData?.type === "Newsletter" ||
                                    meetingData?.type === "Strategy" ? (
                                      <>
                                        <span className="fw-bold formate-date">
                                          {formattedDate}
                                          &nbsp; -
                                        </span>
                                        <span className="fw-bold formate-date">
                                          {formattedEndDateInHours}
                                        </span>
                                      </>
                                    ) : meetingData?.type === "Special" ||
                                      meetingData?.type === "Law" ? (
                                      <>
                                        <span className="fw-bold formate-date">
                                          {formattedDate}
                                          &nbsp; {t("at")}
                                        </span>
                                        <span className="fw-bold formate-date">
                                          {convertTo12HourFormat(
                                            meetingData?.start_time,
                                            meetingData?.date,
                                            meetingData?.steps,
                                            meetingData?.timezone
                                          )}{" "}
                                          -{" "}
                                        </span>
                                        <span className="fw-bold formate-date">
                                          {estimateDate}
                                          &nbsp; {t("at")}
                                        </span>
                                        <span className="fw-bold formate-date">
                                          {/* {newTime} */}
                                          {specialMeetingEndTime(
                                            meetingData?.start_time,
                                            meetingData?.date,
                                            meetingData?.steps,
                                            meetingData?.timezone
                                          )}
                                        </span>
                                      </>
                                    ) : (
                                      <>
                                        <span className="fw-bold formate-date">
                                          {formattedDate}
                                          &nbsp; {t("at")}
                                        </span>
                                        <span className="fw-bold formate-date">
                                          {convertTo12HourFormat(
                                            meetingData?.starts_at ||
                                              meetingData?.start_time,
                                            meetingData?.date,
                                            meetingData?.steps,
                                            meetingData?.timezone
                                          )}{" "}
                                          -{" "}
                                        </span>
                                        <span className="fw-bold formate-date">
                                          {formattedEndDateInHours}
                                          &nbsp; {t("at")}
                                        </span>
                                        <span className="fw-bold formate-date">
                                          {estimateTime}
                                        </span>
                                      </>
                                    )}

                                    <span className="fw-bold">
                                      {getTimezoneSymbol(
                                        localStorage.getItem("timezone")
                                      )}
                                    </span>
                                  </div>
                                </div>

                                <div className="ps-2 ps-md-4 ps-lg-0">
                                  {(meetingData?.location &&
                                    meetingData?.location !== "None") ||
                                  (meetingData?.agenda &&
                                    meetingData?.agenda !== "None") ? (
                                    <div className="d-flex gap-4 align-items-center mt-2 mb-2">
                                      {meetingData?.location &&
                                        meetingData?.location !== "None" && (
                                          <p className="d-flex gap-2 justify-content-start ps-0 fw-bold align-items-center mb-0">
                                            <span>
                                              <svg
                                                width="28px"
                                                height="28px"
                                                viewBox="0 0 32 32"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <g
                                                  id="SVGRepo_bgCarrier"
                                                  stroke-width="0"
                                                ></g>
                                                <g
                                                  id="SVGRepo_tracerCarrier"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                ></g>
                                                <g id="SVGRepo_iconCarrier">
                                                  {" "}
                                                  <path
                                                    d="M2 11.9556C2 8.47078 2 6.7284 2.67818 5.39739C3.27473 4.22661 4.22661 3.27473 5.39739 2.67818C6.7284 2 8.47078 2 11.9556 2H20.0444C23.5292 2 25.2716 2 26.6026 2.67818C27.7734 3.27473 28.7253 4.22661 29.3218 5.39739C30 6.7284 30 8.47078 30 11.9556V20.0444C30 23.5292 30 25.2716 29.3218 26.6026C28.7253 27.7734 27.7734 28.7253 26.6026 29.3218C25.2716 30 23.5292 30 20.0444 30H11.9556C8.47078 30 6.7284 30 5.39739 29.3218C4.22661 28.7253 3.27473 27.7734 2.67818 26.6026C2 25.2716 2 23.5292 2 20.0444V11.9556Z"
                                                    fill="white"
                                                  ></path>{" "}
                                                  <path
                                                    d="M5 23.5601C5 24.3557 5.64998 25.0001 6.45081 25.0001H6.47166C5.65857 25.0001 5 24.3557 5 23.5601Z"
                                                    fill="#FBBC05"
                                                  ></path>{" "}
                                                  <path
                                                    d="M17.4678 12.4V16.1596L22.5364 12.0712V8.43999C22.5364 7.6444 21.8864 7 21.0856 7H10.1045L10.0947 12.4H17.4678Z"
                                                    fill="#FBBC05"
                                                  ></path>{" "}
                                                  <path
                                                    d="M17.4671 19.9207H10.0818L10.0732 25.0003H21.085C21.887 25.0003 22.5358 24.3559 22.5358 23.5603V20.2819L17.4671 16.1611V19.9207Z"
                                                    fill="#34A853"
                                                  ></path>{" "}
                                                  <path
                                                    d="M10.1042 7L5 12.4H10.0956L10.1042 7Z"
                                                    fill="#EA4335"
                                                  ></path>{" "}
                                                  <path
                                                    d="M5 19.9204V23.56C5 24.3556 5.65857 25 6.47166 25H10.0736L10.0821 19.9204H5Z"
                                                    fill="#1967D2"
                                                  ></path>{" "}
                                                  <path
                                                    d="M10.0956 12.3999H5V19.9203H10.0821L10.0956 12.3999Z"
                                                    fill="#4285F4"
                                                  ></path>{" "}
                                                  <path
                                                    d="M26.9926 22.2796V9.9197C26.7068 8.27931 24.9077 10.1597 24.9077 10.1597L22.5371 12.0713V20.2804L25.9305 23.0392C27.1557 23.2 26.9926 22.2796 26.9926 22.2796Z"
                                                    fill="#34A853"
                                                  ></path>{" "}
                                                  <path
                                                    d="M17.4678 16.1594L22.5377 20.2814V12.0723L17.4678 16.1594Z"
                                                    fill="#188038"
                                                  ></path>{" "}
                                                </g>
                                              </svg>
                                            </span>
                                            <span className="solutioncards option-text">
                                              {
                                                meetingData?.user
                                                  ?.google_full_name
                                              }
                                            </span>
                                          </p>
                                        )}
                                      {meetingData?.agenda &&
                                        meetingData?.agenda !== "None" && (
                                          <p className="d-flex gap-2 justify-content-start ps-0 fw-bold align-items-center mb-0">
                                            <span>
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                aria-label="Google Calendar"
                                                role="img"
                                                viewBox="0 0 512 512"
                                                width="28px"
                                                height="28px"
                                                fill="#000000"
                                              >
                                                <g
                                                  id="SVGRepo_bgCarrier"
                                                  stroke-width="0"
                                                ></g>
                                                <g
                                                  id="SVGRepo_tracerCarrier"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                ></g>
                                                <g id="SVGRepo_iconCarrier">
                                                  <rect
                                                    width="512"
                                                    height="512"
                                                    rx="15%"
                                                    fill="#ffffff"
                                                  ></rect>
                                                  <path
                                                    d="M100 340h74V174H340v-74H137Q100 100 100 135"
                                                    fill="#4285f4"
                                                  ></path>
                                                  <path
                                                    d="M338 100v76h74v-41q0-35-35-35"
                                                    fill="#1967d2"
                                                  ></path>
                                                  <path
                                                    d="M338 174h74V338h-74"
                                                    fill="#fbbc04"
                                                  ></path>
                                                  <path
                                                    d="M100 338v39q0 35 35 35h41v-74"
                                                    fill="#188038"
                                                  ></path>
                                                  <path
                                                    d="M174 338H338v74H174"
                                                    fill="#34a853"
                                                  ></path>
                                                  <path
                                                    d="M338 412v-74h74"
                                                    fill="#ea4335"
                                                  ></path>
                                                  <path
                                                    d="M204 229a25 22 1 1 1 25 27h-9h9a25 22 1 1 1-25 27M270 231l27-19h4v-7V308"
                                                    stroke="#4285f4"
                                                    stroke-width="15"
                                                    stroke-linejoin="bevel"
                                                    fill="none"
                                                  ></path>
                                                </g>
                                              </svg>
                                            </span>
                                            <span className="solutioncards option-text">
                                              {
                                                meetingData?.user
                                                  ?.google_full_name
                                              }
                                            </span>
                                          </p>
                                        )}
                                    </div>
                                  ) : null}
                                  <div className="ps-0">
                                    {meetingData?.address ? (
                                      <p className="d-flex gap-2 align-items-center justify-content-start ps-0 ms-0 mt-2">
                                        <FaLocationDot size={25} />
                                        <span>{meetingData?.address}</span>
                                      </p>
                                    ) : null}
                                  </div>
                                  {meetingData?.room_details ? (
                                    <div>
                                      <p className="d-flex gap-2 mt-2 justify-content-start align-items-top ps-0">
                                        <BsPersonWorkspace size={25} />
                                        <p className="m-0">
                                          {meetingData?.room_details &&
                                            meetingData?.room_details}
                                        </p>
                                      </p>
                                    </div>
                                  ) : null}
                                  {meetingData?.phone ? ( // Check if the phone field exists
                                    <div>
                                      <p className="d-flex gap-2 align-items-center justify-content-start ps-0 mt-2">
                                        <span>
                                          <FaPhoneAlt size={25} />
                                        </span>
                                        <a
                                          href={`tel:${meetingData.phone}`}
                                          className="text-decoration-none"
                                        >
                                          <span className="">
                                            {meetingData.phone}
                                          </span>{" "}
                                          {/* Display the phone number */}
                                        </a>
                                      </p>
                                    </div>
                                  ) : null}
                                </div>

                                {/* Options */}
                                <div className="row mt-2">
                                  <div className="col-md-12 d-flex align-items-center gap-3">
                                    {meetingData?.prise_de_notes ===
                                      "Automatic" && (
                                      <>
                                        <div>
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="28"
                                            height="28"
                                            viewBox="0 0 28 28"
                                            fill="none"
                                          >
                                            <g filter="url(#filter0_d_1_1154)">
                                              <circle
                                                cx="14"
                                                cy="12"
                                                r="10"
                                                stroke="url(#paint0_linear_1_1154)"
                                                strokeWidth="4"
                                              />
                                            </g>
                                            <defs>
                                              <filter
                                                id="filter0_d_1_1154"
                                                x="0"
                                                y="0"
                                                width="28"
                                                height="28"
                                                filterUnits="userSpaceOnUse"
                                                colorInterpolationFilters="sRGB"
                                              >
                                                <feFlood
                                                  floodOpacity="0"
                                                  result="BackgroundImageFix"
                                                />
                                                <feColorMatrix
                                                  in="SourceAlpha"
                                                  type="matrix"
                                                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                                  result="hardAlpha"
                                                />
                                                <feOffset dy="2" />
                                                <feGaussianBlur stdDeviation="1" />
                                                <feColorMatrix
                                                  type="matrix"
                                                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
                                                />
                                                <feBlend
                                                  mode="normal"
                                                  in2="BackgroundImageFix"
                                                  result="effect1_dropShadow_1_1154"
                                                />
                                                <feBlend
                                                  mode="normal"
                                                  in="SourceGraphic"
                                                  in2="effect1_dropShadow_1_1154"
                                                  result="shape"
                                                />
                                              </filter>
                                              <linearGradient
                                                id="paint0_linear_1_1154"
                                                x1="14"
                                                y1="0"
                                                x2="20.375"
                                                y2="21.75"
                                                gradientUnits="userSpaceOnUse"
                                              >
                                                <stop stopColor="#B11FAB" />
                                                <stop
                                                  offset="0.514"
                                                  stopColor="#56E8F1"
                                                />
                                                <stop
                                                  offset="1"
                                                  stopColor="#2F47C1"
                                                />
                                              </linearGradient>
                                            </defs>
                                          </svg>
                                          <span className="solutioncards option-text">
                                            {t(
                                              "meeting.formState.Automatic note taking"
                                            )}
                                          </span>
                                        </div>
                                      </>
                                    )}
                                    {meetingData?.note_taker === true && (
                                      <>
                                        <div className="d-flex align-items-center gap-2">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="28px"
                                            height="28px"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="#3D57B5"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          >
                                            <g
                                              id="SVGRepo_bgCarrier"
                                              stroke-width="0"
                                            ></g>
                                            <g
                                              id="SVGRepo_tracerCarrier"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                            ></g>
                                            <g id="SVGRepo_iconCarrier">
                                              {" "}
                                              <rect
                                                x="3"
                                                y="11"
                                                width="18"
                                                height="10"
                                                rx="2"
                                              ></rect>{" "}
                                              <circle
                                                cx="12"
                                                cy="5"
                                                r="2"
                                              ></circle>{" "}
                                              <path d="M12 7v4"></path>{" "}
                                              <line
                                                x1="8"
                                                y1="16"
                                                x2="8"
                                                y2="16"
                                              ></line>{" "}
                                              <line
                                                x1="16"
                                                y1="16"
                                                x2="16"
                                                y2="16"
                                              ></line>{" "}
                                            </g>
                                          </svg>
                                          <span className="solutioncards option-text">
                                            {t("meeting.formState.Note Taker")}
                                          </span>
                                        </div>
                                      </>
                                    )}

                                    {meetingData?.alarm === true && (
                                      <>
                                        <div>
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="25"
                                            height="24"
                                            viewBox="0 0 25 24"
                                            fill="none"
                                          >
                                            <path
                                              fill-rule="evenodd"
                                              clip-rule="evenodd"
                                              d="M12.5001 1.35999C12.2879 1.35999 12.0844 1.44427 11.9344 1.5943C11.7844 1.74433 11.7001 1.94781 11.7001 2.15999V5.63519C11.7001 5.84736 11.7844 6.05084 11.9344 6.20087C12.0844 6.3509 12.2879 6.43519 12.5001 6.43519C12.7122 6.43519 12.9157 6.3509 13.0658 6.20087C13.2158 6.05084 13.3001 5.84736 13.3001 5.63519V2.99519C15.3173 3.17457 17.2159 4.02613 18.6915 5.41333C20.167 6.80054 21.134 8.64304 21.4373 10.6454C21.7407 12.6478 21.363 14.694 20.3646 16.4561C19.3662 18.2181 17.8051 19.5939 15.9315 20.3628C14.058 21.1317 11.9805 21.2492 10.0321 20.6965C8.08379 20.1437 6.37749 18.9528 5.1868 17.3145C3.99611 15.6763 3.39001 13.6857 3.46567 11.6619C3.54134 9.63811 4.29438 7.69833 5.60407 6.15358C5.67546 6.07402 5.73018 5.98095 5.765 5.87989C5.79981 5.77882 5.81402 5.6718 5.80678 5.56514C5.79954 5.45849 5.771 5.35437 5.72285 5.25893C5.67469 5.1635 5.6079 5.07868 5.52641 5.00949C5.44493 4.9403 5.3504 4.88815 5.24842 4.8561C5.14644 4.82406 5.03907 4.81278 4.93265 4.82293C4.82624 4.83308 4.72293 4.86446 4.62885 4.91521C4.53476 4.96595 4.4518 5.03504 4.38487 5.11839C2.81701 6.96726 1.92749 9.29609 1.86357 11.7194C1.79964 14.1427 2.56513 16.5152 4.03333 18.4442C5.50153 20.3731 7.58441 21.7429 9.9372 22.3268C12.29 22.9106 14.7716 22.6736 16.9713 21.6548C19.171 20.6361 20.9569 18.8967 22.0333 16.7247C23.1098 14.5526 23.4122 12.0781 22.8907 9.71074C22.3691 7.34336 21.0548 5.22506 19.1652 3.70646C17.2757 2.18787 14.9242 1.36003 12.5001 1.35999ZM11.2841 12.928L7.25847 7.31679C7.20487 7.23976 7.18006 7.14634 7.18838 7.05287C7.19669 6.9594 7.23761 6.87183 7.30396 6.80548C7.37031 6.73912 7.45789 6.69821 7.55135 6.68989C7.64482 6.68158 7.73824 6.70639 7.81527 6.75999L13.4297 10.784C13.6103 10.914 13.7605 11.0818 13.8699 11.2757C13.9793 11.4695 14.0453 11.6848 14.0632 11.9067C14.0812 12.1286 14.0507 12.3517 13.9738 12.5606C13.897 12.7695 13.7757 12.9592 13.6183 13.1166C13.4609 13.274 13.2712 13.3953 13.0623 13.4722C12.8534 13.549 12.6303 13.5795 12.4084 13.5615C12.1865 13.5436 11.9712 13.4776 11.7773 13.3682C11.5835 13.2588 11.4157 13.1086 11.2857 12.928"
                                              fill="#3D57B5"
                                            />
                                          </svg>
                                          <span
                                            className="solutioncards"
                                            style={{ color: "#3D57B5" }}
                                          >
                                            {t("meeting.formState.Beep alarm")}
                                          </span>
                                        </div>
                                      </>
                                    )}

                                    {/* {meetingData?.share_by === "email" && (
                                      <>
                                        <div>
                                          <span>
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="0 0 30 30"
                                              width="30px"
                                              height="30px"
                                            >
                                              <path
                                                d="M 23 3 A 4 4 0 0 0 19 7 A 4 4 0 0 0 19.09375 7.8359375 L 10.011719 12.376953 A 4 4 0 0 0 7 11 A 4 4 0 0 0 3 15 A 4 4 0 0 0 7 19 A 4 4 0 0 0 10.013672 17.625 L 19.089844 22.164062 A 4 4 0 0 0 19 23 A 4 4 0 0 0 23 27 A 4 4 0 0 0 27 23 A 4 4 0 0 0 23 19 A 4 4 0 0 0 19.986328 20.375 L 10.910156 15.835938 A 4 4 0 0 0 11 15 A 4 4 0 0 0 10.90625 14.166016 L 19.988281 9.625 A 4 4 0 0 0 23 11 A 4 4 0 0 0 27 7 A 4 4 0 0 0 23 3 z"
                                                fill="#3D57B5"
                                              />
                                            </svg>
                                          </span>
                                          {t("Shareby")}
                                        </div>
                                      </>
                                    )} */}
                                  </div>
                                </div>

                                {/* Casting Type */}

                                {/* Privacy */}
                                <div className="row ">
                                  <div className="col-md-12 mt-2 ms-1 d-flex align-items-center gap-3">
                                    <span
                                      style={{
                                        fontFamily: "Inter",
                                        fontSize: "12px",
                                        fontWeight: 400,
                                        lineHeight: "14.52px",
                                        textAlign: "left",
                                        color: "#8590a3",
                                      }}
                                    >
                                      {t("Privacy")}:
                                    </span>
                                    <div className="">
                                      <div className="d-flex align-items-center flex-wrap">
                                        {meetingData?.moment_privacy ===
                                        "public" ? (
                                          <Avatar
                                            src="/Assets/Tek.png"
                                            style={{ borderRadius: "0" }}
                                          />
                                        ) : meetingData?.moment_privacy ===
                                          "team" ? (
                                          <Avatar.Group>
                                            {meetingData?.moment_privacy_teams_data?.map(
                                              (item) => {
                                                return (
                                                  <>
                                                    <Tooltip
                                                      title={item?.name}
                                                      placement="top"
                                                    >
                                                      <Avatar
                                                        size="large"
                                                        src={
                                                          item?.logo?.startsWith(
                                                            "http"
                                                          )
                                                            ? item.logo
                                                            : Assets_URL +
                                                              "/" +
                                                              item.logo
                                                        }
                                                      />
                                                    </Tooltip>
                                                  </>
                                                );
                                              }
                                            )}
                                          </Avatar.Group>
                                        ) : meetingData?.moment_privacy ===
                                          "participant only" ? (
                                          <Avatar.Group>
                                            {meetingData?.user_with_participants?.map(
                                              (item) => {
                                                return (
                                                  <>
                                                    <AntdTooltip
                                                      title={item?.full_name}
                                                      placement="top"
                                                    >
                                                      <Avatar
                                                        size="large"
                                                        src={
                                                          item?.participant_image?.startsWith(
                                                            "http"
                                                          )
                                                            ? item.participant_image
                                                            : Assets_URL +
                                                              "/" +
                                                              item.participant_image
                                                        }
                                                      />
                                                    </AntdTooltip>
                                                  </>
                                                );
                                              }
                                            )}
                                          </Avatar.Group>
                                        ) : meetingData?.moment_privacy ===
                                          "tektime members" ? null : //   title={meeting?.user?.enterprise?.name} // <Tooltip
                                        //   placement="top"
                                        // >
                                        //   <img
                                        //     src={
                                        //       meeting?.user?.enterprise?.logo?.startsWith(
                                        //         "http"
                                        //       )
                                        //         ? meeting?.user?.enterprise?.logo
                                        //         : Assets_URL +
                                        //           "/" +
                                        //           meeting?.user?.enterprise?.logo
                                        //     }
                                        //     alt="Logo"
                                        //     style={{
                                        //       width: "30px",
                                        //       height: "30px",
                                        //       objectFit: "fill",
                                        //       borderRadius: "50%",
                                        //     }}
                                        //   />
                                        // </Tooltip>
                                        meetingData?.moment_privacy ===
                                          "enterprise" ? (
                                          <AntdTooltip
                                            title={
                                              meetingData?.user?.enterprise
                                                ?.name
                                            }
                                            placement="top"
                                          >
                                            <img
                                              src={
                                                meetingData?.user?.enterprise?.logo?.startsWith(
                                                  "http"
                                                )
                                                  ? meetingData?.user
                                                      ?.enterprise?.logo
                                                  : Assets_URL +
                                                    "/" +
                                                    meetingData?.user
                                                      ?.enterprise?.logo
                                              }
                                              alt="Logo"
                                              style={{
                                                width: "30px",
                                                height: "30px",
                                                objectFit: "fill",
                                                borderRadius: "50%",
                                              }}
                                            />
                                          </AntdTooltip>
                                        ) : meetingData?.moment_privacy ===
                                          "password" ? (
                                          <svg
                                            width="37px"
                                            height="36px"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <g
                                              id="SVGRepo_bgCarrier"
                                              stroke-width="0"
                                            ></g>
                                            <g
                                              id="SVGRepo_tracerCarrier"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                            ></g>
                                            <g id="SVGRepo_iconCarrier">
                                              {" "}
                                              <path
                                                d="M7 10.0288C7.47142 10 8.05259 10 8.8 10H15.2C15.9474 10 16.5286 10 17 10.0288M7 10.0288C6.41168 10.0647 5.99429 10.1455 5.63803 10.327C5.07354 10.6146 4.6146 11.0735 4.32698 11.638C4 12.2798 4 13.1198 4 14.8V16.2C4 17.8802 4 18.7202 4.32698 19.362C4.6146 19.9265 5.07354 20.3854 5.63803 20.673C6.27976 21 7.11984 21 8.8 21H15.2C16.8802 21 17.7202 21 18.362 20.673C18.9265 20.3854 19.3854 19.9265 19.673 19.362C20 18.7202 20 17.8802 20 16.2V14.8C20 13.1198 20 12.2798 19.673 11.638C19.3854 11.0735 18.9265 10.6146 18.362 10.327C18.0057 10.1455 17.5883 10.0647 17 10.0288M7 10.0288V8C7 5.23858 9.23858 3 12 3C14.7614 3 17 5.23858 17 8V10.0288"
                                                stroke="#000000"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                              ></path>{" "}
                                            </g>
                                          </svg>
                                        ) : (
                                          <AntdTooltip
                                            title={meetingData?.user?.full_name}
                                            placement="top"
                                          >
                                            <Avatar
                                              src={
                                                meetingData?.user?.image.startsWith(
                                                  "users/"
                                                )
                                                  ? Assets_URL +
                                                    "/" +
                                                    meetingData?.user?.image
                                                  : meetingData?.user?.image
                                              }
                                            />
                                          </AntdTooltip>
                                        )}

                                        <span
                                          className={`badge ms-2 ${
                                            meetingData?.moment_privacy ===
                                            "private"
                                              ? "solution-badge-red"
                                              : meetingData?.moment_privacy ===
                                                "public"
                                              ? "solution-badge-green"
                                              : meetingData?.moment_privacy ===
                                                  "enterprise" ||
                                                meetingData?.moment_privacy ===
                                                  "participant only" ||
                                                meetingData?.moment_privacy ===
                                                  "tektime members"
                                              ? "solution-badge-blue"
                                              : meetingData?.moment_privacy ===
                                                "password"
                                              ? "solution-badge-red"
                                              : "solution-badge-yellow"
                                          }`}
                                          style={{ padding: "3px 8px 3px 8px" }}
                                        >
                                          {meetingData?.moment_privacy ===
                                          "private"
                                            ? t("solution.badge.private")
                                            : meetingData?.moment_privacy ===
                                              "public"
                                            ? t("solution.badge.public")
                                            : meetingData?.moment_privacy ===
                                              "enterprise"
                                            ? t("solution.badge.enterprise")
                                            : meetingData?.moment_privacy ===
                                              "participant only"
                                            ? t(
                                                "solution.badge.participantOnly"
                                              )
                                            : meetingData?.moment_privacy ===
                                              "tektime members"
                                            ? t("solution.badge.membersOnly")
                                            : meetingData?.moment_privacy ===
                                              "password"
                                            ? t("solution.badge.password")
                                            : t("solution.badge.team")}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="row px-3 px-lg-0 report-row">
                              {show ? (
                                <div
                                  style={{
                                    background: "white",
                                    padding: "29px 13px",
                                  }}
                                >
                                  <div className="paragraph-parent">
                                    <h3 className="moment-summary">
                                      <IoArrowBackSharp
                                        onClick={handleHide}
                                        size={25}
                                        style={{
                                          cursor: "pointer",
                                          marginRight: "1rem",
                                        }}
                                      />
                                      {t("momentsSummary")}
                                    </h3>
                                  </div>
                                  <ParticipantCardProfile
                                    userId={uuid}
                                    handleHide={handleHide}
                                    isUser={isUser}
                                  />
                                </div>
                              ) : (
                                <>
                                  <div className="col-md-8">
                                    {meetingData?.description && (
                                      <div className="paragraph-parent">
                                        <h3 className="moment-summary">
                                          {t("momentsSummary")}
                                        </h3>
                                        <p className="paragraph paragraph-images">
                                          {/* {meetingData?.description} */}
                                          <div
                                            dangerouslySetInnerHTML={{
                                              __html:
                                                meetingData?.description || "",
                                            }}
                                          />
                                        </p>
                                      </div>
                                    )}
                                  </div>
                                  <div className="col-md-4">
                                    <div style={{ marginTop: "6rem" }}>
                                      <span className="participant-heading">
                                        {meetingData?.guides?.length > 1
                                          ? "Guides"
                                          : "Guide"}
                                      </span>
                                      {meetingData?.type === "Newsletter" && (
                                        <Card className="mt-4 participant-card">
                                          <Card.Body className="d-flex justify-content-between align-items-center">
                                            <div className="d-flex align-items-center gap-3">
                                              <div className="profile-logo">
                                                <Card.Img
                                                  className="user-img"
                                                  src={
                                                    meetingData?.user?.image?.startsWith(
                                                      "users/"
                                                    )
                                                      ? Assets_URL +
                                                        "/" +
                                                        meetingData?.user?.image
                                                      : meetingData?.user?.image
                                                  }
                                                />
                                                <Card.Img
                                                  className="logout-icon"
                                                  src="/Assets/Avatar_company.svg"
                                                  height="15px"
                                                  width="15px"
                                                  alt="tektime"
                                                />
                                              </div>

                                              <div className="d-flex flex-column align-items-start">
                                                <Card.Title className="text-center mt-4 card-heading">
                                                  {meetingData?.user?.name +
                                                    " " +
                                                    meetingData?.user
                                                      ?.last_name}
                                                </Card.Title>
                                                <Card.Subtitle className="mb-2 card-subtext">
                                                  {meetingData?.user?.post}
                                                </Card.Subtitle>
                                                <Card.Subtitle className="mb-2 card-subtext">
                                                  {meetingData?.user?.teams?.map(
                                                    (item) => item.name
                                                  )}
                                                </Card.Subtitle>
                                                <div
                                                  className="visiting-card-link"
                                                  onClick={() => {
                                                    handleProfile(
                                                      meetingData?.user
                                                        ?.nick_name
                                                    );
                                                    setIsUser(true);
                                                  }}
                                                >
                                                  {t("viewVisitingCard")} &nbsp;{" "}
                                                  <FaArrowRight />
                                                </div>
                                              </div>
                                            </div>
                                            <div>
                                              <svg
                                                width="21"
                                                height="21"
                                                viewBox="0 0 21 21"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <path
                                                  d="M15.4965 9.99542C18.534 9.99542 20.9965 12.4578 20.9965 15.4954C20.9965 18.5329 18.534 20.9954 15.4965 20.9954C12.4589 20.9954 9.99649 18.5329 9.99649 15.4954C9.99649 12.4578 12.4589 9.99542 15.4965 9.99542ZM10.0187 11.9947C9.37159 13.0051 8.99649 14.2064 8.99649 15.4954C8.99649 17.1257 9.59669 18.6158 10.5882 19.7569C9.79269 19.917 8.92779 19.9964 7.99649 19.9964C4.57549 19.9964 2.05252 18.9243 0.51036 16.7599C0.1784 16.294 0 15.7362 0 15.1641V14.2442C0 13.0021 1.00685 11.9953 2.24887 11.9953L10.0187 11.9947ZM12.85 15.1418C12.6548 14.9465 12.3382 14.9465 12.1429 15.1418C11.9476 15.3371 11.9476 15.6537 12.1429 15.8489L14.1429 17.8489C14.3382 18.0442 14.6548 18.0442 14.85 17.8489L18.85 13.8489C19.0453 13.6537 19.0453 13.3371 18.85 13.1418C18.6548 12.9465 18.3382 12.9465 18.1429 13.1418L14.4965 16.7882L12.85 15.1418ZM7.99649 0C10.7579 0 12.9965 2.23858 12.9965 5C12.9965 7.76143 10.7579 10 7.99649 10C5.23503 10 2.99645 7.76143 2.99645 5C2.99645 2.23858 5.23503 0 7.99649 0Z"
                                                  fill="#58985B"
                                                />
                                              </svg>
                                            </div>
                                          </Card.Body>
                                        </Card>
                                      )}
                                    </div>

                                    <div className="">
                                      {meetingData?.created_from ===
                                      "Google Calendar" ? (
                                        meetingData?.user?.email !==
                                        meetingData?.event_creator?.email ? (
                                          <Card className="mt-4 participant-card">
                                            <Card.Body className="d-flex justify-content-between align-items-center">
                                              <div className="d-flex align-items-center gap-3">
                                                <div className="profile-logo">
                                                  {/* <Card.Img
                                                      className="user-img"
                                                      src={
                                                        guide?.participant_image?.startsWith(
                                                          "users/"
                                                        ) ||
                                                        guide?.participant_image?.startsWith(
                                                          "storage/"
                                                        )
                                                          ? Assets_URL +
                                                            "/" +
                                                            guide?.participant_image
                                                          : guide?.participant_image
                                                      }
                                                    />
                                                    <Card.Img
                                                      className="logout-icon"
                                                      src="/Assets/Avatar_company.svg"
                                                      height="15px"
                                                      width="15px"
                                                      alt="tektime"
                                                    /> */}
                                                </div>

                                                <div className="d-flex flex-column align-items-start">
                                                  <Card.Title className="text-center mt-4 card-heading">
                                                    {
                                                      meetingData?.event_creator
                                                        ?.email
                                                    }
                                                  </Card.Title>

                                                  {/* <Card.Subtitle className="mb-2 card-subtext">
                                                      {guide?.team_names
                                                        ?.map((item) => item)
                                                        .join(", ")}
                                                    </Card.Subtitle> */}
                                                  {/* {guide?.user_id && (
                                                      <div
                                                        className="visiting-card-link"
                                                        onClick={() => {
                                                          handleProfile(
                                                            guide?.id
                                                          );
                                                          setIsUser(false);
                                                        }}
                                                      >
                                                        {t("viewVisitingCard")}{" "}
                                                        &nbsp; <FaArrowRight />
                                                      </div>
                                                    )} */}
                                                </div>
                                              </div>
                                            </Card.Body>
                                          </Card>
                                        ) : (
                                          <>
                                            {meetingData?.type !==
                                              "Newsletter" &&
                                              meetingData?.guides
                                                // ?.filter((guide) => guide.isCreator !== 1)
                                                ?.map((guide, index) => (
                                                  <Card
                                                    key={index}
                                                    className="mt-4 participant-card"
                                                  >
                                                    <Card.Body className="d-flex justify-content-between align-items-center">
                                                      <div className="d-flex align-items-center gap-3">
                                                        <div className="profile-logo">
                                                          <Card.Img
                                                            className="user-img"
                                                            src={
                                                              guide?.participant_image?.startsWith(
                                                                "users/"
                                                              ) ||
                                                              guide?.participant_image?.startsWith(
                                                                "storage/"
                                                              )
                                                                ? Assets_URL +
                                                                  "/" +
                                                                  guide?.participant_image
                                                                : guide?.participant_image
                                                            }
                                                          />
                                                          <Card.Img
                                                            className="logout-icon"
                                                            src="/Assets/Avatar_company.svg"
                                                            height="15px"
                                                            width="15px"
                                                            alt="tektime"
                                                          />
                                                        </div>

                                                        <div className="d-flex flex-column align-items-start">
                                                          <Card.Title className="text-center mt-4 card-heading">
                                                            {guide?.first_name +
                                                              " " +
                                                              guide?.last_name}
                                                          </Card.Title>
                                                          <Card.Subtitle className="mb-2 card-subtext">
                                                            {guide?.post}
                                                          </Card.Subtitle>
                                                          <Card.Subtitle className="mb-2 card-subtext">
                                                            {guide?.team_names
                                                              ?.map(
                                                                (item) => item
                                                              )
                                                              .join(", ")}
                                                          </Card.Subtitle>
                                                          {guide?.user_id && (
                                                            <div
                                                              className="visiting-card-link"
                                                              onClick={() => {
                                                                handleProfile(
                                                                  guide?.id
                                                                );
                                                                setIsUser(
                                                                  false
                                                                );
                                                              }}
                                                            >
                                                              {t(
                                                                "viewVisitingCard"
                                                              )}{" "}
                                                              &nbsp;{" "}
                                                              <FaArrowRight />
                                                            </div>
                                                          )}
                                                        </div>
                                                      </div>
                                                      <div>
                                                        <svg
                                                          width="21"
                                                          height="21"
                                                          viewBox="0 0 21 21"
                                                          fill="none"
                                                          xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                          <path
                                                            d="M15.4965 9.99542C18.534 9.99542 20.9965 12.4578 20.9965 15.4954C20.9965 18.5329 18.534 20.9954 15.4965 20.9954C12.4589 20.9954 9.99649 18.5329 9.99649 15.4954C9.99649 12.4578 12.4589 9.99542 15.4965 9.99542ZM10.0187 11.9947C9.37159 13.0051 8.99649 14.2064 8.99649 15.4954C8.99649 17.1257 9.59669 18.6158 10.5882 19.7569C9.79269 19.917 8.92779 19.9964 7.99649 19.9964C4.57549 19.9964 2.05252 18.9243 0.51036 16.7599C0.1784 16.294 0 15.7362 0 15.1641V14.2442C0 13.0021 1.00685 11.9953 2.24887 11.9953L10.0187 11.9947ZM12.85 15.1418C12.6548 14.9465 12.3382 14.9465 12.1429 15.1418C11.9476 15.3371 11.9476 15.6537 12.1429 15.8489L14.1429 17.8489C14.3382 18.0442 14.6548 18.0442 14.85 17.8489L18.85 13.8489C19.0453 13.6537 19.0453 13.3371 18.85 13.1418C18.6548 12.9465 18.3382 12.9465 18.1429 13.1418L14.4965 16.7882L12.85 15.1418ZM7.99649 0C10.7579 0 12.9965 2.23858 12.9965 5C12.9965 7.76143 10.7579 10 7.99649 10C5.23503 10 2.99645 7.76143 2.99645 5C2.99645 2.23858 5.23503 0 7.99649 0Z"
                                                            fill="#58985B"
                                                          />
                                                        </svg>
                                                      </div>
                                                    </Card.Body>
                                                  </Card>
                                                ))}
                                          </>
                                        )
                                      ) : (
                                        <>
                                          {meetingData?.type !== "Newsletter" &&
                                            meetingData?.guides
                                              // ?.filter((guide) => guide.isCreator !== 1)
                                              ?.map((guide, index) => (
                                                <Card
                                                  key={index}
                                                  className="mt-4 participant-card"
                                                >
                                                  <Card.Body className="d-flex justify-content-between align-items-center">
                                                    <div className="d-flex align-items-center gap-3">
                                                      <div className="profile-logo">
                                                        <Card.Img
                                                          className="user-img"
                                                          src={
                                                            guide?.participant_image?.startsWith(
                                                              "users/"
                                                            ) ||
                                                            guide?.participant_image?.startsWith(
                                                              "storage/"
                                                            )
                                                              ? Assets_URL +
                                                                "/" +
                                                                guide?.participant_image
                                                              : guide?.participant_image
                                                          }
                                                        />
                                                        <Card.Img
                                                          className="logout-icon"
                                                          src="/Assets/Avatar_company.svg"
                                                          height="15px"
                                                          width="15px"
                                                          alt="tektime"
                                                        />
                                                      </div>

                                                      <div className="d-flex flex-column align-items-start">
                                                        <Card.Title className="text-center mt-4 card-heading">
                                                          {guide?.first_name +
                                                            " " +
                                                            guide?.last_name}
                                                        </Card.Title>
                                                        <Card.Subtitle className="mb-2 card-subtext">
                                                          {guide?.post}
                                                        </Card.Subtitle>
                                                        <Card.Subtitle className="mb-2 card-subtext">
                                                          {guide?.team_names
                                                            ?.map(
                                                              (item) => item
                                                            )
                                                            .join(", ")}
                                                        </Card.Subtitle>
                                                        {guide?.user_id && (
                                                          <div
                                                            className="visiting-card-link"
                                                            onClick={() => {
                                                              handleProfile(
                                                                guide?.id
                                                              );
                                                              setIsUser(false);
                                                            }}
                                                          >
                                                            {t(
                                                              "viewVisitingCard"
                                                            )}{" "}
                                                            &nbsp;{" "}
                                                            <FaArrowRight />
                                                          </div>
                                                        )}
                                                      </div>
                                                    </div>
                                                    <div>
                                                      <svg
                                                        width="21"
                                                        height="21"
                                                        viewBox="0 0 21 21"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                      >
                                                        <path
                                                          d="M15.4965 9.99542C18.534 9.99542 20.9965 12.4578 20.9965 15.4954C20.9965 18.5329 18.534 20.9954 15.4965 20.9954C12.4589 20.9954 9.99649 18.5329 9.99649 15.4954C9.99649 12.4578 12.4589 9.99542 15.4965 9.99542ZM10.0187 11.9947C9.37159 13.0051 8.99649 14.2064 8.99649 15.4954C8.99649 17.1257 9.59669 18.6158 10.5882 19.7569C9.79269 19.917 8.92779 19.9964 7.99649 19.9964C4.57549 19.9964 2.05252 18.9243 0.51036 16.7599C0.1784 16.294 0 15.7362 0 15.1641V14.2442C0 13.0021 1.00685 11.9953 2.24887 11.9953L10.0187 11.9947ZM12.85 15.1418C12.6548 14.9465 12.3382 14.9465 12.1429 15.1418C11.9476 15.3371 11.9476 15.6537 12.1429 15.8489L14.1429 17.8489C14.3382 18.0442 14.6548 18.0442 14.85 17.8489L18.85 13.8489C19.0453 13.6537 19.0453 13.3371 18.85 13.1418C18.6548 12.9465 18.3382 12.9465 18.1429 13.1418L14.4965 16.7882L12.85 15.1418ZM7.99649 0C10.7579 0 12.9965 2.23858 12.9965 5C12.9965 7.76143 10.7579 10 7.99649 10C5.23503 10 2.99645 7.76143 2.99645 5C2.99645 2.23858 5.23503 0 7.99649 0Z"
                                                          fill="#58985B"
                                                        />
                                                      </svg>
                                                    </div>
                                                  </Card.Body>
                                                </Card>
                                              ))}
                                        </>
                                      )}
                                    </div>

                                    {meetingData?.type !== "Newsletter" && (
                                      <>
                                        {meetingData?.participants?.filter(
                                          // (item) => item.isCreator === 0
                                          (item) =>
                                            // item.isCreator === 0 &&
                                            !guideEmails.has(item.email)
                                        )?.length > 0 && (
                                          <div className="mt-4">
                                            <span className="participant-heading">
                                              {t("invite")}
                                            </span>{" "}
                                            <span
                                              style={{
                                                fontFamily: "Roboto",
                                                fontSize: "16px",
                                                fontWeight: 400,
                                                lineHeight: "18.75px",
                                                textAlign: "left",
                                              }}
                                            >
                                              {"(" +
                                                meetingData?.participants?.filter(
                                                  (item) =>
                                                    // item.attandance === 0 &&
                                                    // item.isCreator === 0 &&
                                                    !guideEmails.has(item.email)
                                                ).length +
                                                "/" +
                                                meetingData?.participants?.filter(
                                                  (item) =>
                                                    // item.isCreator === 0 &&
                                                    !guideEmails.has(item.email)
                                                ).length +
                                                ")"}
                                            </span>
                                            {meetingData?.participants
                                              ?.filter(
                                                // (item) => item.isCreator === 0
                                                (item) =>
                                                  // item.isCreator === 0 &&
                                                  !guideEmails.has(item.email)
                                              )
                                              ?.map((item, index) => {
                                                // if (item.isCreator === 1) {
                                                //   return null;
                                                // }
                                                return (
                                                  <>
                                                    <Card
                                                      className="mt-4 participant-card"
                                                      style={{
                                                        border:
                                                          meetingData?.type ===
                                                          "Google Agenda Event"
                                                            ? item?.attendee_response_status ===
                                                              "accepted"
                                                              ? "1px solid green"
                                                              : item?.attendee_response_status ===
                                                                "declined"
                                                              ? "1px solid red"
                                                              : "1px solid grey"
                                                            : item?.attandance ===
                                                              1
                                                            ? "1px solid green"
                                                            : "1px solid red",
                                                        cursor: "pointer",
                                                        marginTop: "4rem",
                                                        borderRadius: "26px",
                                                        position: "relative",
                                                      }}
                                                    >
                                                      {/* Tick or Cross Icon at Bottom Center */}
                                                      {meetingData?.type ===
                                                        "Google Agenda Event" && (
                                                        <>
                                                          {item?.attendee_response_status ===
                                                            "accepted" && (
                                                            <FaCheckCircle
                                                              style={{
                                                                position:
                                                                  "absolute",
                                                                bottom: "-10px",
                                                                left: "50%",
                                                                transform:
                                                                  "translateX(-50%)",
                                                                background:
                                                                  "white",
                                                                borderRadius:
                                                                  "50%",
                                                                padding: "2px",
                                                                color: "green",
                                                                fontSize:
                                                                  "1.5rem",
                                                              }}
                                                            />
                                                          )}

                                                          {item?.attendee_response_status ===
                                                            "declined" && (
                                                            <FaTimesCircle
                                                              style={{
                                                                position:
                                                                  "absolute",
                                                                bottom: "-10px",
                                                                left: "50%",
                                                                transform:
                                                                  "translateX(-50%)",
                                                                background:
                                                                  "white",
                                                                borderRadius:
                                                                  "50%",
                                                                padding: "2px",
                                                                color: "red",
                                                                fontSize:
                                                                  "1.5rem",
                                                              }}
                                                            />
                                                          )}
                                                          {item?.attendee_response_status ===
                                                            "needsAction" && (
                                                            <FaQuestionCircle
                                                              style={{
                                                                position:
                                                                  "absolute",
                                                                bottom: "-10px",
                                                                left: "50%",
                                                                transform:
                                                                  "translateX(-50%)",
                                                                background:
                                                                  "white",
                                                                borderRadius:
                                                                  "50%",
                                                                padding: "2px",
                                                                color: "grey",
                                                                fontSize:
                                                                  "1.5rem",
                                                              }}
                                                            />
                                                          )}
                                                        </>
                                                      )}
                                                      <Card.Body className="d-flex justify-content-between align-items-center">
                                                        <div className="d-flex align-items-center gap-3">
                                                          <div className="profile-logo">
                                                            {item?.participant_image?.startsWith(
                                                              "users/"
                                                            ) ||
                                                            item?.participant?.startsWith(
                                                              "storage/"
                                                            ) ? (
                                                              <Card.Img
                                                                className="user-img"
                                                                src={`${Assets_URL}/${item?.participant_image}`}
                                                              />
                                                            ) : item.participant_image ? (
                                                              <Card.Img
                                                                className="user-img"
                                                                src={
                                                                  item?.participant_image?.startsWith(
                                                                    "http"
                                                                  )
                                                                    ? item?.participant_image
                                                                    : Assets_URL +
                                                                      "/" +
                                                                      item?.participant_image
                                                                }
                                                              />
                                                            ) : (
                                                              <Card.Img
                                                                className="user-img"
                                                                src="/Assets/avatar.jpeg"
                                                              />
                                                            )}
                                                            <Card.Img
                                                              className="logout-icon"
                                                              src="/Assets/Avatar_company.svg"
                                                              height="15px"
                                                              width="15px"
                                                              alt="tektime"
                                                            />
                                                          </div>

                                                          <div className="d-flex flex-column align-items-start">
                                                            <Card.Title className="text-center mt-4 card-heading">
                                                              {item.first_name}{" "}
                                                              {item.last_name}
                                                            </Card.Title>
                                                            {meetingData?.type ===
                                                              "Google Agenda Event" &&
                                                              item?.full_name ===
                                                                " " && (
                                                                <Card.Title className="text-center mt-4 card-heading">
                                                                  {item.email}
                                                                </Card.Title>
                                                              )}
                                                            <Card.Subtitle className="mb-2 card-subtext">
                                                              {item?.post}
                                                            </Card.Subtitle>
                                                            <Card.Subtitle className="mb-2 card-subtext">
                                                              {item?.team_names
                                                                ?.map(
                                                                  (item) => item
                                                                )
                                                                .join(", ")}
                                                            </Card.Subtitle>
                                                            {item?.user_id && (
                                                              <div
                                                                className="visiting-card-link"
                                                                onClick={() =>
                                                                  handleProfile(
                                                                    item?.id
                                                                  )
                                                                }
                                                              >
                                                                {t(
                                                                  "viewVisitingCard"
                                                                )}{" "}
                                                                &nbsp;{" "}
                                                                <FaArrowRight />
                                                              </div>
                                                            )}
                                                          </div>
                                                        </div>
                                                        <div>
                                                          {item.attandance ==
                                                          1 ? (
                                                            <svg
                                                              width="21"
                                                              height="21"
                                                              viewBox="0 0 21 21"
                                                              fill="none"
                                                              xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                              <path
                                                                d="M15.4965 9.99542C18.534 9.99542 20.9965 12.4578 20.9965 15.4954C20.9965 18.5329 18.534 20.9954 15.4965 20.9954C12.4589 20.9954 9.99649 18.5329 9.99649 15.4954C9.99649 12.4578 12.4589 9.99542 15.4965 9.99542ZM10.0187 11.9947C9.37159 13.0051 8.99649 14.2064 8.99649 15.4954C8.99649 17.1257 9.59669 18.6158 10.5882 19.7569C9.79269 19.917 8.92779 19.9964 7.99649 19.9964C4.57549 19.9964 2.05252 18.9243 0.51036 16.7599C0.1784 16.294 0 15.7362 0 15.1641V14.2442C0 13.0021 1.00685 11.9953 2.24887 11.9953L10.0187 11.9947ZM12.85 15.1418C12.6548 14.9465 12.3382 14.9465 12.1429 15.1418C11.9476 15.3371 11.9476 15.6537 12.1429 15.8489L14.1429 17.8489C14.3382 18.0442 14.6548 18.0442 14.85 17.8489L18.85 13.8489C19.0453 13.6537 19.0453 13.3371 18.85 13.1418C18.6548 12.9465 18.3382 12.9465 18.1429 13.1418L14.4965 16.7882L12.85 15.1418ZM7.99649 0C10.7579 0 12.9965 2.23858 12.9965 5C12.9965 7.76143 10.7579 10 7.99649 10C5.23503 10 2.99645 7.76143 2.99645 5C2.99645 2.23858 5.23503 0 7.99649 0Z"
                                                                fill="#58985B"
                                                              />
                                                            </svg>
                                                          ) : (
                                                            <svg
                                                              width="24"
                                                              height="24"
                                                              viewBox="0 0 24 24"
                                                              fill="none"
                                                              xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                              <path
                                                                d="M17.5004 12.0003C20.5379 12.0003 23.0004 14.4627 23.0004 17.5003C23.0004 20.5378 20.5379 23.0003 17.5004 23.0003C14.4628 23.0003 12.0004 20.5378 12.0004 17.5003C12.0004 14.4627 14.4628 12.0003 17.5004 12.0003ZM12.023 13.999C11.3757 15.0096 11.0004 16.2111 11.0004 17.5003C11.0004 19.144 11.6105 20.6452 12.6166 21.7898C11.8153 21.9316 10.9423 22.0013 10.0004 22.0013C7.11087 22.0013 4.87205 21.3447 3.30918 20.001C2.48056 19.2887 2.00391 18.2503 2.00391 17.1575V16.2502C2.00391 15.0075 3.01127 14.0002 4.25391 14.0002L12.023 13.999ZM20.8096 15.2525L15.2526 20.8095C15.8932 21.2454 16.667 21.5003 17.5004 21.5003C19.7095 21.5003 21.5004 19.7094 21.5004 17.5003C21.5004 16.6669 21.2455 15.8931 20.8096 15.2525ZM17.5004 13.5003C15.2912 13.5003 13.5004 15.2911 13.5004 17.5003C13.5004 18.3336 13.7552 19.1074 14.1912 19.748L19.7481 14.1911C19.1075 13.7551 18.3337 13.5003 17.5004 13.5003ZM10.0004 2.00488C12.7618 2.00488 15.0004 4.24346 15.0004 7.00488C15.0004 9.76631 12.7618 12.0049 10.0004 12.0049C7.23894 12.0049 5.00036 9.76631 5.00036 7.00488C5.00036 4.24346 7.23894 2.00488 10.0004 2.00488Z"
                                                                fill="#ED2F2F"
                                                              />
                                                            </svg>
                                                          )}
                                                        </div>
                                                      </Card.Body>
                                                    </Card>
                                                  </>
                                                );
                                              })}
                                          </div>
                                        )}
                                      </>
                                    )}
                                  </div>
                                </>
                              )}
                            </div>

                            {meetingData?.steps?.length > 0 && (
                              <div className="cards-section">
                                <div>
                                  <span className="participant-heading">
                                    {`${t(
                                      "meeting.newMeeting.labels.Program"
                                    )} `}
                                  </span>
                                  <ReportStepCard
                                    data={meetingData?.steps}
                                    meeting={meetingData}
                                    setMeetingData={setMeetingData}
                                    transcriptionProgress={
                                      transcriptionProgress
                                    }
                                    isTranscribing={isTranscribing}
                                    startTime={formattedTime}
                                    users={{
                                      ...meetingData?.user,
                                      firstName: meetingData?.user?.name,
                                      lastName: meetingData?.user?.last_name,
                                      image:
                                        meetingData?.user?.assigned_to_image ||
                                        meetingData?.user?.image ||
                                        "/Assets/avatar.jpeg",
                                    }}
                                  />
                                </div>
                              </div>
                            )}

                            {meetingData?.note_taker === true &&
                              meetingData?.location === "Google Meet" && (
                                <div
                                  style={{
                                    marginTop: "5rem",
                                    marginBottom: "3rem",
                                  }}
                                >
                                  <h4
                                    className={`${
                                      fromMeeting
                                        ? "participant-heading-meeting"
                                        : "participant-heading"
                                    } d-flex align-items-center justify-content-between`}
                                  >
                                    {`${t("Notes")} `}
                                  </h4>

                                  {showReportProgressBar && !isCalling ? (
                                    <div
                                      style={{
                                        padding: "10px 32px",
                                      }}
                                    >
                                      <ProgressBar now={reportProgress} />
                                      <p>Loading report data...</p>
                                    </div>
                                  ) : (
                                    <div
                                      className="meeting-notes"
                                      style={{
                                        padding: "10px 32px",
                                      }}
                                    >
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html:
                                            reportData ||
                                            meetingData?.meeting_notes,
                                        }}
                                      />
                                    </div>
                                  )}
                                </div>
                              )}

                            {meetingData?.prise_de_notes === "Automatic" &&
                              meetingData?.note_taker === false && (
                                <div
                                  style={{
                                    marginTop: "5rem",
                                    marginBottom: "3rem",
                                  }}
                                >
                                  <h4
                                    className={`participant-heading-meeting d-flex align-items-center justify-content-between`}
                                  >
                                    {/* {viewNote === "note"
                                  ? `${t("Notes")}`
                                  : `${t("Transcript")}`} */}
                                    {viewNote === "note"
                                      ? `${t("Summary of")}: ${
                                          meetingData?.type ===
                                          "Google Agenda Event"
                                            ? "Google Agenda Event"
                                            : t(`types.${meetingData?.type}`)
                                        }`
                                      : viewNote === "prompt"
                                      ? `${t("Prompt")}: ${
                                          meetingData?.solution
                                            ? meetingData?.solution?.title
                                            : t(
                                                `types.${meetingData?.prompts[0]?.meeting_type}`
                                              )
                                        }`
                                      : `${t("Transcript")}`}

                                    <span
                                      style={{
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "10px",
                                      }}
                                    ></span>
                                  </h4>
                                  {loading ? (
                                    <div
                                      style={{
                                        width: "100%",
                                        margin: "20px 0",
                                      }}
                                    >
                                      <ProgressBar animated now={45} />
                                      <h5 className="text-center">
                                        {" "}
                                        {t("note_translation.Processing Audio")}
                                      </h5>
                                    </div>
                                  ) : (
                                    <>
                                      {/* {(summaryLoading ||
                                        transcriptLoading) && (
                                        <div className="fullscreen-loader">
                                          <div
                                            className="progress-container"
                                            style={{
                                              width: "50%",
                                              opacity: "1",
                                            }}
                                          >
                                            <div
                                              className="progress"
                                              style={{ width: `${50}%` }}
                                            />
                                          </div>
                                          <h5
                                            className="text-center mt-2"
                                            style={{ color: "black" }}
                                          >
                                            {summaryLoading
                                              ? t(
                                                  "note_translation.Processing Notes"
                                                )
                                              : t(
                                                  "note_translation.Fetching Transcription"
                                                )}
                                          </h5>
                                        </div>
                                      )} */}
                                      <>
                                        {(summaryLoading ||
                                          transcriptLoading ||
                                          meetingSummaryLoading) && (
                                    <div className="position-fixed top-0 start-0 w-100 h-100 bg-white bg-opacity-90" style={{backdropFilter: 'blur(4px)', zIndex: 9999}}>
  <div className="d-flex flex-column align-items-center justify-content-center h-100">
    <div className="text-center mx-auto px-4" style={{maxWidth: '500px'}}>
      <div className="fs-5 text-secondary mb-2">
        Don't close the window...
      </div>
      <div className="small text-muted mb-5">
        {progress2 < 100 ? (
          "Report and Transcription is generating"
        ) : (
          "Your meeting insights are prepared"
        )}
      </div>

      {/* Animated Document Stack */}
      {/* <div className="position-relative mb-5 mx-auto" style={{width: '208px', height: '208px'}}>
        {[0, 1, 2, 3].map((i) => (
          <div
            key={i}
            className="position-absolute top-0 start-50 translate-middle-x mx-auto bg-white border border-light rounded shadow-sm"
            style={{
              width: '144px',
              height: '192px',
              transform: `
                rotate(${-3 + i * 2}deg) 
                translateY(${i * 4}px)
                scale(${1 - i * 0.05})
              `,
              zIndex: 4 - i,
              animation: `
                float 2.5s ease-in-out infinite ${i * 0.2}s,
                pulse 2s ease-in-out infinite ${i * 0.3}s
              `,
              filter: `blur(${i * 0.3}px)`,
              opacity: 1 - (i * 0.15)
            }}
          >
            <div className="position-absolute top-4 start-4 end-4" style={{gap: '0.5rem'}}>
              {[...Array(5)].map((_, line) => (
                <div 
                  key={line}
                  className="bg-light rounded-pill"
                  style={{
                    height: '0.5rem',
                    width: `${80 - line * 10}%`,
                    animation: `shimmer 1.5s infinite ${line * 0.1}s`
                  }}
                />
              ))}
            </div>
          </div>
        ))}
        
        {progress2 >= 100 && (
          <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center" style={{zIndex: 10}}>
            <svg 
              className="text-success"
              style={{width: '64px', height: '64px', animation: 'scaleIn 0.3s 0.9s ease-out forwards'}}
              viewBox="0 0 52 52"
            >
              <circle 
                className="text-success"
                cx="26" 
                cy="26" 
                r="25" 
                fill="none" 
                stroke="currentColor"
                strokeWidth="2"
                strokeDasharray="100" 
                strokeDashoffset="100"
                style={{
                  animation: `drawCircle 0.6s ease-out forwards`
                }}
              />
              <path
                className="text-success"
                fill="none"
                stroke="currentColor"
                strokeWidth="4"
                strokeDasharray="100"
                strokeDashoffset="100"
                d="M14.1 27.2l7.1 7.2 16.7-16.8"
                style={{
                  animation: `drawCheck 0.4s 0.6s ease-out forwards`
                }}
              />
            </svg>
          </div>
        )}
      </div> */}

      {/* Progress Bar */}
      <div className="progress mb-4" style={{height: '0.5rem'}}>
        <div 
          className="progress-bar"
          role="progressbar"
          style={{ 
            width: `${progress2}%`,
            background: 'linear-gradient(90deg, #0d6efd, #6610f2)',
            animation: "gradientShift 3s ease infinite",
            backgroundSize: "200% 100%"
          }}
          aria-valuenow={progress2}
          aria-valuemin="0"
          aria-valuemax="100"
        ></div>
      </div>
      <div className="small text-muted mb-5">
        {progress2 < 100 ? (
          "Analyzing conversations and identifying key points..."
        ) : (
          "Processing complete!"
        )}
      </div>
    </div>
  </div>

  <style jsx>{`
    @keyframes float {
      0%, 100% { transform: translateY(0) rotate(0deg); }
      50% { transform: translateY(-12px) rotate(1deg); }
    }
    @keyframes pulse {
      0%, 100% { transform: scale(1); }
      50% { transform: scale(1.02); }
    }
    @keyframes shimmer {
      0% { opacity: 0.3; }
      50% { opacity: 1; }
      100% { opacity: 0.3; }
    }
    @keyframes gradientShift {
      0% { background-position: 0% 50%; }
      50% { background-position: 100% 50%; }
      100% { background-position: 0% 50%; }
    }
    @keyframes drawCircle {
      to { stroke-dashoffset: 0; }
    }
    @keyframes drawCheck {
      to { stroke-dashoffset: 0; }
    }
    @keyframes scaleIn {
      to { transform: scale(1); }
    }
  `}</style>
</div>
                                          )}
                                      </>
                                      {viewNote === "note"
                                        ? !summaryLoading &&
                                          !transcriptLoading && (
                                            <>
                                              {/* <div
      id="editable-content"
      dangerouslySetInnerHTML={{ __html: sanitize(meetingSummary) }}
      aria-busy={summaryLoading}
    /> */}
                                              {/* <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8"> */}
                                              {/* <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-lg p-6"> */}
                                              <div className="markdown-content">
                                                <ReactMarkdown
                                                  remarkPlugins={[remarkGfm]}
                                                  components={{
                                                    h1: ({
                                                      node,
                                                      ...props
                                                    }) => <h1 {...props} />,
                                                    h2: ({
                                                      node,
                                                      ...props
                                                    }) => <h2 {...props} />,
                                                    h3: ({
                                                      node,
                                                      ...props
                                                    }) => <h3 {...props} />,
                                                    p: ({ node, ...props }) => (
                                                      <p {...props} />
                                                    ),
                                                    ul: ({
                                                      node,
                                                      ...props
                                                    }) => <ul {...props} />,
                                                    ol: ({
                                                      node,
                                                      ...props
                                                    }) => <ol {...props} />,
                                                    strong: ({
                                                      node,
                                                      ...props
                                                    }) => <strong {...props} />,
                                                    code: ({
                                                      node,
                                                      inline,
                                                      ...props
                                                    }) =>
                                                      inline ? (
                                                        <code {...props} />
                                                      ) : (
                                                        <code {...props} />
                                                      ),
                                                  }}
                                                >
                                                  {meetingSummary}
                                                </ReactMarkdown>
                                              </div>
                                              {/* </div> */}
                                              {/* // </div> */}
                                            </>
                                          )
                                        : !transcriptLoading && (
                                            <div
                                              dangerouslySetInnerHTML={{
                                                __html: meetingTranscript,
                                              }}
                                            />
                                          )}
                                    </>
                                  )}
                                </div>
                              )}
                            {meetingData?.meeting_files?.length > 0 && (
                              <div className="cards-section">
                                <div>
                                  <span className="participant-heading">
                                    {`${t("meeting.newMeeting.labels.file")} `}
                                  </span>
                                  <CompletedReportStepFile
                                    data={meetingData?.meeting_files}
                                    meeting={meetingData}
                                    startTime={formattedTime}
                                    users={{
                                      ...meetingData?.user,
                                      firstName: meetingData?.user?.name,
                                      lastName: meetingData?.user?.last_name,
                                      image:
                                        meetingData?.user?.assigned_to_image ||
                                        meetingData?.user?.image ||
                                        "/Assets/avatar.jpeg",
                                    }}
                                  />
                                </div>
                              </div>
                            )}

                            {meetingData.step_decisions &&
                              meetingData.step_decisions.some(
                                (decision) => decision !== null
                              ) && (
                                <div className="decision-section px-3 px-lg-0">
                                  <div style={{ marginTop: "2rem" }}>
                                    <span className="participant-heading">
                                      {`${t(
                                        "meeting.newMeeting.labels.decisions"
                                      )} `}
                                    </span>
                                    <DecisionCard
                                      data={meetingData?.steps}
                                      meeting={meetingData}
                                    />
                                  </div>
                                </div>
                              )}
                            {meetingData?.plan_d_actions?.length > 0 && (
                              <div className="chart-section mx-0 px-3 px-lg-0">
                                <div style={{ margin: "5rem 0 5rem 0" }}>
                                  <span className="participant-heading">
                                    {`${t("Strategy")} `}
                                  </span>
                                </div>

                                <div className="col-md-12">
                                  <Table bordered className="action-table">
                                    <thead>
                                      <tr className="table-row">
                                        {/* <th className="table-row-head"></th> */}
                                        <th
                                          className="table-row-head"
                                          style={{
                                            paddingLeft: "38px",
                                          }}
                                        >
                                          {t("tasks")}
                                        </th>

                                        <th className="table-row-head text-center">
                                          {t("duration")}
                                          {/* &nbsp; ({t("actions.days")}) */}
                                        </th>
                                        <th className="table-row-head text-center">
                                          {t("participant")}
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {filteredActions?.map((user, index) => (
                                        <tr
                                          className="table-data"
                                          key={user?.id}
                                        >
                                          {/* <td
                                style={{
                                  paddingLeft: "1rem",
                                  textAlign: "center",
                                }}
                                className="table-data-row"
                              >
                                <label className="custom-checkbox">
                                  <input
                                    type="checkbox"
                                    checked={!!selectedUsers[user.id]}
                                    onChange={() =>
                                      handleCheckboxChange(user.id)
                                    }
                                  />
                                </label>
                              </td> */}
                                          <td
                                            style={{
                                              width: "70%",
                                              paddingLeft: "28px",
                                            }}
                                            className="table-data-row"
                                          >
                                            {user?.action}
                                          </td>
                                          {/* <td className="text-center table-data-row">
                             
                              </td>
                              <td className="text-center table-data-row">
                                {user?.status}
                              </td> */}
                                          <td className="text-center table-data-row ">
                                            <span className="duree">
                                              {
                                                String(user?.action_days).split(
                                                  "."
                                                )[0]
                                              }
                                            </span>
                                            {/* {t('days')} */}
                                          </td>
                                          <td className="text-center table-data-row">
                                            <Avatar
                                              src={
                                                user?.participant_image?.includes(
                                                  "users"
                                                )
                                                  ? Assets_URL +
                                                    "/" +
                                                    user?.participant_image
                                                  : user?.participant_image
                                              }
                                            />
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </Table>
                                </div>
                              </div>
                            )}

                            <div style={{ marginTop: "5rem" }}>
                              <span className="participant-heading">
                                {`${t(
                                  "meeting.newMeeting.labels.discussion"
                                )} `}
                              </span>
                              <MeetingDiscussion
                                meetingId={meetId}
                                messages={meetingMessages}
                                selectedMoment={meetingData}
                                onMessagesUpdate={(newMeetings) =>
                                  setMeetingMessages(newMeetings)
                                }
                              />
                            </div>
                            <div className="d-flex justify-content-center align-items-center view-count">
                              <div className="d-flex flex-column align-items-center">
                                <span>
                                  <svg
                                    width="24"
                                    height="25"
                                    viewBox="0 0 24 25"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M12 15.5C13.6569 15.5 15 14.1569 15 12.5C15 10.8431 13.6569 9.5 12 9.5C10.3431 9.5 9 10.8431 9 12.5C9 14.1569 10.3431 15.5 12 15.5Z"
                                      stroke="black"
                                      stroke-width="2"
                                    />
                                    <path
                                      d="M21 12.5C21 12.5 20 4.5 12 4.5C4 4.5 3 12.5 3 12.5"
                                      stroke="black"
                                      stroke-width="2"
                                    />
                                  </svg>
                                </span>
                                <p className="page-count">
                                  {pageViews} page views
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {!(
                        meeting?.location === "Google Meet" &&
                        !["Task", "Quiz", "Media", "Law"].includes(
                          meeting?.type
                        )
                      ) && (
                        <>
                          {showProgressBar && (
                            <div className="progress-overlay">
                              <div style={{ width: "50%" }}>
                                <ProgressBar now={progress} animated />
                                <h5 className="text-center my-3">
                                  {t("progressBarText")}
                                </h5>
                              </div>
                            </div>
                          )}
                        </>
                      )}


                    </div>
                  ) : meetingData?.status === "in_progress" ||
                    meetingData?.status === "to_finish" ||
                    meetingData?.status === "todo" ? (
                    <>
                      <InProgress
                        meetingFile={meetingFile}
                        setFromTektime={setFromTektime}
                        fromTektime={fromTektime}
                        setCallNow={setCallNow}
                        setMeetingTranscript={setMeetingTranscript}
                        setViewNote={setViewNote}
                        isModalOpen={isModalOpen1}
                        setIsModalOpen={setIsModalOpen1}
                        meetingData={meetingData}
                        setMeetingData={setMeetingData}
                        t={t}
                        seesionUser={sessionUser}
                        dropdownRef={dropdownRef}
                        renderIcon={renderIcon}
                        allMeetings={allMeetings}
                        meetId={meetId}
                        selectedTitleOrder={selectedTitleOrder}
                        toggleDropdown={toggleDropdown}
                        dropdownVisible={dropdownVisible}
                        applyFilter={applyFilter}
                        formattedDate={formattedDate}
                        convertTo12HourFormat={convertTo12HourFormat}
                        formattedTime={formattedTime}
                        formattedEndDate={formattedEndDate}
                        estimateDate={estimateDate}
                        estimateTime={estimateTime}
                        setEstimateTime={setEstimateTime}
                        setEstimateDate={setEstimateDate}
                        handleShowSignUp={handleShowSignUp}
                        handleShowStepperModal={handleShowStepperModal}
                        showHostProfile={showHostProfile}
                        hideHostShow={hideHostShow}
                        handleHostShow={handleHostShow}
                        isContentBlurred={isContentBlurred}
                        guidesEmails={guideEmails}
                        showProfile={showProfile}
                        handleShow={handleShow}
                        hideShow={hideShow}
                        meetingMessages={meetingMessages}
                        setMeetingMessages={setMeetingMessages}
                        showProgressBar={showProgressBar1}
                        setShowProgressBar={setShowProgressBar1}
                        progress={progress1}
                        setProgress={setProgress1}
                        onUploadSuccess={handleAudioUploadSuccess}
                        setIsUploading={setIsUploading}
                      />
                    </>
                  ) : (
                    <>
                      {/* feedback location curent moment */}
                      <div className="email-invite w-100">
                        {meetingData?.destination_banner ? (
                          <img
                            src={meetingData?.destination_banner}
                            alt="Destination Banner"
                            style={{
                              width: "100%",
                              height: "338px",
                              objectFit: "cover",
                              filter: "opacity(0.5)",
                            }}
                          />
                        ) : (
                          <div className="gradient-header">
                            <svg
                              width="100%"
                              height="338"
                              viewBox="0 0 1453 338"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g filter="url(#filter0_f_902_7997)">
                                <rect
                                  width="100%"
                                  height="271"
                                  fill="url(#paint0_linear_902_7997)"
                                />
                              </g>
                              <defs>
                                <filter
                                  id="filter0_f_902_7997"
                                  x="-66.5"
                                  y="-66.5"
                                  width="1573"
                                  height="404"
                                  filterUnits="userSpaceOnUse"
                                  color-interpolation-filters="sRGB"
                                >
                                  <feFlood
                                    flood-opacity="0"
                                    result="BackgroundImageFix"
                                  />
                                  <feBlend
                                    mode="normal"
                                    in="SourceGraphic"
                                    in2="BackgroundImageFix"
                                    result="shape"
                                  />
                                  <feGaussianBlur
                                    stdDeviation="33.25"
                                    result="effect1_foregroundBlur_902_7997"
                                  />
                                </filter>
                                <linearGradient
                                  id="paint0_linear_902_7997"
                                  x1="856"
                                  y1="281.934"
                                  x2="863.131"
                                  y2="-138.913"
                                  gradientUnits="userSpaceOnUse"
                                >
                                  <stop stop-color="white" />
                                  <stop offset="1" stop-color="#76C3EE" />
                                </linearGradient>
                              </defs>
                            </svg>
                          </div>
                        )}
                        <div className="content">
                          <div
                            className="row report-row"
                            style={{ height: "35vh" }}
                          >
                            <div className="col-12 col-md-10 d-flex flex-column flex-md-row align-items-center align-items-md-start text-center text-md-start">
                              <h5 className="content-heading fw-bold">
                                {meetingData?.objective}
                              </h5>
                            </div>

                            <div className="col-md-2">
                              <div className="position-relative">
                                <Card className="mt-3 host-card tektime-dev-team">
                                  <Card.Body>
                                    <div className="d-flex justify-content-center">
                                      <div className="profile-logo">
                                        <Card.Img
                                          className="avatar-img"
                                          style={{
                                            objectFit: "cover",
                                            objectPosition: "top",
                                          }}
                                          src={
                                            meetingData?.destination?.clients
                                              ?.client_logo
                                              ? meetingData?.destination?.clients?.client_logo?.startsWith(
                                                  "http"
                                                )
                                                ? meetingData?.destination
                                                    ?.clients?.client_logo
                                                : `${Assets_URL}/${meetingData?.destination?.clients?.client_logo}`
                                              : "/Assets/logo2.png" ||
                                                "/Assets/logo2.png"
                                          }
                                        />
                                      </div>
                                    </div>

                                    <Card.Title className="text-center mt-3 card-heading">
                                      {meetingData?.destination?.clients
                                        ?.name || ""}
                                    </Card.Title>
                                    {/* <Card.Subtitle className="mb-2 card-subtext">
                        {meeting?.user?.post} -{" "}
                        {meeting?.user?.teams?.map((item) => item.name)}
                      </Card.Subtitle> */}
                                  </Card.Body>
                                </Card>
                              </div>
                            </div>

                            {/* ------------------------------------------------ HOST */}
                          </div>
                          <div className="row align-items-start report-row mt-5 pt-5 mt-lg-5 pt-lg-0">
                            <div className="col-md-8">
                              <div
                                className="dropdown-container"
                                ref={dropdownRef}
                              >
                                <h5 className="content-heading-title ms-0 mt-0">
                                  {renderIcon()}
                                  {/* // </div> */}
                                  &nbsp;
                                  {selectedTitleOrder}&nbsp;
                                  {meetingData?.title} &nbsp;&nbsp;
                                  {meetingData?.status === "active" && (
                                    <span
                                      className={`badge ms-2 ${
                                        moment().isAfter(
                                          moment(
                                            `${meetingData?.date} ${meetingData?.start_time}`,
                                            "YYYY-MM-DD HH:mm"
                                          )
                                        )
                                          ? "late"
                                          : "future"
                                      }`}
                                      // style={{ padding: "3px 8px 3px 8px" }}
                                    >
                                      {moment().isAfter(
                                        moment(
                                          `${meetingData?.date} ${meetingData?.start_time}`,
                                          "YYYY-MM-DD HH:mm"
                                        )
                                      )
                                        ? t("badge.late")
                                        : t("badge.future")}
                                    </span>
                                  )}
                                  {meetingData?.status === "in_progress" && (
                                    // <span className="mx-2 badge status-badge-inprogress1">
                                    <span
                                      className={`${
                                        meetingData?.steps?.some(
                                          (moment) =>
                                            moment?.step_status ===
                                              "in_progress" &&
                                            convertTimeTakenToSeconds(
                                              moment?.time_taken
                                            ) >
                                              convertCount2ToSeconds(
                                                moment?.count2,
                                                moment?.time_unit
                                              )
                                        )
                                          ? "status-badge-red1"
                                          : "status-badge-inprogress1"
                                      } mx-2 badge h-100`}
                                    >
                                      {t("badge.inprogress")}
                                    </span>
                                  )}
                                  {meetingData?.status === "closed" && (
                                    <span className="mx-2 badge inprogrss">
                                      {t("badge.finished")}
                                    </span>
                                  )}
                                  {meetingData?.status === "abort" && (
                                    <span className="mx-2 badge late">
                                      {t("badge.cancel")}
                                    </span>
                                  )}
                                  {/* {allMeetings && allMeetings?.length < 2 ? null : ( */}
                                  {allMeetings?.filter(
                                    (item) =>
                                      Number(item?.id) !== Number(meetId)
                                  )?.length > 0 ? (
                                    <span>
                                      <MdKeyboardArrowDown
                                        size={30}
                                        onClick={toggleDropdown}
                                        style={{
                                          cursor: "pointer",
                                          // marginLeft: ".6rem",
                                          marginBottom: "6px",
                                        }}
                                      />
                                    </span>
                                  ) : null}
                                </h5>
                                {dropdownVisible && (
                                  <div className="dropdown-content-filter">
                                    <div className="dropdown-section">
                                      {allMeetings
                                        // ?.filter((item) => item.id !== meetId)
                                        ?.filter(
                                          (item) =>
                                            item.id.toString() !==
                                            meetId.toString()
                                        )
                                        ?.map((item, index) => {
                                          return (
                                            <>
                                              <div
                                                key={index}
                                                onClick={() =>
                                                  applyFilter(item)
                                                }
                                                style={{ cursor: "pointer" }}
                                              >
                                                <b>{item.title_order}.</b>&nbsp;
                                                {item.title}
                                              </div>
                                            </>
                                          );
                                        })}
                                    </div>
                                  </div>
                                )}
                              </div>

                              <div className="d-flex gap-4 items mt-0 mt-md-2 audio-items">
                                <div className="type">
                                  <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.33333 2.99984C8.33333 3.3665 8.20289 3.6805 7.942 3.94184C7.68111 4.20317 7.36711 4.33362 7 4.33317C6.85556 4.33317 6.72222 4.31362 6.6 4.2745C6.47778 4.23539 6.35556 4.17162 6.23333 4.08317C5.96667 4.17206 5.75289 4.33317 5.592 4.5665C5.43111 4.79984 5.35044 5.05539 5.35 5.33317H14L13.3333 9.99984H10.0667V8.6665H12.1833C12.2389 8.33317 12.2862 7.99984 12.3253 7.6665C12.3644 7.33317 12.4116 6.99984 12.4667 6.6665H3.53333C3.58889 6.99984 3.63622 7.33317 3.67533 7.6665C3.71444 7.99984 3.76156 8.33317 3.81667 8.6665H5.93333V9.99984H2.66667L2 5.33317H4C4 4.78873 4.15 4.29428 4.45 3.84984C4.75 3.40539 5.15556 3.07762 5.66667 2.8665C5.7 2.52206 5.84444 2.23606 6.1 2.0085C6.35556 1.78095 6.65556 1.66695 7 1.6665C7.36667 1.6665 7.68067 1.79717 7.942 2.0585C8.20333 2.31984 8.33378 2.63362 8.33333 2.99984ZM6.51667 12.6665H9.48333L9.86667 8.6665H6.13333L6.51667 12.6665ZM5.33333 13.9998L4.83333 8.79984C4.78889 8.41095 4.9 8.06939 5.16667 7.77517C5.43333 7.48095 5.76111 7.33362 6.15 7.33317H9.85C10.2389 7.33317 10.5667 7.4805 10.8333 7.77517C11.1 8.06984 11.2111 8.41139 11.1667 8.79984L10.6667 13.9998H5.33333Z"
                                      fill="#8590A3"
                                    />
                                  </svg>
                                  {/* <span className="time">{meeting?.type}</span> */}
                                  <span className="time">
                                    {meetingData?.solution
                                      ? meetingData?.solution?.title
                                      : meetingData?.type ===
                                        "Google Agenda Event"
                                      ? "Google Agenda Event"
                                      : meetingData?.type === "Special"
                                      ? "Media"
                                      : meetingData?.type === "Prise de contact"
                                      ? "Prise de contact"
                                      : t(`types.${meetingData?.type}`)}
                                  </span>
                                </div>
                                {/* <div className="priority">
                                  <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M12.346 6.79075C12.3618 6.77463 12.3808 6.76199 12.4018 6.75362C12.4228 6.74526 12.4453 6.74137 12.4679 6.74218C12.4905 6.743 12.5126 6.74851 12.533 6.75836C12.5533 6.76821 12.5714 6.78219 12.586 6.79941C13.4616 7.83748 13.9592 9.1419 13.9973 10.4994C13.9978 10.5213 13.9938 10.543 13.9857 10.5633C13.9776 10.5835 13.9656 10.602 13.9502 10.6175C13.9349 10.6331 13.9165 10.6454 13.8964 10.6537C13.8762 10.6621 13.8545 10.6663 13.8327 10.6661H10.8293C10.7849 10.6653 10.7424 10.6476 10.7104 10.6167C10.6785 10.5857 10.6595 10.5438 10.6573 10.4994C10.627 10.0165 10.4657 9.5509 10.1907 9.15275C10.167 9.11952 10.1557 9.07907 10.1588 9.0384C10.1618 8.99773 10.179 8.95941 10.2073 8.93008L12.346 6.79075ZM11.866 6.07941C11.9393 6.14075 11.9427 6.25141 11.8753 6.31941L9.73532 8.45875C9.70603 8.48691 9.66784 8.50399 9.62732 8.50703C9.5868 8.51007 9.54649 8.49889 9.51332 8.47541C9.20249 8.26075 8.84958 8.11463 8.47799 8.04675C8.43781 8.03991 8.4013 8.01924 8.37475 7.98831C8.34821 7.95739 8.33332 7.91816 8.33265 7.87741V4.85208C8.33265 4.75608 8.41265 4.68008 8.50865 4.68808C9.74476 4.79382 10.9177 5.27947 11.866 6.07941ZM7.66599 4.85275C7.66625 4.8301 7.66178 4.80765 7.65287 4.78684C7.64395 4.76602 7.63079 4.74729 7.61423 4.73186C7.59766 4.71642 7.57805 4.70461 7.55666 4.69719C7.53526 4.68976 7.51256 4.68689 7.48999 4.68875C6.25395 4.7943 5.08102 5.28038 4.13265 6.08008C4.11544 6.09471 4.10146 6.11276 4.0916 6.1331C4.08175 6.15343 4.07624 6.17559 4.07542 6.19817C4.07461 6.22075 4.0785 6.24325 4.08687 6.26424C4.09523 6.28523 4.10787 6.30424 4.12399 6.32008L6.26399 8.45941C6.29315 8.48781 6.33137 8.50505 6.37196 8.5081C6.41255 8.51114 6.45292 8.49981 6.48599 8.47608C6.7968 8.2614 7.14972 8.11528 7.52132 8.04741C7.56149 8.04057 7.59801 8.0199 7.62455 7.98898C7.65109 7.95806 7.66599 7.91883 7.66665 7.87808L7.66599 4.85275ZM5.80865 9.15275C5.83205 9.11951 5.84311 9.07915 5.83995 9.03862C5.83679 8.9981 5.81959 8.95995 5.79132 8.93075L3.65199 6.79075C3.63611 6.77467 3.61705 6.76207 3.59604 6.75377C3.57502 6.74546 3.55251 6.74163 3.52993 6.74251C3.50735 6.74338 3.4852 6.74896 3.46489 6.75887C3.44459 6.76878 3.42657 6.78282 3.41199 6.80008C2.53685 7.83833 2.03977 9.14273 2.00199 10.5001C2.00154 10.5219 2.00546 10.5435 2.01351 10.5638C2.02156 10.584 2.03358 10.6024 2.04886 10.618C2.06415 10.6335 2.08238 10.6458 2.1025 10.6542C2.12261 10.6626 2.1442 10.6668 2.16599 10.6667H5.16932C5.26132 10.6667 5.33599 10.5927 5.34132 10.5001C5.37132 10.0154 5.53465 9.54941 5.80799 9.15341"
                                      fill="#8590A3"
                                      fill-opacity="0.25"
                                    />
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M8.33203 7.87077C8.33203 7.95477 8.3947 8.02477 8.47737 8.0401C8.85073 8.10802 9.20529 8.25485 9.51737 8.47077C9.55067 8.49434 9.59116 8.50551 9.63183 8.50234C9.67251 8.49918 9.71079 8.48187 9.74004 8.45344L12.3467 5.84677C12.3628 5.83102 12.3756 5.8121 12.384 5.79119C12.3925 5.77029 12.3966 5.74786 12.3959 5.72531C12.3953 5.70276 12.39 5.68059 12.3804 5.66019C12.3708 5.63979 12.357 5.6216 12.34 5.60677C11.2636 4.6834 9.92079 4.12735 8.5067 4.01944C8.48426 4.01788 8.46174 4.02097 8.44055 4.02851C8.41936 4.03606 8.39996 4.04791 8.38356 4.0633C8.36717 4.0787 8.35412 4.09732 8.34526 4.11799C8.33639 4.13866 8.33189 4.16094 8.33203 4.18344V7.87077Z"
                                      fill="#8590A3"
                                    />
                                  </svg>
                                  <span className="time">
                                    {t(
                                      `meeting.newMeeting.options.priorities.${meetingData?.priority}`
                                    )}
                                  </span>
                                </div> */}
                              </div>

                              <div className="mt-3 d-flex align-items-center gap-2 content-body stepcard-content ps-2 ps-md-4 ps-lg-0">
                                <div className="d-flex align-items-center gap-2">
                                  {meetingData?.type === "Action" ||
                                  meetingData?.type === "Newsletter" ||
                                  meetingData?.type === "Strategy" ? (
                                    <>
                                      <img
                                        src="/Assets/invite-date.svg"
                                        height="28px"
                                        width="28px"
                                      />
                                      <span className="fw-bold formate-date">
                                        {formattedDate}
                                        &nbsp; -
                                      </span>
                                      <span className="fw-bold formate-date">
                                        {/* {formattedDateActive} */}
                                        {formattedEndDate}
                                      </span>
                                    </>
                                  ) : (
                                    <>
                                      <img src="/Assets/invite-date.svg" />

                                      <span className="fw-bold formate-date">
                                        {formattedDate}
                                        &nbsp; {t("at")}
                                      </span>
                                      <span className="fw-bold formate-date">
                                        {/* {formattedTime} */}
                                        {/* {convertTo12HourFormat(
                                  meetingData?.start_time,
                                  meetingData?.steps
                                )}{" "} */}
                                        {meetingData?.status === "in_progress"
                                          ? convertTo12HourFormat(
                                              meetingData?.starts_at,
                                              meetingData?.date,
                                              meetingData?.steps,
                                              meetingData?.timezone
                                            )
                                          : convertTo12HourFormat(
                                              meetingData?.start_time,
                                              meetingData?.date,
                                              meetingData?.steps,
                                              meetingData?.timezone
                                            )}{" "}
                                        -{" "}
                                      </span>

                                      <span className="fw-bold formate-date">
                                        {/* {formattedEndDateInHoursForEmailInvite} */}
                                        {estimateDate}
                                        &nbsp; {t("at")}
                                      </span>
                                      <span className="fw-bold formate-date">
                                        {/* {lastStepEndTime} */}
                                        {estimateTime}
                                      </span>
                                      {/* <span className="fw-bold formate-date">
                                {convertTo12HourFormat1(
                                  meetingData?.start_time,
                                  meetingData?.steps
                                )}{" "}
                                -{" "}
                              </span>
                              <span className="fw-bold formate-date">
                                {calculateEndTime(
                                  meetingData?.start_time?.slice(0, 5),
                                  meetingData?.steps
                                )}
                              </span> */}

                                      <span className="fw-bold">
                                        {getTimezoneSymbol(
                                          localStorage.getItem("timezone")
                                        )}
                                      </span>
                                    </>
                                  )}
                                </div>
                              </div>

                              <div className="ps-2 ps-md-4 ps-lg-0">
                                {(meetingData?.location &&
                                  meetingData?.location !== "None") ||
                                (meetingData?.agenda &&
                                  meetingData?.agenda !== "None") ? (
                                  <div className="d-flex gap-4 align-items-center mt-2 mb-2">
                                    {meetingData?.location &&
                                      meetingData?.location !== "None" && (
                                        <p className="d-flex gap-2 justify-content-start ps-0 fw-bold align-items-center mb-0">
                                          <span>
                                            <svg
                                              width="28px"
                                              height="28px"
                                              viewBox="0 0 32 32"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <g
                                                id="SVGRepo_bgCarrier"
                                                stroke-width="0"
                                              ></g>
                                              <g
                                                id="SVGRepo_tracerCarrier"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                              ></g>
                                              <g id="SVGRepo_iconCarrier">
                                                {" "}
                                                <path
                                                  d="M2 11.9556C2 8.47078 2 6.7284 2.67818 5.39739C3.27473 4.22661 4.22661 3.27473 5.39739 2.67818C6.7284 2 8.47078 2 11.9556 2H20.0444C23.5292 2 25.2716 2 26.6026 2.67818C27.7734 3.27473 28.7253 4.22661 29.3218 5.39739C30 6.7284 30 8.47078 30 11.9556V20.0444C30 23.5292 30 25.2716 29.3218 26.6026C28.7253 27.7734 27.7734 28.7253 26.6026 29.3218C25.2716 30 23.5292 30 20.0444 30H11.9556C8.47078 30 6.7284 30 5.39739 29.3218C4.22661 28.7253 3.27473 27.7734 2.67818 26.6026C2 25.2716 2 23.5292 2 20.0444V11.9556Z"
                                                  fill="white"
                                                ></path>{" "}
                                                <path
                                                  d="M5 23.5601C5 24.3557 5.64998 25.0001 6.45081 25.0001H6.47166C5.65857 25.0001 5 24.3557 5 23.5601Z"
                                                  fill="#FBBC05"
                                                ></path>{" "}
                                                <path
                                                  d="M17.4678 12.4V16.1596L22.5364 12.0712V8.43999C22.5364 7.6444 21.8864 7 21.0856 7H10.1045L10.0947 12.4H17.4678Z"
                                                  fill="#FBBC05"
                                                ></path>{" "}
                                                <path
                                                  d="M17.4671 19.9207H10.0818L10.0732 25.0003H21.085C21.887 25.0003 22.5358 24.3559 22.5358 23.5603V20.2819L17.4671 16.1611V19.9207Z"
                                                  fill="#34A853"
                                                ></path>{" "}
                                                <path
                                                  d="M10.1042 7L5 12.4H10.0956L10.1042 7Z"
                                                  fill="#EA4335"
                                                ></path>{" "}
                                                <path
                                                  d="M5 19.9204V23.56C5 24.3556 5.65857 25 6.47166 25H10.0736L10.0821 19.9204H5Z"
                                                  fill="#1967D2"
                                                ></path>{" "}
                                                <path
                                                  d="M10.0956 12.3999H5V19.9203H10.0821L10.0956 12.3999Z"
                                                  fill="#4285F4"
                                                ></path>{" "}
                                                <path
                                                  d="M26.9926 22.2796V9.9197C26.7068 8.27931 24.9077 10.1597 24.9077 10.1597L22.5371 12.0713V20.2804L25.9305 23.0392C27.1557 23.2 26.9926 22.2796 26.9926 22.2796Z"
                                                  fill="#34A853"
                                                ></path>{" "}
                                                <path
                                                  d="M17.4678 16.1594L22.5377 20.2814V12.0723L17.4678 16.1594Z"
                                                  fill="#188038"
                                                ></path>{" "}
                                              </g>
                                            </svg>
                                          </span>
                                          <span className="solutioncards option-text">
                                            {
                                              meetingData?.user
                                                ?.google_full_name
                                            }
                                          </span>
                                        </p>
                                      )}
                                    {meetingData?.agenda &&
                                      meetingData?.agenda !== "None" && (
                                        <p className="d-flex gap-2 justify-content-start ps-0 fw-bold align-items-center mb-0">
                                          <span>
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              aria-label="Google Calendar"
                                              role="img"
                                              viewBox="0 0 512 512"
                                              width="28px"
                                              height="28px"
                                              fill="#000000"
                                            >
                                              <g
                                                id="SVGRepo_bgCarrier"
                                                stroke-width="0"
                                              ></g>
                                              <g
                                                id="SVGRepo_tracerCarrier"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                              ></g>
                                              <g id="SVGRepo_iconCarrier">
                                                <rect
                                                  width="512"
                                                  height="512"
                                                  rx="15%"
                                                  fill="#ffffff"
                                                ></rect>
                                                <path
                                                  d="M100 340h74V174H340v-74H137Q100 100 100 135"
                                                  fill="#4285f4"
                                                ></path>
                                                <path
                                                  d="M338 100v76h74v-41q0-35-35-35"
                                                  fill="#1967d2"
                                                ></path>
                                                <path
                                                  d="M338 174h74V338h-74"
                                                  fill="#fbbc04"
                                                ></path>
                                                <path
                                                  d="M100 338v39q0 35 35 35h41v-74"
                                                  fill="#188038"
                                                ></path>
                                                <path
                                                  d="M174 338H338v74H174"
                                                  fill="#34a853"
                                                ></path>
                                                <path
                                                  d="M338 412v-74h74"
                                                  fill="#ea4335"
                                                ></path>
                                                <path
                                                  d="M204 229a25 22 1 1 1 25 27h-9h9a25 22 1 1 1-25 27M270 231l27-19h4v-7V308"
                                                  stroke="#4285f4"
                                                  stroke-width="15"
                                                  stroke-linejoin="bevel"
                                                  fill="none"
                                                ></path>
                                              </g>
                                            </svg>
                                          </span>
                                          <span className="solutioncards option-text">
                                            {
                                              meetingData?.user
                                                ?.google_full_name
                                            }
                                          </span>
                                        </p>
                                      )}
                                  </div>
                                ) : null}
                                <div className="ps-0">
                                  {meetingData?.address ? (
                                    <p className="d-flex gap-2 align-items-center justify-content-start ps-0 ms-0 mt-2">
                                      <FaLocationDot size={25} />
                                      <span>{meetingData?.address}</span>
                                    </p>
                                  ) : null}
                                </div>
                                {meetingData?.room_details ? (
                                  <div>
                                    <p className="d-flex gap-2 mt-2 justify-content-start align-items-top ps-0">
                                      <BsPersonWorkspace size={25} />
                                      <p className="m-0">
                                        {meetingData?.room_details &&
                                          meetingData?.room_details}
                                      </p>
                                    </p>
                                  </div>
                                ) : null}
                                {meetingData?.phone ? ( // Check if the phone field exists
                                  <div>
                                    <p className="d-flex gap-2 align-items-center justify-content-start ps-0 mt-2">
                                      <span>
                                        <FaPhoneAlt size={25} />
                                      </span>
                                      <a
                                        href={`tel:${meetingData.phone}`}
                                        className="text-decoration-none"
                                      >
                                        <span className="">
                                          {meetingData.phone}
                                        </span>{" "}
                                        {/* Display the phone number */}
                                      </a>
                                    </p>
                                  </div>
                                ) : null}
                              </div>

                              {/* Options */}
                              <div className="row mt-2">
                                <div className="col-md-12 d-flex align-items-center gap-3">
                                  {meetingData?.prise_de_notes ===
                                    "Automatic" && (
                                    <>
                                      <div>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="28"
                                          height="28"
                                          viewBox="0 0 28 28"
                                          fill="none"
                                        >
                                          <g filter="url(#filter0_d_1_1154)">
                                            <circle
                                              cx="14"
                                              cy="12"
                                              r="10"
                                              stroke="url(#paint0_linear_1_1154)"
                                              strokeWidth="4"
                                            />
                                          </g>
                                          <defs>
                                            <filter
                                              id="filter0_d_1_1154"
                                              x="0"
                                              y="0"
                                              width="28"
                                              height="28"
                                              filterUnits="userSpaceOnUse"
                                              colorInterpolationFilters="sRGB"
                                            >
                                              <feFlood
                                                floodOpacity="0"
                                                result="BackgroundImageFix"
                                              />
                                              <feColorMatrix
                                                in="SourceAlpha"
                                                type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                                result="hardAlpha"
                                              />
                                              <feOffset dy="2" />
                                              <feGaussianBlur stdDeviation="1" />
                                              <feColorMatrix
                                                type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
                                              />
                                              <feBlend
                                                mode="normal"
                                                in2="BackgroundImageFix"
                                                result="effect1_dropShadow_1_1154"
                                              />
                                              <feBlend
                                                mode="normal"
                                                in="SourceGraphic"
                                                in2="effect1_dropShadow_1_1154"
                                                result="shape"
                                              />
                                            </filter>
                                            <linearGradient
                                              id="paint0_linear_1_1154"
                                              x1="14"
                                              y1="0"
                                              x2="20.375"
                                              y2="21.75"
                                              gradientUnits="userSpaceOnUse"
                                            >
                                              <stop stopColor="#B11FAB" />
                                              <stop
                                                offset="0.514"
                                                stopColor="#56E8F1"
                                              />
                                              <stop
                                                offset="1"
                                                stopColor="#2F47C1"
                                              />
                                            </linearGradient>
                                          </defs>
                                        </svg>
                                        <span className="solutioncards option-text">
                                          {t(
                                            "meeting.formState.Automatic note taking"
                                          )}
                                        </span>
                                      </div>
                                    </>
                                  )}
                                  {meetingData?.note_taker === true && (
                                    <>
                                      <div className="d-flex align-items-center gap-2">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="28px"
                                          height="28px"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="#3D57B5"
                                          stroke-width="2"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        >
                                          <g
                                            id="SVGRepo_bgCarrier"
                                            stroke-width="0"
                                          ></g>
                                          <g
                                            id="SVGRepo_tracerCarrier"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          ></g>
                                          <g id="SVGRepo_iconCarrier">
                                            {" "}
                                            <rect
                                              x="3"
                                              y="11"
                                              width="18"
                                              height="10"
                                              rx="2"
                                            ></rect>{" "}
                                            <circle
                                              cx="12"
                                              cy="5"
                                              r="2"
                                            ></circle>{" "}
                                            <path d="M12 7v4"></path>{" "}
                                            <line
                                              x1="8"
                                              y1="16"
                                              x2="8"
                                              y2="16"
                                            ></line>{" "}
                                            <line
                                              x1="16"
                                              y1="16"
                                              x2="16"
                                              y2="16"
                                            ></line>{" "}
                                          </g>
                                        </svg>
                                        <span className="solutioncards option-text">
                                          {t("meeting.formState.Note Taker")}
                                        </span>
                                      </div>
                                    </>
                                  )}

                                  {meetingData?.alarm === true && (
                                    <>
                                      <div>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="25"
                                          height="24"
                                          viewBox="0 0 25 24"
                                          fill="none"
                                        >
                                          <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M12.5001 1.35999C12.2879 1.35999 12.0844 1.44427 11.9344 1.5943C11.7844 1.74433 11.7001 1.94781 11.7001 2.15999V5.63519C11.7001 5.84736 11.7844 6.05084 11.9344 6.20087C12.0844 6.3509 12.2879 6.43519 12.5001 6.43519C12.7122 6.43519 12.9157 6.3509 13.0658 6.20087C13.2158 6.05084 13.3001 5.84736 13.3001 5.63519V2.99519C15.3173 3.17457 17.2159 4.02613 18.6915 5.41333C20.167 6.80054 21.134 8.64304 21.4373 10.6454C21.7407 12.6478 21.363 14.694 20.3646 16.4561C19.3662 18.2181 17.8051 19.5939 15.9315 20.3628C14.058 21.1317 11.9805 21.2492 10.0321 20.6965C8.08379 20.1437 6.37749 18.9528 5.1868 17.3145C3.99611 15.6763 3.39001 13.6857 3.46567 11.6619C3.54134 9.63811 4.29438 7.69833 5.60407 6.15358C5.67546 6.07402 5.73018 5.98095 5.765 5.87989C5.79981 5.77882 5.81402 5.6718 5.80678 5.56514C5.79954 5.45849 5.771 5.35437 5.72285 5.25893C5.67469 5.1635 5.6079 5.07868 5.52641 5.00949C5.44493 4.9403 5.3504 4.88815 5.24842 4.8561C5.14644 4.82406 5.03907 4.81278 4.93265 4.82293C4.82624 4.83308 4.72293 4.86446 4.62885 4.91521C4.53476 4.96595 4.4518 5.03504 4.38487 5.11839C2.81701 6.96726 1.92749 9.29609 1.86357 11.7194C1.79964 14.1427 2.56513 16.5152 4.03333 18.4442C5.50153 20.3731 7.58441 21.7429 9.9372 22.3268C12.29 22.9106 14.7716 22.6736 16.9713 21.6548C19.171 20.6361 20.9569 18.8967 22.0333 16.7247C23.1098 14.5526 23.4122 12.0781 22.8907 9.71074C22.3691 7.34336 21.0548 5.22506 19.1652 3.70646C17.2757 2.18787 14.9242 1.36003 12.5001 1.35999ZM11.2841 12.928L7.25847 7.31679C7.20487 7.23976 7.18006 7.14634 7.18838 7.05287C7.19669 6.9594 7.23761 6.87183 7.30396 6.80548C7.37031 6.73912 7.45789 6.69821 7.55135 6.68989C7.64482 6.68158 7.73824 6.70639 7.81527 6.75999L13.4297 10.784C13.6103 10.914 13.7605 11.0818 13.8699 11.2757C13.9793 11.4695 14.0453 11.6848 14.0632 11.9067C14.0812 12.1286 14.0507 12.3517 13.9738 12.5606C13.897 12.7695 13.7757 12.9592 13.6183 13.1166C13.4609 13.274 13.2712 13.3953 13.0623 13.4722C12.8534 13.549 12.6303 13.5795 12.4084 13.5615C12.1865 13.5436 11.9712 13.4776 11.7773 13.3682C11.5835 13.2588 11.4157 13.1086 11.2857 12.928"
                                            fill="#3D57B5"
                                          />
                                        </svg>
                                        <span
                                          className="solutioncards"
                                          style={{ color: "#3D57B5" }}
                                        >
                                          {t("meeting.formState.Beep alarm")}
                                        </span>
                                      </div>
                                    </>
                                  )}

                                  {/* {meetingData?.share_by === "email" && (
                                    <>
                                      <div>
                                        <span>
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 30 30"
                                            width="30px"
                                            height="30px"
                                          >
                                            <path
                                              d="M 23 3 A 4 4 0 0 0 19 7 A 4 4 0 0 0 19.09375 7.8359375 L 10.011719 12.376953 A 4 4 0 0 0 7 11 A 4 4 0 0 0 3 15 A 4 4 0 0 0 7 19 A 4 4 0 0 0 10.013672 17.625 L 19.089844 22.164062 A 4 4 0 0 0 19 23 A 4 4 0 0 0 23 27 A 4 4 0 0 0 27 23 A 4 4 0 0 0 23 19 A 4 4 0 0 0 19.986328 20.375 L 10.910156 15.835938 A 4 4 0 0 0 11 15 A 4 4 0 0 0 10.90625 14.166016 L 19.988281 9.625 A 4 4 0 0 0 23 11 A 4 4 0 0 0 27 7 A 4 4 0 0 0 23 3 z"
                                              fill="#3D57B5"
                                            />
                                          </svg>
                                        </span>
                                        {t("Shareby")}
                                      </div>
                                    </>
                                  )} */}
                                </div>
                              </div>

                              {/* Casting Type */}

                              {/* Privacy */}
                              <div className="row ">
                                <div className="col-md-12 mt-2 ms-1 d-flex align-items-center gap-3">
                                  <span
                                    style={{
                                      fontFamily: "Inter",
                                      fontSize: "12px",
                                      fontWeight: 400,
                                      lineHeight: "14.52px",
                                      textAlign: "left",
                                      color: "#8590a3",
                                    }}
                                  >
                                    {t("Privacy")}:
                                  </span>
                                  {/* <div className=""> */}
                                  <div className="d-flex align-items-center flex-wrap">
                                    {meetingData?.moment_privacy ===
                                    "public" ? (
                                      <Avatar
                                        src="/Assets/Tek.png"
                                        style={{ borderRadius: "0" }}
                                      />
                                    ) : meetingData?.moment_privacy ===
                                      "team" ? (
                                      <Avatar.Group>
                                        {meetingData?.moment_privacy_teams_data?.map(
                                          (item) => {
                                            return (
                                              <>
                                                <Tooltip
                                                  title={item?.name}
                                                  placement="top"
                                                >
                                                  <Avatar
                                                    size="large"
                                                    src={
                                                      item?.logo?.startsWith(
                                                        "http"
                                                      )
                                                        ? item.logo
                                                        : Assets_URL +
                                                          "/" +
                                                          item.logo
                                                    }
                                                  />
                                                </Tooltip>
                                              </>
                                            );
                                          }
                                        )}
                                      </Avatar.Group>
                                    ) : meetingData?.moment_privacy ===
                                      "participant only" ? (
                                      <Avatar.Group>
                                        {meetingData?.user_with_participants?.map(
                                          (item) => {
                                            return (
                                              <>
                                                <AntdTooltip
                                                  title={item?.full_name}
                                                  placement="top"
                                                >
                                                  <Avatar
                                                    size="large"
                                                    src={
                                                      item?.participant_image?.startsWith(
                                                        "http"
                                                      )
                                                        ? item.participant_image
                                                        : Assets_URL +
                                                          "/" +
                                                          item.participant_image
                                                    }
                                                  />
                                                </AntdTooltip>
                                              </>
                                            );
                                          }
                                        )}
                                      </Avatar.Group>
                                    ) : meetingData?.moment_privacy ===
                                      "tektime members" ? (
                                      <img
                                        src={
                                          meetingData?.user?.enterprise?.logo?.startsWith(
                                            "http"
                                          )
                                            ? meetingData?.user?.enterprise
                                                ?.logo
                                            : Assets_URL +
                                              "/" +
                                              meetingData?.user?.enterprise
                                                ?.logo
                                        }
                                        alt="Logo"
                                        style={{
                                          width: "30px",
                                          height: "30px",
                                          objectFit: "fill",
                                          borderRadius: "50%",
                                        }}
                                      />
                                    ) : meetingData?.moment_privacy ===
                                      "enterprise" ? (
                                      <AntdTooltip
                                        title={
                                          meetingData?.user?.enterprise?.name
                                        }
                                        placement="top"
                                      >
                                        <img
                                          src={
                                            meetingData?.user?.enterprise?.logo?.startsWith(
                                              "http"
                                            )
                                              ? meetingData?.user?.enterprise
                                                  ?.logo
                                              : Assets_URL +
                                                "/" +
                                                meetingData?.user?.enterprise
                                                  ?.logo
                                          }
                                          alt="Logo"
                                          style={{
                                            width: "30px",
                                            height: "30px",
                                            objectFit: "fill",
                                            borderRadius: "50%",
                                          }}
                                        />
                                      </AntdTooltip>
                                    ) : meetingData?.moment_privacy ===
                                      "password" ? (
                                      <svg
                                        width="37px"
                                        height="36px"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <g
                                          id="SVGRepo_bgCarrier"
                                          stroke-width="0"
                                        ></g>
                                        <g
                                          id="SVGRepo_tracerCarrier"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        ></g>
                                        <g id="SVGRepo_iconCarrier">
                                          {" "}
                                          <path
                                            d="M7 10.0288C7.47142 10 8.05259 10 8.8 10H15.2C15.9474 10 16.5286 10 17 10.0288M7 10.0288C6.41168 10.0647 5.99429 10.1455 5.63803 10.327C5.07354 10.6146 4.6146 11.0735 4.32698 11.638C4 12.2798 4 13.1198 4 14.8V16.2C4 17.8802 4 18.7202 4.32698 19.362C4.6146 19.9265 5.07354 20.3854 5.63803 20.673C6.27976 21 7.11984 21 8.8 21H15.2C16.8802 21 17.7202 21 18.362 20.673C18.9265 20.3854 19.3854 19.9265 19.673 19.362C20 18.7202 20 17.8802 20 16.2V14.8C20 13.1198 20 12.2798 19.673 11.638C19.3854 11.0735 18.9265 10.6146 18.362 10.327C18.0057 10.1455 17.5883 10.0647 17 10.0288M7 10.0288V8C7 5.23858 9.23858 3 12 3C14.7614 3 17 5.23858 17 8V10.0288"
                                            stroke="#000000"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          ></path>{" "}
                                        </g>
                                      </svg>
                                    ) : (
                                      <AntdTooltip
                                        title={meetingData?.user?.full_name}
                                        placement="top"
                                      >
                                        <Avatar
                                          src={
                                            meetingData?.user?.image.startsWith(
                                              "users/"
                                            )
                                              ? Assets_URL +
                                                "/" +
                                                meetingData?.user?.image
                                              : meetingData?.user?.image
                                          }
                                        />
                                      </AntdTooltip>
                                    )}

                                    <span
                                      className={`badge ms-2 ${
                                        meetingData?.moment_privacy ===
                                        "private"
                                          ? "solution-badge-red"
                                          : meetingData?.moment_privacy ===
                                            "public"
                                          ? "solution-badge-green"
                                          : meetingData?.moment_privacy ===
                                              "enterprise" ||
                                            meetingData?.moment_privacy ===
                                              "participant only" ||
                                            meetingData?.moment_privacy ===
                                              "tektime members"
                                          ? "solution-badge-blue"
                                          : meetingData?.moment_privacy ===
                                            "password"
                                          ? "solution-badge-red"
                                          : "solution-badge-yellow"
                                      }`}
                                      style={{ padding: "3px 8px 3px 8px" }}
                                    >
                                      {meetingData?.moment_privacy === "private"
                                        ? t("solution.badge.private")
                                        : meetingData?.moment_privacy ===
                                          "public"
                                        ? t("solution.badge.public")
                                        : meetingData?.moment_privacy ===
                                          "enterprise"
                                        ? t("solution.badge.enterprise")
                                        : meetingData?.moment_privacy ===
                                          "participant only"
                                        ? t("solution.badge.participantOnly")
                                        : meetingData?.moment_privacy ===
                                          "tektime members"
                                        ? t("solution.badge.membersOnly")
                                        : meetingData?.moment_privacy ===
                                          "password"
                                        ? t("solution.badge.password")
                                        : t("solution.badge.team")}
                                    </span>
                                  </div>
                                  {/* </div> */}
                                </div>
                              </div>

                              <div className="paragraph-parent mt-3 ps-2 ps-md-4 ps-lg-0">
                                <span className="paragraph paragraph-images">
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: meetingData?.description || "",
                                    }}
                                  />
                                </span>
                              </div>
                            </div>

                            <div className="col-md-4 d-flex flex-column gap-3 justify-content-end">
                              <div className="d-flex justify-content-end w-100">
                                <AntdTooltip
                                  title={
                                    !meetingData?.guides?.some(
                                      (item) =>
                                        item?.email ===
                                        sessionStorage.getItem("email")
                                    )
                                      ? t(
                                          "You are not authorized to start this moment"
                                        )
                                      : ""
                                  }
                                >
                                  <div style={{ display: "inline-block" }}>
                                    <Button
                                      className="btn play-btn"
                                      style={{ width: "fit-content" }}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handlePlay(meetingData);
                                      }}
                                      disabled={
                                        !meetingData?.guides?.some(
                                          (item) =>
                                            item?.email ===
                                            sessionStorage.getItem("email")
                                        ) || play
                                      }
                                    >
                                      {meetingData?.type ===
                                      "Google Agenda Event"
                                        ? t("Join the meeting")
                                        : `${t("startMoment")}: ${
                                            meetingData?.solution
                                              ? meetingData?.solution?.title
                                              : meetingData?.type ===
                                                "Prise de contact"
                                              ? "Prise de contact"
                                              : t(`types.${meetingData?.type}`)
                                          }`}
                                      <FaArrowRight
                                        size={12}
                                        style={{
                                          marginLeft: ".5rem",
                                          fontWeight: 700,
                                        }}
                                      />
                                    </Button>
                                  </div>
                                </AntdTooltip>
                              </div>

                              {meetingData?.type === "Newsletter" ? (
                                <Card>
                                  <Card.Body className="d-flex flex-column">
                                    <h4
                                      style={{
                                        fontFamily: "Roboto",
                                        fontSize: "20px",
                                        fontWeight: 600,
                                        lineHeight: "20px",
                                        textAlign: "left",
                                        color: "#344054",
                                      }}
                                    >
                                      {t("Join Now")}
                                    </h4>
                                    <h6
                                      style={{
                                        fontFamily: "Roboto",
                                        fontSize: "14px",
                                        fontWeight: 400,
                                        lineHeight: "16.41px",
                                        textAlign: "left",
                                        color: "#92929D",
                                      }}
                                    >
                                      {t(
                                        "Sign up to be a part of this moment."
                                      )}
                                    </h6>
                                    <div className="subscribe-button mt-2">
                                      <button
                                        className="btn moment-btn w-100"
                                        style={{
                                          padding: "12px 20px 12px 20px",
                                          gap: "8px",
                                          borderRadius: "8px",
                                          background: "#2C48AE",
                                          border: "1px solid #E2E2E2",
                                          color: "white",
                                        }}
                                        onClick={() => handleShowSignUp()}
                                      >
                                        {t("Subscribe")}{" "}
                                      </button>
                                    </div>
                                  </Card.Body>
                                </Card>
                              ) : meetingData?.casting_type ===
                                  "Registration" &&
                                meetingData?.type !== "Newsletter" ? (
                                <Card>
                                  <Card.Body className="d-flex flex-column">
                                    <div className="d-flex align-items-center justify-content-between">
                                      {meetingData?.participants?.some(
                                        (participant) =>
                                          participant.email ===
                                          sessionUser?.email
                                      ) ? null : (
                                        <>
                                          <div className="d-flex flex-column">
                                            <h4
                                              style={{
                                                fontFamily: "Roboto",
                                                fontSize: "20px",
                                                fontWeight: 600,
                                                lineHeight: "20px",
                                                textAlign: "left",
                                                color: "#344054",
                                              }}
                                            >
                                              {t("Register Now")}
                                            </h4>
                                            <h6
                                              style={{
                                                fontFamily: "Roboto",
                                                fontSize: "14px",
                                                fontWeight: 400,
                                                lineHeight: "16.41px",
                                                textAlign: "left",
                                                color: "#92929D",
                                              }}
                                            >
                                              {t(
                                                "Sign up to be a part of this moment."
                                              )}
                                            </h6>
                                          </div>

                                          <div>
                                            {meetingData?.max_participants_register -
                                              meetingData?.participants?.filter(
                                                (item) =>
                                                  item.email !==
                                                  sessionUser?.email
                                              )?.length}{" "}
                                            Remaining
                                          </div>
                                        </>
                                      )}
                                    </div>
                                    <div className="subscribe-button mt-2">
                                      {meetingData?.participants?.some(
                                        (participant) =>
                                          participant.email ===
                                          sessionUser?.email
                                      ) ? (
                                        <button
                                          className="btn moment-btn w-100"
                                          style={{
                                            padding: "12px 20px",
                                            gap: "8px",
                                            borderRadius: "8px",
                                            background: "#2C48AE",
                                            border: "1px solid #E2E2E2",
                                            color: "white",
                                          }}
                                          disabled
                                        >
                                          {t("Already Registered")}
                                        </button>
                                      ) : (
                                        <button
                                          className="btn moment-btn w-100"
                                          style={{
                                            padding: "12px 20px",
                                            gap: "8px",
                                            borderRadius: "8px",
                                            background: "#2C48AE",
                                            border: "1px solid #E2E2E2",
                                            color: "white",
                                          }}
                                          onClick={() =>
                                            handleShowStepperModal()
                                          }
                                        >
                                          {t("Register")}
                                        </button>
                                      )}
                                    </div>
                                  </Card.Body>
                                </Card>
                              ) : null}
                            </div>
                          </div>
                          <div className="cards-section">
                            <div style={{ marginTop: "5rem" }}>
                              <span className="participant-heading">
                                {showHostProfile && (
                                  <IoArrowBackSharp
                                    onClick={hideHostShow}
                                    size={25}
                                    style={{
                                      cursor: "pointer",
                                      marginRight: "1rem",
                                    }}
                                  />
                                )}
                                {meetingData?.guides?.length > 1
                                  ? "Guides"
                                  : "Guide"}
                              </span>
                              <div
                                className="host"
                                style={{
                                  background: showHostProfile && "white",
                                }}
                              >
                                <HostCard
                                  data={meetingData?.user}
                                  guides={meetingData?.guides}
                                  handleShow={handleHostShow}
                                  handleHide={hideHostShow}
                                  showProfile={showHostProfile}
                                  meeting={meetingData}
                                />
                              </div>
                            </div>
                            {/* ------------------------------------------------ Participants */}
                            {isContentBlurred && (
                              <div
                                style={{
                                  filter: isContentBlurred
                                    ? "none"
                                    : "blur(13px)",
                                }}
                              >
                                {meetingData?.type !== "Newsletter" && (
                                  <>
                                    {meetingData?.participants?.filter(
                                      (item) =>
                                        // item.isCreator === 0 &&
                                        !guideEmails.has(item.email)
                                    )?.length > 0 && (
                                      <div style={{ marginTop: "5rem" }}>
                                        <span className="participant-heading">
                                          {showProfile && (
                                            <IoArrowBackSharp
                                              onClick={hideShow}
                                              size={25}
                                              style={{
                                                cursor: "pointer",
                                                marginRight: "1rem",
                                              }}
                                            />
                                          )}
                                          {t("invite")}
                                        </span>
                                        <div className="row">
                                          <div className="col-md-3">
                                            <ParticipantCard />
                                          </div>
                                          <div className="col-md-3">
                                            <ParticipantCard />
                                          </div>
                                          <div className="col-md-3">
                                            <ParticipantCard />
                                          </div>
                                          <div className="col-md-3">
                                            <ParticipantCard />
                                          </div>
                                        </div>

                                        <div
                                          style={{
                                            background: showProfile && "white",
                                          }}
                                          className="participant"
                                        >
                                          <ParticipantCard
                                            data={meetingData?.participants}
                                            guides={meetingData?.guides}
                                            handleShow={handleShow}
                                            handleHide={hideShow}
                                            showProfile={showProfile}
                                            meeting={meetingData}
                                          />
                                        </div>
                                      </div>
                                    )}
                                  </>
                                )}
                              </div>
                            )}

                            {meetingData?.type === "Newsletter" && (
                              <div style={{ marginTop: "5rem" }}>
                                <h4
                                  className={
                                    fromMeeting
                                      ? "participant-heading-meeting"
                                      : "participant-heading"
                                  }
                                >
                                  {t("Abonnés")}
                                </h4>

                                <div
                                  className="participant"
                                  style={{ background: showProfile && "white" }}
                                >
                                  <div style={{ marginTop: "5rem" }}>
                                    <SubscriberCard
                                      subscribers={
                                        meetingData?.newsletter_subscribers
                                      }
                                      data={meetingData?.newsletter_subscribers}
                                      fromMeeting={fromMeeting}
                                      meeting={meetingData}
                                      // handleShow={handleShow1}
                                      // handleHide={hideShow}
                                      showProfile={showProfile}
                                    />
                                  </div>
                                </div>
                              </div>
                            )}

                            {/* ------------------------------------------------ Steps */}

                            <div style={{ marginTop: "5rem" }}>
                              <span className="participant-heading">
                                {`${t("meeting.newMeeting.labels.Program")} `}
                              </span>
                              {/* <StepCard data={meeting?.steps} startTime={formattedTime} users={{ ...meeting?.user, image: meeting?.user?.image || '/Assets/avatar.jpeg' }}  /> */}
                              <ActiveReportStepCard
                                data={meetingData?.steps}
                                startTime={formattedTime}
                                users={{
                                  ...meetingData?.user,
                                  firstName: meetingData?.user?.name,
                                  lastName: meetingData?.user?.last_name,
                                  image:
                                    meetingData?.user?.assigned_to_image ||
                                    meetingData?.user?.image ||
                                    "/Assets/avatar.jpeg",
                                }}
                                meetingId={meetingData?.id}
                                meeting={meetingData}
                              />
                            </div>

                            {meetingData?.meeting_files?.length > 0 && (
                              <div className="cards-section">
                                <div>
                                  <span className="participant-heading">
                                    {`${t("meeting.newMeeting.labels.file")} `}
                                  </span>
                                  <ReportStepFile
                                    data={meetingData?.meeting_files}
                                    startTime={formattedTime}
                                    users={{
                                      ...meetingData?.user,
                                      firstName: meetingData?.user?.name,
                                      lastName: meetingData?.user?.last_name,
                                      image:
                                        meetingData?.user?.assigned_to_image ||
                                        meetingData?.user?.image ||
                                        "/Assets/avatar.jpeg",
                                    }}
                                    meeting1={meetingData?.id}
                                  />
                                </div>
                              </div>
                            )}

                            <div style={{ marginTop: "5rem" }}>
                              <span className="participant-heading">
                                {`${t(
                                  "meeting.newMeeting.labels.discussion"
                                )} `}
                              </span>
                              <MeetingDiscussion
                                meetingId={meetId}
                                messages={meetingMessages}
                                selectedMoment={meetingData}
                                onMessagesUpdate={(newMeetings) =>
                                  setMeetingMessages(newMeetings)
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* SignUp Modal */}
                      <SignUp
                        show={showSignUp}
                        handleClose={handleCloseSignUp}
                        handleShowSignIn={handleShowSignIn}
                        meetingId={meetId}
                        meeting={meetingData}

                      />
                      <StepperSignUpModal
                        show={showStepperModal}
                        handleClose={handleCloseStepperModal}
                        handleShowSignIn={handleShowSignIn}
                        meetingId={meetId}
                        meeting={meetingData}
                        setIsLoggedIn={setIsLoggedIn}
                        refreshData={getMeetingReport}
                        user={sessionUser}
                      />
                      {/* Forgot Password Modal */}
                      <ForgotPassword
                        show={showForgot}
                        handleClose={handleCloseForgot}
                        handleShowForgot={handleShowForgot}
                      />
                    </>
                  )}
                </div>
              ) : (
                <>
                  {/* graph destination */}
                  <div
                    className="email-invite report w-100 "
                    style={{ position: uniqueId ? "static" : "relative" }}
                  >
                    {uniqueId && (
                      <div className="">
                        {destinationDate?.banner ? (
                          <img
                            src={destinationDate?.banner}
                            alt="Destination Banner"
                            style={{
                              width: "100%",
                              height: "338px",
                              objectFit: "cover",
                              filter: "opacity(0.5)",
                            }}
                          />
                        ) : (
                          <div className="gradient-header">
                            <svg
                              width="100%"
                              height="338"
                              viewBox="0 0 1453 338"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g filter="url(#filter0_f_902_7997)">
                                <rect
                                  width="100%"
                                  height="271"
                                  fill="url(#paint0_linear_902_7997)"
                                />
                              </g>
                              <defs>
                                <filter
                                  id="filter0_f_902_7997"
                                  x="-66.5"
                                  y="-66.5"
                                  width="1573"
                                  height="404"
                                  filterUnits="userSpaceOnUse"
                                  colorInterpolationFilters="sRGB"
                                >
                                  <feFloo
                                    floodOpacity="0"
                                    result="BackgroundImageFix"
                                  />
                                  <feBlend
                                    mode="normal"
                                    in="SourceGraphic"
                                    in2="BackgroundImageFix"
                                    result="shape"
                                  />
                                  <feGaussianBlur
                                    stdDeviation="33.25"
                                    result="effect1_foregroundBlur_902_7997"
                                  />
                                </filter>
                                <linearGradient
                                  id="paint0_linear_902_7997"
                                  x1="856"
                                  y1="281.934"
                                  x2="863.131"
                                  y2="-138.913"
                                  gradientUnits="userSpaceOnUse"
                                >
                                  <stop stopColor="white" />
                                  <stop offset="1" stopColor="#76C3EE" />
                                </linearGradient>
                              </defs>
                            </svg>
                          </div>
                        )}
                      </div>
                    )}
                    <div className="participant px-0">
                      <div className="content">
                        <div
                          className="row align-items-center report-row"
                          style={{ minHeight: "35vh" }}
                        >
                          <div className="col-md-10 d-flex flex-column ps-2 mt-5">
                            <h5 className="content-heading fw-bold text-start ps-2 mt-5 mt-md-0">
                              {destinationDate?.destination_name}
                              {/* {destinationDate?.clients[0]?.client_need} */}
                            </h5>

                            <div className="ps-2 content-body mt-3">
                              <div className="d-flex align-items-center gap-2">
                                <>
                                  <img src="/Assets/invite-date.svg" />
                                  <span className="fw-bold formate-date">
                                    {formatMissionDate(
                                      destinationDate?.meeting_start_date
                                    )}
                                    &nbsp; -
                                  </span>
                                  <span className="fw-bold formate-date">
                                    {formatMissionDate(
                                      destinationDate?.meeting_end_date
                                    )}
                                  </span>
                                </>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-2 d-flex justify-content-end d-none d-md-block">
                            <div className="position-relative">
                              {/* <HostCard data={meeting?.user} /> */}
                              <Card
                                className=" host-card graph-tektime-dev-team tektime-dev-team"
                                style={{ top: "-125px" }}
                              >
                                <Card.Body>
                                  <div className="d-flex justify-content-center">
                                    <div className="profile-logo">
                                      <Card.Img
                                        className="avatar-img"
                                        style={{
                                          objectFit: "cover",
                                          objectPosition: "top",
                                        }}
                                        src={
                                          destinationDate?.clients?.client_logo
                                            ? destinationDate?.clients?.client_logo?.startsWith(
                                                "http"
                                              )
                                              ? destinationDate?.clients
                                                  ?.client_logo
                                              : `${Assets_URL}/${destinationDate?.clients?.client_logo}`
                                            : "/Assets/logo2.png" ||
                                              "/Assets/logo2.png"
                                        }
                                      />
                                    </div>
                                  </div>
                                  <Card.Title className="text-center mt-3 card-heading">
                                    {destinationDate?.clients?.name || ""}
                                  </Card.Title>
                                </Card.Body>
                              </Card>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* remove moment-list */}
                      <div className="d-block d-md-none">
                        <Card className="border-0 w-100">
                          <Card.Body>
                            <div className="d-flex justify-content-center">
                              <div className="profile-logo">
                                <Card.Img
                                  className="avatar-img"
                                  style={{
                                    objectFit: "cover",
                                    objectPosition: "top",
                                  }}
                                  src={
                                    destinationDate?.clients?.client_logo
                                      ? destinationDate?.clients?.client_logo?.startsWith(
                                          "http"
                                        )
                                        ? destinationDate?.clients?.client_logo
                                        : `${Assets_URL}/${destinationDate?.clients?.client_logo}`
                                      : "/Assets/logo2.png" ||
                                        "/Assets/logo2.png"
                                  }
                                />
                              </div>
                            </div>

                            <Card.Title className="text-center mt-3 card-heading">
                              {destinationDate?.clients?.name || ""}
                            </Card.Title>
                          </Card.Body>
                        </Card>
                      </div>
                      <div className="row align-items-start moment-list graphpage-margin justify-content-between pt-5 mt-0">
                        <div className="col-lg-7 col-md-7 p-0">
                          {destinationDate?.destination_description &&
                            destinationDate?.destination_description !==
                              "null" && (
                              <div className="paragraph-parent m-1">
                                <p className="paragraph paragraph-images mt-1 p-1">
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html:
                                        destinationDate.destination_description,
                                    }}
                                  />
                                </p>
                              </div>
                            )}

                          <div className="moments-section mt-4">
                            <h2 className="participant-heading mb-3">
                              Moments
                            </h2>
                            <Accordion
                              // defaultActiveKey="0"
                              activeKey={openKeys}
                              className="my-custom-accordion"
                            >
                              {destinationDate?.meetings
                                ?.filter((moment) => moment.status !== "abort")
                                ?.sort(
                                  (a, b) => new Date(a.date) - new Date(b.date)
                                )
                                ?.map((item, index) => {
                                  // const destinationDate = new Date(item?.date);
                                  // // Get individual components of the date
                                  // const desDay = String(
                                  //   destinationDate.getDate()
                                  // ).padStart(2, "0");
                                  // const desMonth = String(
                                  //   destinationDate.getMonth() + 1
                                  // ).padStart(2, "0"); // Months are zero-based
                                  // const desYear = destinationDate.getFullYear();

                                  // // Format the date in dd:mm:yyyy
                                  // const formattedDesDate = `${desDay}/${desMonth}/${desYear}`;

                                  const formattedDesDate =
                                    convertDateToUserTimezone(
                                      item?.date,
                                      item?.starts_at || item?.start_time,
                                      item?.timezone
                                    );

                                  const endTime = specialMeetingEndTime(
                                    item?.start_time,
                                    item?.steps
                                  );
                                  return (
                                    <Accordion.Item
                                      eventKey={index.toString()}
                                      key={item.id}
                                      className="mb-4 shadow "
                                      onClick={() =>
                                        handleToggleAccoridon(index.toString())
                                      }
                                    >
                                      <Accordion.Header className="my-custom-header">
                                        <p className="moment-title graphpage-momenttitle">
                                          {item?.order_no <= 9 ? "0" : " "}
                                          {item?.order_no}
                                          &nbsp;
                                          {item?.type}: &nbsp;{item?.title}{" "}
                                          &nbsp;&nbsp;{" "}
                                          {item?.status === "active" && (
                                            <span
                                              className={`badge ms-2 ${
                                                moment().isAfter(
                                                  moment(
                                                    `${item?.date} ${item?.start_time}`,
                                                    "YYYY-MM-DD HH:mm"
                                                  )
                                                )
                                                  ? "late"
                                                  : "future"
                                              }`}
                                              // style={{ padding: "3px 8px 3px 8px" }}
                                            >
                                              {moment().isAfter(
                                                moment(
                                                  `${item?.date} ${item?.start_time}`,
                                                  "YYYY-MM-DD HH:mm"
                                                )
                                              )
                                                ? t("badge.late")
                                                : t("badge.future")}
                                            </span>
                                          )}
                                          {item?.status === "in_progress" && (
                                            // <span className="mx-2 badge status-badge-inprogress1">
                                            <span
                                              className={`${
                                                item?.steps?.some(
                                                  (moment) =>
                                                    moment?.step_status ===
                                                      "in_progress" &&
                                                    convertTimeTakenToSeconds(
                                                      moment?.time_taken
                                                    ) >
                                                      convertCount2ToSeconds(
                                                        moment?.count2,
                                                        moment?.time_unit
                                                      )
                                                )
                                                  ? "status-badge-red1"
                                                  : "status-badge-inprogress1"
                                              } mx-2 badge h-100`}
                                            >
                                              {t("badge.inprogress")}
                                            </span>
                                          )}
                                          {item?.status === "closed" && (
                                            <span className="mx-2 badge inprogrss">
                                              {t("badge.finished")}
                                            </span>
                                          )}
                                          {item?.status === "abort" && (
                                            <span className="mx-2 badge late">
                                              {t("badge.cancel")}
                                            </span>
                                          )}
                                          {item?.status === "to_finish" && (
                                            <span className="mx-2 badge status-badge-finish">
                                              {t("badge.finish")}
                                            </span>
                                          )}
                                          {item?.status === "todo" && (
                                            <span className="mx-2 badge status-badge-green">
                                              {t("badge.Todo")}
                                            </span>
                                          )}
                                          {item?.status === "in_progress" ||
                                          item?.status === "closed" ? (
                                            <>
                                              <span className="fw-bold formate-date">
                                                <span className="fw-bold formate-date">
                                                  {formattedDesDate}
                                                  &nbsp; {t("at")} &nbsp;
                                                </span>
                                                <>
                                                  {item?.type === "Special" ||
                                                  item?.type === "Law" ? (
                                                    <>{endTime}</>
                                                  ) : (
                                                    <>
                                                      {convertTo12HourFormat(
                                                        item?.starts_at ||
                                                          item?.start_time,
                                                        item?.date,
                                                        item?.steps,
                                                        item?.timezone
                                                      )}
                                                    </>
                                                  )}
                                                </>
                                              </span>
                                            </>
                                          ) : (
                                            <span className="ms-2 fw-bold formate-date">
                                              <span className="fw-bold formate-date">
                                                {formattedDesDate}
                                                &nbsp; {t("at")} &nbsp;
                                              </span>
                                              {convertTo12HourFormat(
                                                item?.start_time,
                                                item?.date,
                                                item?.steps,
                                                item?.timezone
                                              )}
                                            </span>
                                          )}
                                          {/* {start time of the moment} */}
                                          &nbsp;&nbsp;
                                          <span
                                            style={{
                                              color: "#4C49E3",
                                              marginLeft: "5px",
                                              textDecoration: "none",
                                              fontSize: "14px",
                                              fontFamily: "Roboto",
                                              cursor: "pointer",
                                            }}
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setIsModalOpen(false);
                                              setUniqueId((prev) => !prev);
                                              viewPresentation(item);
                                            }}
                                          >
                                            {t("meeting.See More")}
                                          </span>
                                        </p>
                                      </Accordion.Header>
                                      <Accordion.Body>
                                        {/* <p>
                                {moment.description.replace(
                                  /<\/?[^>]+(>|$)/g,
                                  ""
                                )}
                              </p> */}
                                        {/* {moment.description.length > 100 // Set length threshold for truncation
                                  ? `${moment.description
                                      .slice(0, 100)
                                      .replace(/<\/?[^>]+(>|$)/g, "")}...`
                                  : moment.description.replace(
                                      /<\/?[^>]+(>|$)/g,
                                      ""
                                    )} */}
                                        <p
                                          dangerouslySetInnerHTML={{
                                            __html: item?.description?.replace(
                                              /<img /g,
                                              '<img style="width: 100%;" '
                                            ),
                                          }}
                                        ></p>
                                        {/* <p>

                                {
                                  <span
                                    style={{
                                      color: "#4C49E3",
                                      marginLeft: "5px",
                                      textDecoration: "none",
                                      fontSize: "14px",
                                      fontFamily: "Roboto",
                                      cursor: "pointer",
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      viewPresentation(moment);
                                    }}
                                  >
                                    See More
                                  </span>
                                }
                              </p> */}
                                      </Accordion.Body>
                                    </Accordion.Item>
                                  );
                                })}
                            </Accordion>
                          </div>
                        </div>
                        <div className="col-md-5 col-lg-4 p-0">
                          <div className="casting-section">
                            <h2 className="participant-heading mb-5">
                              Casting
                            </h2>
                            <div className="casting-list">
                              <Accordion
                                className="casting-accordian"
                                onSelect={(key) => setActiveEventKey(key)}
                                activeKey={activeEventKey}
                              >
                                {destinationDate?.participant?.map(
                                  (member, index) => (
                                    <Accordion.Item
                                      eventKey={index.toString()}
                                      key={member.id}
                                      className="mb-2"
                                    >
                                      <Accordion.Header className="casting-accordian">
                                        <div className="d-flex align-items-center gap-3 w-100">
                                          <Avatar
                                            src={
                                              member?.participant_image?.startsWith(
                                                "users/"
                                              )
                                                ? Assets_URL +
                                                  "/" +
                                                  member?.participant_image
                                                : member?.participant_image
                                            }
                                            style={{
                                              width: "40px",
                                              height: "40px",
                                              objectPosition: "top",
                                              objectFit: "cover",
                                            }}
                                            className="custom-avatar"
                                          />
                                          <div className="d-flex flex-column gap-2 w-100">
                                            <div className="d-flex align-items-center justify-content-between">
                                              <h5 className="mb-0 casting-member">
                                                {member.full_name}
                                              </h5>

                                              {activeEventKey ===
                                                index.toString() && (
                                                <div
                                                  className="visiting-card-link mt-0"
                                                  //  style={{marginLeft:'25px'}}
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    copyToClipboard(
                                                      member?.user?.nick_name ||
                                                        member?.nick_name
                                                    );
                                                  }}
                                                >
                                                  {t("viewVisitingCard")} &nbsp;{" "}
                                                  <FaArrowRight />
                                                </div>
                                              )}
                                            </div>

                                            <p className="mb-0">
                                              {member.post}
                                            </p>
                                            <p className="mb-0">
                                              {member?.user?.enterprise?.name ||
                                                member?.enterprise?.name}
                                            </p>
                                          </div>
                                        </div>
                                      </Accordion.Header>

                                      <Accordion.Body>
                                        {member?.user?.bio && (
                                          <div>
                                            <h6>
                                              {" "}
                                              {t("profile.inviteProfile.bio")}
                                            </h6>

                                            {member?.user?.bio}
                                          </div>
                                        )}

                                        {member?.meetings?.length > 0 && (
                                          <div>
                                            <div className="table-responsive">
                                              <table
                                                className="table  mt-3"
                                                style={{
                                                  borderCollapse: "separate",
                                                  borderSpacing: 0,
                                                  border: "1px solid #BACBED", // Outer border
                                                }}
                                              >
                                                <thead>
                                                  <tr>
                                                    <th
                                                      style={{
                                                        backgroundColor:
                                                          "aliceblue",
                                                      }}
                                                    >
                                                      {t(
                                                        "time_unit.moment_name"
                                                      )}
                                                    </th>
                                                    <th
                                                      style={{
                                                        backgroundColor:
                                                          "aliceblue",
                                                      }}
                                                    >
                                                      {t(
                                                        "time_unit.moment_delay"
                                                      )}
                                                    </th>
                                                  </tr>
                                                </thead>
                                                <tbody
                                                  style={{
                                                    border: "0 solid white",
                                                  }}
                                                >
                                                  {member?.meetings?.map(
                                                    (item, idx) => (
                                                      <tr key={idx}>
                                                        <td>{item.title}</td>
                                                        <td
                                                          style={{
                                                            color:
                                                              item.status ===
                                                              "in_progress"
                                                                ? item?.steps?.some(
                                                                    (step) =>
                                                                      convertTimeTakenToSeconds(
                                                                        step?.time_taken
                                                                      ) >
                                                                      convertCount2ToSeconds(
                                                                        step?.count2,
                                                                        step?.time_unit
                                                                      )
                                                                  )
                                                                  ? "#FFDB01"
                                                                  : "#FFDB01"
                                                                : item?.status ===
                                                                  "active"
                                                                ? moment().isAfter(
                                                                    moment(
                                                                      `${item.date} ${item.start_time}`,
                                                                      "YYYY-MM-DD HH:mm"
                                                                    )
                                                                  )
                                                                  ? "#F12D2B"
                                                                  : "#4C49E3"
                                                                : item?.status ===
                                                                  "closed"
                                                                ? "#0A8634"
                                                                : "",
                                                          }}
                                                        >
                                                          {item?.status ===
                                                          "in_progress"
                                                            ? calculateTimeDifferencePrepareData(
                                                                item?.steps,
                                                                item?.starts_at,
                                                                item?.current_date,
                                                                t
                                                              )
                                                            : item?.status ===
                                                              "closed"
                                                            ? calculateTotalTimeTaken(
                                                                item?.steps
                                                              )
                                                            : calculateTotalTime(
                                                                item?.steps
                                                              )}
                                                        </td>
                                                      </tr>
                                                    )
                                                  )}
                                                </tbody>
                                              </table>
                                            </div>
                                          </div>
                                        )}
                                      </Accordion.Body>
                                    </Accordion.Item>
                                  )
                                )}
                              </Accordion>
                            </div>
                          </div>
                        </div>
                        <Card className="roadmap-container shadow mt-5">
                          <div>
                            <h4
                              className={`${
                                fromMeeting
                                  ? "participant-heading-meeting"
                                  : "participant-heading"
                              } d-flex align-items-center justify-content-between`}
                            >
                              {view === "graph"
                                ? `${t("time_unit.Roadmap")} `
                                : `${t("time_unit.Calendar")} `}
                              <span style={{ cursor: "pointer" }}>
                                <div className="toggle-button">
                                  <button
                                    className={`toggle-button-option ${
                                      view === "list" ? "active" : ""
                                    }`}
                                    onClick={() => handleToggle("list")}
                                  >
                                    <div className="icon-list" />
                                    <FaRegCalendarDays size={18} />
                                  </button>
                                  <button
                                    className={`toggle-button-option ${
                                      view === "graph" ? "active" : ""
                                    }`}
                                    onClick={() => handleToggle("graph")}
                                  >
                                    <div className="icon-graph" />
                                    <FaChartGantt size={20} />
                                  </button>
                                </div>
                              </span>
                            </h4>

                            <Card.Body>
                              {view === "graph" ? (
                                <>
                                  <Roadmap
                                    loading={loading}
                                    data={roadmapData}
                                    milestones={milestones}
                                    startDate={meetingStartDate}
                                    endDate={meetingEndDate}
                                    onPrevious={() =>
                                      setTimeWindowOffset((prev) => prev - 1)
                                    }
                                    onNext={() =>
                                      setTimeWindowOffset((prev) => prev + 1)
                                    }
                                    onReset={() => setTimeWindowOffset(0)}
                                    from="report"
                                  />
                                </>
                              ) : (
                                <>
                                  <ReactCalendar
                                    meetings={roadmapMeetings}
                                    from="report"
                                  />
                                </>
                              )}
                            </Card.Body>
                          </div>
                        </Card>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </>
          )}
        </>
      )}


                      {showProgressBar1 && (
                             <div className="progress-overlay">
                               <div style={{ width: "50%" }}>
                                 <ProgressBar now={progress1} animated />
                                 <h5 className="text-center my-3">{t("progressBarText")}</h5>
                                 <p
                                   style={{
                                     marginTop: "20px",
                                     textAlign: "center",
                                   }}
                                 >
                                   {t("Saving Audio Report...Don't close this window")},
                                   <a
                                     href="#"
                                     onClick={(e) => {
                                       e.preventDefault(); // Prevent the default anchor behavior
                                       window.open(
                                         `https://tektime.io/meeting`,
                     
                                         "_blank"
                                       ); // Open the current URL in a new tab
                                     }}
                                     style={{
                                       marginLeft: "5px",
                                       color: "#1890ff",
                                       textDecoration: "underline",
                                     }}
                                   >
                                     {t("Click here to view the application in another window")}
                                   </a>
                                 </p>
                               </div>
                             </div>
                           )}
      {/* <p className="feedback-meta">Amanda Smith • an hour ago</p> */}
      {showFeedbackPopup && (
        <div className="feedback-overlay">
          <div
            className="feedback-popup bg-light"
            style={{ width: sessionUser ? "400px" : "520px" }}
          >
            <div className="feedback-card card border-0 bg-light p-1 rounded-0">
              <div className="card-body text-center" style={{ padding: "7px" }}>
                {/* <MdStars className="fs-2 bg-light" /> */}
                {sessionUser ? (
                  <img
                    src={
                      sessionUser?.image?.startsWith("http")
                        ? sessionUser?.image
                        : Assets_URL + "/" + sessionUser?.image
                    } // Or your image path
                    alt="User Avatar"
                    className="rounded-circle" // Makes the avatar circular
                    style={{
                      width: "48px",
                      height: "48px",
                      objectFit: "cover",
                      objectPosition: "top",
                    }} // Adjust size and maintain aspect ratio
                  />
                ) : (
                  <MdStars className="fs-2 bg-light" />
                )}
                <h2 className="feedback-title">{meetingData?.title}</h2>
                <div className="bg-white p-3 rounded-3 mt-3">
                  <p className="feedback-subtitle">
                    {t("How do you rate the time you just spent")}{" "}
                    {estimateDate} à {estimateTime} ?
                  </p>

                  <div className="emoji-container">
                    {emojis?.map((item) => (
                      <OverlayTrigger
                        key={item?.value}
                        placement="top"
                        overlay={(props) => (
                          <BootTooltip id={`tooltip-${item?.value}`} {...props}>
                            {item?.label}
                          </BootTooltip>
                        )}
                      >
                        <div
                          className={`emoji ${
                            rating === item.value ? "selected" : ""
                          }`}
                          onClick={() => setRating(item.value)}
                          style={{ cursor: "pointer" }}
                        >
                          {item.emoji}
                          <span className="emoji-label">{item.value}</span>
                        </div>
                      </OverlayTrigger>
                    ))}
                    <div className="d-flex flex-column align-items-center justify-content-center mt-2">
                      <button
                        className="btn"
                        onClick={onClose}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          padding: "8px 12px",
                          borderRadius: "5px",
                          fontSize: "14px",
                          backgroundColor: "red", // Green if selected, gray otherwise
                          color: "#fff", // White text
                          border: "none",
                        }}
                      >
                        {t("0 Star")}
                      </button>
                    </div>
                    {!sessionUser && (
                      <div className="d-flex flex-column align-items-center justify-content-center mt-2">
                        <button
                          className="btn"
                          onClick={onClose}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            padding: "8px 12px",
                            borderRadius: "5px",
                            fontSize: "14px",
                            backgroundColor: "#28a745", // Green if selected, gray otherwise
                            color: "#fff", // White text
                            border: "none",
                          }}
                        >
                          {t("Already Answered")}
                        </button>
                      </div>
                    )}
                  </div>
                  {!sessionUser && (
                    <input
                      type="text"
                      className="form-control mb-2"
                      placeholder={t("Write your name here")}
                      value={userName}
                      onChange={(e) => setUserName(e.target.value)}
                    />
                  )}

                  <textarea
                    className="form-control shadow-none"
                    placeholder={t("Write your feedback here")}
                    value={feedback}
                    onChange={(e) => setFeedback(e.target.value)}
                  />
                  <label className="toggle-container">
                    <input
                      type="checkbox"
                      checked={anonymous}
                      onChange={() => setAnonymous(!anonymous)}
                    />
                    <span className="toggle-slider"></span>
                    <span className="toggle-label">{t("Anonymous")}</span>
                  </label>
                  <button
                    className="feedback-button"
                    disabled={submit}
                    onClick={handleFeedbackSubmit}
                  >
                    {t("Send my feedback")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {isModalOpen && (
        <div className="confirmation-modal">
          <div className="confirmation-modal-content">
            <p>{localizeVisibilityMessage(visibilityMessage, t)}</p>
            {visibilityMessage === "Please log in to view meeting." ? (
              <button className="btn btn-primary" onClick={handleLogin}>
                Login
              </button>
            ) : visibilityMessage ===
              "Please enter password to view meeting." ? (
              <div className="d-flex flex-column gap-2">
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      checkPassword();
                    }
                  }}
                />
                <button className="btn btn-primary" onClick={checkPassword}>
                  Submit
                </button>
              </div>
            ) : null}
            {!window.location.href.includes("destination") && (
              <button className="btn-no" onClick={handleClose}>
                {t("confirmationModal.close")}
              </button>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Report;
